import { socket,
    CONV_STORAGE,
    room,
    conversationTooltipTimeout,
    deviceManager,
    stopMediaPlayers,//card 556
    chat,
    localRecording,
    unload,
    disablePrivacyModeBtn,
    kinoTimer,
    live_stream,
    lockFocus,
    muteParticipants,
    kinoLimits,
    isJoined,
    convertPath,
    electronConfig,
    isElectron,
    lobby,
    muteMic,
    unMuteMic,
    unMuteCamera,
    cameraOptionsPreferences,
    animatedLayers,
    kinoParticipants,
    volumeManager,
    onStage,
    spacesView,
    hideSideMenu,
    hideParticipantsList,
    kinoControls,
    muteAll,
    screenShare,
    pictureInPicture,
    isMicMuted,
    toggleMic,
    permissions,
    renderKinoMenu,
    Video
    } from './roomnew';
import axios from 'axios'
import Efss from './efss';
// import KinoSound from './sounds.js';//uncomment on electron
import Speaker from './speaker';
import Announcement from './announcement';
import Presenter from '../room/presenter';
import StealFocus from '../room/steal-focus';
import SplitConversations from '../room/split-conversations';
import MinimizedContent from '../room/MinimizedContent';
import Participant from '../room/participant/Participant';
import LockMasterVolume from '../room/LockMasterVolume';
// import VideoBackgroundBlur from '../features/blurred-background/VideoBackgroundBlur';
import tippy from 'tippy.js';
import {hideAll} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { getLocalMainKinoTrack, getRemoteParticipantMainKinoTrack, getRemoteParticipantMainVideoTrack, removeMutedLocalVideoTrack } from '../features/base/tracks/functions';
import { MEDIA_TYPE, STREAMING_STATUS } from '../features/base/tracks/constants';
import { updateVideoQuality } from '../features/base/video-quality/actions';
import { removeScreenshareLayer } from '../features/base/tracks/events';
import { isEndpointVisible, showCameraLayerWhenAppMinimized } from '../features/base/video-quality/functions';
import { onResizeScreen } from '../features/screen-share/ScreenshareUI';
import { renderChatsList } from '../features/chat/chatsList';

export default class Videos {
    constructor (){
        this.user_id = USER_ID;
        this.guest_id = GUEST_ID;
        this.videoSpace = $('#videoSpace');
        this.remoteVideos = $('#remoteVideos');
        this.remoteVideosContainer = $('#remoteVideosContainer');
        this.sideVideos = $('#sideVideos');
        this.localVideoContainer = $('#localVideoContainer');
        this.sideVideosContainer = $('#sideVideosContainer');
        this.notifications = $('#notificationsBanner');
        this.isFocused = false;
        this.isTileView = false;
        this.isLocalMaximized = true;
        this.videos = {};
        this.onConversation = {};
        this.initialVolume = {};
        this.videoRatio = 16 / 9;
        this.videoMinWidth = 300;
        this.videoMinHeight = Math.ceil(this.videoMaxWidth / this.videoRatio);
        this.containerMaxVideos = 2;
        this.mobileMenuOptions = $('#mobileMenuOptions');
        this.maxColumns = 2;
        this.maxRows = 1;
        this.participantCount = 1;
        this.pipMode = false;
        this.isSharingScreen = false;
        this.reconnectTimeout = 0;
        this.chatBubbles = [];
        this.sounds = new KinoSound();
        this.chatMessageReceivedTimeout = []
        this.chatMessageReceivedShowItemsTimeout = []
        this.chatMessageReceivedCloseItemsTimeout = []
        this.recordedBy = {};
        this.myConversation={id:null,participants:[]};
        // this.minimizeIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m448 0h-384c-35.285156 0-64 28.714844-64 64v384c0 35.285156 28.714844 64 64 64h384c35.285156 0 64-28.714844 64-64v-384c0-35.285156-28.714844-64-64-64zm21.332031 448c0 11.777344-9.554687 21.332031-21.332031 21.332031h-256v-117.332031c0-17.664062-14.335938-32-32-32h-117.332031v-256c0-11.777344 9.554687-21.332031 21.332031-21.332031h384c11.777344 0 21.332031 9.554687 21.332031 21.332031zm0 0" fill="#e0e4e5" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m420.414062 91.585938c-8.339843-8.34375-21.820312-8.34375-30.164062 0l-91.582031 91.582031-48.917969-48.917969c-6.101562-6.101562-15.273438-7.933594-23.253906-4.628906-7.980469 3.285156-13.164063 11.09375-13.164063 19.710937v128c0 11.796875 9.539063 21.335938 21.335938 21.335938h128c8.617187 0 16.425781-5.183594 19.710937-13.164063 3.304688-7.980468 1.472656-17.152344-4.628906-23.253906l-48.917969-48.917969 91.582031-91.582031c8.34375-8.34375 8.34375-21.824219 0-30.164062zm0 0" fill="#e0e4e5" data-original="#000000" style="" class=""/></g></svg>`;
        // this.maximizeIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m448 0h-384c-35.285156 0-64 28.714844-64 64v384c0 35.285156 28.714844 64 64 64h384c35.285156 0 64-28.714844 64-64v-384c0-35.285156-28.714844-64-64-64zm21.332031 448c0 11.777344-9.554687 21.332031-21.332031 21.332031h-256v-117.332031c0-17.664062-14.335938-32-32-32h-117.332031v-256c0-11.777344 9.554687-21.332031 21.332031-21.332031h384c11.777344 0 21.332031 9.554687 21.332031 21.332031zm0 0" fill="#e0e4e5" data-original="#000000" style="" class=""/><path xmlns="http://www.w3.org/2000/svg" d="m405.332031 85.332031h-128c-8.617187 0-16.425781 5.183594-19.710937 13.164063-3.304688 7.980468-1.472656 17.152344 4.628906 23.253906l48.917969 48.917969-91.582031 91.582031c-8.34375 8.34375-8.34375 21.824219 0 30.164062 4.15625 4.160157 9.621093 6.253907 15.082031 6.253907 5.460937 0 10.921875-2.09375 15.082031-6.253907l91.582031-91.582031 48.917969 48.917969c4.074219 4.074219 9.535156 6.25 15.082031 6.25 2.753907 0 5.527344-.511719 8.171875-1.621094 7.980469-3.285156 13.164063-11.09375 13.164063-19.710937v-128c0-11.796875-9.539063-21.335938-21.335938-21.335938zm0 0" fill="#e0e4e5" data-original="#000000" style="" class=""/></g></svg>`;
        this.minimizeIcon = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="512" height="512" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g id="Layer_2" data-name="Layer 2"><path d="M25.28,1H6.72A5.73,5.73,0,0,0,1,6.72V25.28A5.73,5.73,0,0,0,6.72,31H25.28A5.73,5.73,0,0,0,31,25.28V6.72A5.73,5.73,0,0,0,25.28,1ZM29,25.28A3.73,3.73,0,0,1,25.28,29H6.72A3.73,3.73,0,0,1,3,25.28V6.72A3.73,3.73,0,0,1,6.72,3H25.28A3.73,3.73,0,0,1,29,6.72Z" ></path><path d="M20.54,19.14H24.3a1,1,0,0,0,0-2H17.84a.7.7,0,0,0-.7.7V24.3a1,1,0,0,0,2,0V20.56L25,26.43A1,1,0,1,0,26.42,25Z" ></path><path d="M13.87,6.71a1,1,0,0,0-1,1v3.76L7,5.57a1,1,0,0,0-1.41,0h0A1,1,0,0,0,5.56,7l5.89,5.89H7.71a1,1,0,1,0,0,2h6.46a.7.7,0,0,0,.7-.7V7.71A1,1,0,0,0,13.87,6.71Z" ></path></g></g></svg>`;
        this.maximizeIcon=`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="512" height="512" x="0" y="0" viewBox="0 0 8.4666665 8.4666669" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g id="layer1"><path id="path3478" d="m7.0058594 2c-2.7527021 0-5.0058594 2.2453414-5.0058594 4.9980469v17.9960941c0 2.752701 2.2531573 5.005859 5.0058594 5.005859h17.9960936c2.752702 0 4.998047-2.253158 4.998047-5.005859v-17.9960941c0-2.7527055-2.245345-4.9980469-4.998047-4.9980469zm0 2h17.9960936c1.679298 0 2.998047 1.3187499 2.998047 2.9980469v17.9960941c0 1.679297-1.318749 3.005859-2.998047 3.005859h-17.9960936c-1.6792982-.000004-3.0058594-1.326562-3.0058594-3.005859v-17.9960941c0-1.679297 1.3265612-2.9980469 3.0058594-2.9980469zm12.0175786 2.984375c-.529733.0121-.958073.4352958-.976563.9648438-.01979.5509428.410048 1.0139762.960937 1.0351562l2.482422.083984-4.195312 4.2695316c-.389822.39419-.384566 1.030274.01172 1.417968.394807.386142 1.027883.379142 1.414062-.01563l4.167969-4.238281.08008 2.443359c.02119.550102.48301.979624 1.033203.960938.550847-.01805.983239-.4784.966797-1.029297l-.162112-4.7656195c0-.64912-.315046-.9648437-.964844-.9648437-1.604429-.05457-3.21781-.1103174-4.818359-.1621094zm-5.72461 10.349609-4.1835936 4.183594-.080078-2.466797c-.02119-.550102-.4830101-.979623-1.0332031-.960937-.550847.01805-.9832387.4784-.9667969 1.029297l.1621094 4.765625c0 .60806.4130288.964843.9648438.964843l4.7656246.16211c.55016.01646 1.010193-.414769 1.029297-.964844.01979-.550943-.410046-1.013976-.960937-1.035156l-2.464844-.08203 4.181641-4.181641c.416679-.416679.382865-1.023334 0-1.419922-.410342-.410342-1.017262-.390942-1.414063.0059z" transform="scale(.265)" font-variant-ligatures="normal" font-variant-position="normal" font-variant-caps="normal" font-variant-numeric="normal" font-variant-alternates="normal" font-variant-east-asian="normal" font-feature-settings="normal" font-variation-settings="normal" text-indent="0" text-align="start" text-decoration-line="none" text-decoration-style="solid" text-decoration-color="rgb(0,0,0)" text-transform="none" text-orientation="mixed" white-space="normal" shape-padding="0" shape-margin="0" inline-size="0" isolation="auto" mix-blend-mode="normal" solid-color="rgb(0,0,0)" solid-opacity="1" vector-effect="none" paint-order="stroke fill markers"></path></g></g></svg>`;
        this.kickIcon = `<svg width="48px" height="48px" viewBox="0 0 48 48"><g id="kick"><g id="kick"><path d="M0 0L48 0L48 48L0 48L0 0L0 0Z" id="Background" fill="none" stroke="none" /><path d="M31 38C31 40.209 29.209 42 27 42L4 42C1.791 42 0 40.209 0 38L0 4C0 1.791 1.791 0 4 0L27 0C29.209 0 31 1.791 31 4L31 38L31 38L31 38Z" transform="translate(6 3)" id="Shape" fill="#E0E4E5" stroke="none" /><path d="M12 10L0 20L0 0L12 10L12 10Z" transform="translate(29 14)" id="Shape" fill="#455A64" stroke="none" /><path d="M0 0L17 0L17 6L0 6L0 0L0 0Z" transform="translate(14 21)" id="Shape" fill="#455A64" stroke="none" /></g></g></svg>`;
        this.showTheDoorIcon=`<svg style="margin-left:4px;" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="512" height="512" x="0" y="0" viewBox="0 0 512.00533 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="m320 277.335938c-11.796875 0-21.332031 9.558593-21.332031 21.332031v85.335937c0 11.753906-9.558594 21.332032-21.335938 21.332032h-64v-320c0-18.21875-11.605469-34.496094-29.054687-40.554688l-6.316406-2.113281h99.371093c11.777344 0 21.335938 9.578125 21.335938 21.335937v64c0 11.773438 9.535156 21.332032 21.332031 21.332032s21.332031-9.558594 21.332031-21.332032v-64c0-35.285156-28.714843-63.99999975-64-63.99999975h-229.332031c-.8125 0-1.492188.36328175-2.28125.46874975-1.027344-.085937-2.007812-.46874975-3.050781-.46874975-23.53125 0-42.667969 19.13281275-42.667969 42.66406275v384c0 18.21875 11.605469 34.496093 29.054688 40.554687l128.386718 42.796875c4.351563 1.34375 8.679688 1.984375 13.226563 1.984375 23.53125 0 42.664062-19.136718 42.664062-42.667968v-21.332032h64c35.285157 0 64-28.714844 64-64v-85.335937c0-11.773438-9.535156-21.332031-21.332031-21.332031zm0 0" fill="#000000" data-original="#000000" class=""></path><path d="m505.75 198.253906-85.335938-85.332031c-6.097656-6.101563-15.273437-7.9375-23.25-4.632813-7.957031 3.308594-13.164062 11.09375-13.164062 19.714844v64h-85.332031c-11.777344 0-21.335938 9.554688-21.335938 21.332032 0 11.777343 9.558594 21.332031 21.335938 21.332031h85.332031v64c0 8.621093 5.207031 16.40625 13.164062 19.714843 7.976563 3.304688 17.152344 1.46875 23.25-4.628906l85.335938-85.335937c8.339844-8.339844 8.339844-21.824219 0-30.164063zm0 0" fill="#000000" data-original="#000000" class=""></path></g></svg>`;
        // make moderator Icon
        this.makeModeratorIcon = `<svg width="48px" height="48px" viewBox="0 0 640 512"><g id="make-moderator"><path fill="#67bd6e" d="M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"class=""></path></g></svg>`;
        this.waveIcon = `<svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg"><rect fill="none" height="256" width="256"></rect><path d="M220.2,104l-20-34.7a28.1,28.1,0,0,0-47.3-1.9l-17.3-30A28.1,28.1,0,0,0,97.3,27.1a29.4,29.4,0,0,0-9.9,9.6,27.9,27.9,0,0,0-11.5-6.2,27.1,27.1,0,0,0-21.2,2.8A27.9,27.9,0,0,0,44.4,71.5l3.4,5.8A28.5,28.5,0,0,0,36,81a28.1,28.1,0,0,0-10.2,38.2l42,72.8a88,88,0,1,0,152.4-88Zm-6.7,62.6A71.2,71.2,0,0,1,180,210.3,72.1,72.1,0,0,1,81.6,184l-42-72.8a12,12,0,0,1,20.8-12l22,38.1a8,8,0,1,0,13.9-8l-22-38.1h0l-16-27.7a12,12,0,0,1-1.2-9.1,11.8,11.8,0,0,1,5.6-7.3,12,12,0,0,1,9.1-1.2,12.5,12.5,0,0,1,7.3,5.6L87,65.4h.1l26,45a7.7,7.7,0,0,0,6.9,4,7.3,7.3,0,0,0,4-1.1,8,8,0,0,0,2.9-10.9l-26-45h0a12,12,0,1,1,20.8-12l30,51.9h0l6.3,11a48.1,48.1,0,0,0-10.9,61,8,8,0,0,0,13.8-8,32,32,0,0,1,11.7-43.7,8.1,8.1,0,0,0,3.8-4.9,8.4,8.4,0,0,0-.8-6l-10-17.4a12,12,0,0,1,13.5-17.5,11.8,11.8,0,0,1,7.2,5.5l20,34.7A70.9,70.9,0,0,1,213.5,166.6Zm-125.8,78a8.2,8.2,0,0,1-6.6,3.4,8.6,8.6,0,0,1-4.6-1.4A117.9,117.9,0,0,1,41.1,208a8,8,0,1,1,13.8-8,102.6,102.6,0,0,0,30.8,33.4A8.1,8.1,0,0,1,87.7,244.6ZM168,31a8,8,0,0,1,8-8h0a60.2,60.2,0,0,1,52,30,7.9,7.9,0,0,1-3,10.9,7.1,7.1,0,0,1-4,1.1,8,8,0,0,1-6.9-4A44,44,0,0,0,176,39,8,8,0,0,1,168,31Z"></path></svg>`;
        this.focusIcon = `<svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><g id="focus"><path d="M0 0L48 0L48 48L0 48L0 0Z" id="Background" fill="none" stroke="none" /><path d="M0 18C0 27.9 8.1 36 18 36C27.9 36 36 27.9 36 18C36 8.1 27.9 0 18 0C8.1 0 0 8.1 0 18ZM4 18C4 10.3 10.3 4 18 4C25.7 4 32 10.3 32 18C32 25.7 25.7 32 18 32C10.3 32 4 25.7 4 18Z" transform="translate(6 6)" id="Shape" fill="#E0E4E5" fill-rule="evenodd" stroke="none" /><path d="M19 0L23 0L23 10L19 10L19 0ZM0 19L10 19L10 23L0 23L0 19ZM42 19L32 19L32 23L42 23L42 19ZM23 32L19 32L19 42L23 42L23 32Z" transform="translate(3 3)" id="Shape" fill="#78909C" fill-rule="evenodd" stroke="none" /><path d="M12 6C12 9.3 9.3 12 6 12C2.7 12 0 9.3 0 6C0 2.7 2.7 0 6 0C9.3 0 12 2.7 12 6L12 6Z" transform="translate(18 18)" id="Shape" fill="#E0E4E5" stroke="none" /></g></svg>`;
        this.focusedIcon = `<svg width="48px" height="48px" viewBox="0 0 48 48"><g id="focused"><path d="M0 0L48 0L48 48L0 48L0 0Z" id="Background" fill="none" stroke="none" /><path d="M0 18C0 27.9 8.1 36 18 36C27.9 36 36 27.9 36 18C36 8.1 27.9 0 18 0C8.1 0 0 8.1 0 18ZM4 18C4 10.3 10.3 4 18 4C25.7 4 32 10.3 32 18C32 25.7 25.7 32 18 32C10.3 32 4 25.7 4 18Z" transform="translate(6 6)" id="Shape" fill="#04AE1F" fill-rule="evenodd" stroke="none" /><path d="M19 0L23 0L23 10L19 10L19 0ZM0 19L10 19L10 23L0 23L0 19ZM42 19L32 19L32 23L42 23L42 19ZM23 32L19 32L19 42L23 42L23 32Z" transform="translate(3 3)" id="Shape" fill="#FFFFFF" fill-rule="evenodd" stroke="none" /><path d="M12 6C12 9.3 9.3 12 6 12C2.7 12 0 9.3 0 6C0 2.7 2.7 0 6 0C9.3 0 12 2.7 12 6L12 6Z" transform="translate(18 18)" id="Shape" fill="#44B907" stroke="none" /></g></svg>`;
        this.conversationIcon = `<svg width="48px" height="48px" viewBox="0 0 48 48" ><g id="group"><g id="group"><path d="M0 0L48 0L48 48L0 48L0 0L0 0Z" id="Background" fill="none" stroke="none" /><path d="M5 10C2.237 10 0 7.762 0 5C0 2.238 2.237 0 5 0C7.761 0 10 2.238 10 5C10 7.762 7.761 10 5 10" transform="translate(7 15)" id="Shape" fill="#FFA726" stroke="none" /><path d="M0.03 6.104C0.03 6.104 2.768 0 10 0C17.231 0 20.03 6.104 20.03 6.104L20 10L0 10L0.03 6.104ZM44 6C44 6 41.231 0 34 0C26.768 0 24 6 24 6L24 10L44 10L44 6Z" transform="translate(2 27)" id="Shape" fill="#455A64" fill-rule="evenodd" stroke="none" /><path d="M18 6C18 9.315 15.314 12 12 12C8.686 12 6 9.315 6 6C6 2.685 8.686 0 12 0C15.313 0 18 2.686 18 6ZM24 22C24 22 20.614 15.054 11.935 15.054C3.256 15.054 0 22 0 22L0 27L24 27L24 22Z" transform="translate(12 10)" id="Shape" fill="#E0E4E5" fill-rule="evenodd" stroke="none" /><path d="M5 10C7.762 10 10 7.762 10 5C10 2.238 7.762 0 5 0C2.238 0 0 2.238 0 5C0 7.762 2.238 10 5 10" transform="translate(31 15)" id="Shape" fill="#FFA726" stroke="none" /><path d="M5 10C2.237 10 0 7.762 0 5C0 2.238 2.237 0 5 0C7.761 0 10 2.238 10 5C10 7.762 7.761 10 5 10ZM29 10C31.762 10 34 7.762 34 5C34 2.238 31.762 0 29 0C26.238 0 24 2.238 24 5C24 7.762 26.238 10 29 10Z" transform="translate(7 15)" id="Shape" fill="#78909C" fill-rule="evenodd" stroke="none" /></g></g></svg>`;
        //bamirs: recording icon
        this.recIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53"><g transform="translate(-257.5 -1012.5)"><path d="M33,8a24.991,24.991,0,1,0,14.565,4.677A24.678,24.678,0,0,0,33,8Z" transform="translate(251 1006)" fill="none" stroke="#c51a05" stroke-width="3"/><path d="M22.944,8A14.944,14.944,0,1,0,37.889,22.944,14.942,14.942,0,0,0,22.944,8Z" transform="translate(261 1016.111)" fill="#c51a05"/></g></svg>`;
        this.optionsIcon=`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="512" height="512" x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><circle cx="12" cy="12" r="2" fill="#ffffff" data-original="#000000" class=""></circle><circle cx="4" cy="12" r="2" fill="#ffffff" data-original="#000000" class=""></circle><circle cx="20" cy="12" r="2" fill="#ffffff" data-original="#000000" class=""></circle></g></svg>`;
        this.focused = {};
        this.localVideo = {};
        this.toggleDisabled = false;
        this.sideParticipants = {};
        this.mainParticipants = {};
        this.mouseNotMoving = 0;
        // this.toggleTileView = $('#toggleTileView');
        this.toolBox = $('#tool-box');
        this.toolEventsArea = $('#toolEventsArea');
        this.toolBoxTimeout = 0;
        this.toolBoxShown = true;
        this.sideVideosShown = true;
        this.masterAudioMute = $('#audioMasterVolume');
        this.masterVolumeSlider = null;
        this.raiseHand = $('#raiseHand');
        this.raiseHandFocused = $('#raiseHandFocused');
        this.windowFullScreenBtn = $('#windowFullScreen');
        this.participantsListMenu = $('#participants-list-menu');
        this.searchParticipantInput = $("#participant_search_name");
        this.masterMuted = false;
        this.members = new Array();
        this.isDragging = false;
        this.mousePosition = {
            x: 0,
            y: 0,
        };
        this.window = {
            width: 0,
            height: 0,
        };

        this.volumeIcon=`<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M3 10.0001V14.0001C3 14.5501 3.45 15.0001 4 15.0001H7L10.29 18.2901C10.92 18.9201 12 18.4701 12 17.5801V6.41008C12 5.52008 10.92 5.07008 10.29 5.70008L7 9.00008H4C3.45 9.00008 3 9.45008 3 10.0001ZM16.5 12.0001C16.5 10.2301 15.48 8.71008 14 7.97008V16.0201C15.48 15.2901 16.5 13.7701 16.5 12.0001ZM14 4.45008V4.65009C14 5.03009 14.25 5.36009 14.6 5.50009C17.18 6.53009 19 9.06008 19 12.0001C19 14.9401 17.18 17.4701 14.6 18.5001C14.24 18.6401 14 18.9701 14 19.3501V19.5501C14 20.1801 14.63 20.6201 15.21 20.4001C18.6 19.1101 21 15.8401 21 12.0001C21 8.16008 18.6 4.89008 15.21 3.60009C14.63 3.37009 14 3.82008 14 4.45008Z" fill="white"/></svg>`;
        this.volumeIconMuted=`<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.63 3.62844C3.24 4.01844 3.24 4.64844 3.63 5.03844L7.29 8.69844L7 8.99844H4C3.45 8.99844 3 9.44844 3 9.99844V13.9984C3 14.5484 3.45 14.9984 4 14.9984H7L10.29 18.2884C10.92 18.9184 12 18.4684 12 17.5784V13.4084L16.18 17.5884C15.69 17.9584 15.16 18.2684 14.58 18.4984C14.22 18.6484 14 19.0284 14 19.4184C14 20.1384 14.73 20.5984 15.39 20.3284C16.19 19.9984 16.94 19.5584 17.61 19.0184L18.95 20.3584C19.34 20.7484 19.97 20.7484 20.36 20.3584C20.75 19.9684 20.75 19.3384 20.36 18.9484L5.05 3.62844C4.66 3.23844 4.03 3.23844 3.63 3.62844ZM19 11.9984C19 12.8184 18.85 13.6084 18.59 14.3384L20.12 15.8684C20.68 14.6984 21 13.3884 21 11.9984C21 8.16844 18.6 4.88844 15.22 3.59844C14.63 3.36844 14 3.82844 14 4.45844V4.64844C14 5.02844 14.25 5.35844 14.61 5.49844C17.18 6.53844 19 9.05844 19 11.9984ZM10.29 5.70844L10.12 5.87844L12 7.75844V6.40844C12 5.51844 10.92 5.07844 10.29 5.70844ZM16.5 11.9984C16.5 10.2284 15.48 8.70844 14 7.96844V9.75844L16.48 12.2384C16.49 12.1584 16.5 12.0784 16.5 11.9984Z" fill="#FF4747"/><path d="M4.36847 4.362L12.9509 12.9426L19.6261 19.6163" stroke="white" stroke-width="2.1" stroke-linecap="round"/></svg>`;
        this.volumeHalfIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M18.5 12.0003C18.5 10.2303 17.48 8.71026 16 7.97026V16.0203C17.48 15.2903 18.5 13.7703 18.5 12.0003ZM5 10.0003V14.0003C5 14.5503 5.45 15.0003 6 15.0003H9L12.29 18.2903C12.92 18.9203 14 18.4703 14 17.5803V6.41026C14 5.52026 12.92 5.07026 12.29 5.70026L9 9.00026H6C5.45 9.00026 5 9.45026 5 10.0003Z" fill="white"/></svg>`;
        this.micMutedIcon = `<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M265.403 88.2228C264.31 53.2236 235.217 25.0055 199.999 25.0055C163.906 25.0055 134.375 54.536 134.375 90.6289V200.001C134.375 205.907 135.25 211.376 136.781 216.845L265.403 88.2228Z" fill="#FF3D00"/>
        <path d="M199.999 265.625C236.092 265.625 265.622 236.094 265.622 200.001V149.843L371.801 43.6644C376.066 39.3989 376.066 32.4647 371.801 28.1991C367.535 23.9336 360.601 23.9336 356.336 28.1991L28.2183 356.316C23.9309 360.582 23.9309 367.516 28.1964 371.782C32.4619 376.069 39.3743 376.069 43.6617 371.804L131.335 284.131C147.565 297.19 167.253 306.049 189.061 308.28V364.06C189.061 370.185 193.874 374.997 199.999 374.997C206.123 374.997 210.936 370.185 210.936 364.06V308.28C266.06 302.593 309.371 256.656 309.371 200.001V189.064C309.371 182.939 304.559 178.127 298.434 178.127C292.309 178.127 287.497 182.939 287.497 189.064V200.001C287.497 248.344 248.341 287.499 199.999 287.499C179.874 287.499 161.5 280.324 146.603 268.862L162.112 253.353C172.852 260.987 185.977 265.625 199.999 265.625V265.625Z" fill="#FF3D00"/>
        <path d="M119.501 234.126C114.907 223.626 112.501 212.032 112.501 200.001V189.064C112.501 182.939 107.688 178.127 101.563 178.127C95.4386 178.127 90.6262 182.939 90.6262 189.064V200.001C90.6262 218.376 95.2199 235.438 103.095 250.531L119.501 234.126Z" fill="#FF3D00"/>
        </svg>`;
        this.muteUserIcon=`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 435.2 435.2" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path style="fill:red !imporant" d="M356.864 224.768c0-8.704-6.656-15.36-15.36-15.36s-15.36 6.656-15.36 15.36c0 59.904-48.64 108.544-108.544 108.544-59.904 0-108.544-48.64-108.544-108.544 0-8.704-6.656-15.36-15.36-15.36s-15.36 6.656-15.36 15.36c0 71.168 53.248 131.072 123.904 138.752v40.96h-55.808c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36h142.336c8.704 0 15.36-6.656 15.36-15.36s-6.656-15.36-15.36-15.36H232.96v-40.96c70.656-7.68 123.904-67.584 123.904-138.752z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path style="fill: red !imporant" d="M217.6 0c-47.104 0-85.504 38.4-85.504 85.504v138.752c0 47.616 38.4 85.504 85.504 86.016 47.104 0 85.504-38.4 85.504-85.504V85.504C303.104 38.4 264.704 0 217.6 0z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg>
        `;
        this.cameraIcon = `<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M369.816 113.65C366.622 111.648 362.553 111.45 359.184 113.166L287.5 149.202V123C287.5 104.806 272.778 90 254.688 90H57.8125C39.7219 90 25 104.806 25 123V277C25 295.194 39.7219 310 57.8125 310H254.688C272.778 310 287.5 295.194 287.5 277V250.798L359.163 286.834C362.531 288.528 366.556 288.374 369.794 286.35C373.031 284.348 375 280.806 375 277V123C375 119.194 373.031 115.652 369.816 113.65V113.65Z" fill="white"/></svg>`;
        this.cameraMutedIcon = `<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M46.4372 307.202L262.121 91.5075C259.715 90.8513 257.309 90.6325 254.684 90.6325H57.812C39.656 90.6325 25 105.289 25 123.446V276.576C25 290.795 33.9686 302.827 46.4372 307.202Z" fill="#FF3D00"/><path d="M359.245 113.602L287.496 149.478V127.974L371.801 43.6654C376.066 39.3997 376.066 32.4651 371.801 28.1993C367.535 23.9336 360.601 23.9336 356.335 28.1993L28.2156 356.335C23.95 360.6 23.95 367.535 28.2156 371.801C32.4811 376.066 39.4154 376.066 43.6809 371.801L106.089 309.389H254.684C272.84 309.389 287.496 294.733 287.496 276.576V250.544L359.245 286.42C363.292 288.148 367.032 287.689 369.745 285.982C373.026 283.795 374.995 280.295 374.995 276.576V123.446C374.995 119.727 373.026 116.227 369.745 114.04C366.682 112.071 362.526 111.852 359.245 113.602V113.602Z" fill="#FF3D00"/></svg>`;
        this.noCameraIcon=`<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M9.56 8l-2-2-4.15-4.14L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.55-.18L19.73 21l1.41-1.41-8.86-8.86L9.56 8zM5 16V8h1.73l8 8H5zm10-8v2.61l6 6V6.5l-4 4V7c0-.55-.45-1-1-1h-5.61l2 2H15z"/></svg>`;
        this.focusViewIcon = `<svg width="30px" height="30px" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg" class="change-view-icon"><g id="focusedView"><rect id="sideBox1" style="--order:1" x="80" y="5" width="30" height="26" rx="5" fill="#CFD8DC"/><path id="sideBox2" style="--order:2" d="M80 42C80 39.2386 82.2386 37 85 37H105C107.761 37 110 39.2386 110 42V58C110 60.7614 107.761 63 105 63H85C82.2386 63 80 60.7614 80 58V42Z" fill="#CFD8DC"/><rect id="sideBox3" style="--order:3" x="80" y="69" width="30" height="26" rx="5" fill="#CFD8DC"/><rect id="focusedBox" x="8" y="5" width="64" height="90" rx="5" fill="#CFD8DC"/></g></svg>`;
        this.tileViewIcon = `<svg width="30px" height="30px" viewBox="0 0 48 48" class="change-view-icon"><g id="grid"><path d="M0 0L48 0L48 48L0 48L0 0Z" id="Background" fill="none" stroke="none"></path><path d="M8 10C9.104 10 10 9.104 10 8L10 2C10 0.896 9.104 0 8 0L2 0C0.896 0 0 0.896 0 2L0 8C0 9.104 0.896 10 2 10L8 10ZM23 8C23 9.104 22.104 10 21 10L15 10C13.896 10 13 9.104 13 8L13 2C13 0.896 13.896 0 15 0L21 0C22.104 0 23 0.896 23 2L23 8ZM34 10C35.104 10 36 9.104 36 8L36 2C36 0.896 35.104 0 34 0L28 0C26.896 0 26 0.896 26 2L26 8C26 9.104 26.896 10 28 10L34 10ZM10 21C10 22.104 9.104 23 8 23L2 23C0.896 23 0 22.104 0 21L0 15C0 13.896 0.896 13 2 13L8 13C9.104 13 10 13.896 10 15L10 21ZM21 23C22.104 23 23 22.104 23 21L23 15C23 13.896 22.104 13 21 13L15 13C13.896 13 13 13.896 13 15L13 21C13 22.104 13.896 23 15 23L21 23ZM36 21C36 22.104 35.104 23 34 23L28 23C26.896 23 26 22.104 26 21L26 15C26 13.896 26.896 13 28 13L34 13C35.104 13 36 13.896 36 15L36 21ZM8 36C9.104 36 10 35.104 10 34L10 28C10 26.896 9.104 26 8 26L2 26C0.896 26 0 26.896 0 28L0 34C0 35.104 0.896 36 2 36L8 36ZM23 34C23 35.104 22.104 36 21 36L15 36C13.896 36 13 35.104 13 34L13 28C13 26.896 13.896 26 15 26L21 26C22.104 26 23 26.896 23 28L23 34ZM34 36C35.104 36 36 35.104 36 34L36 28C36 26.896 35.104 26 34 26L28 26C26.896 26 26 26.896 26 28L26 34C26 35.104 26.896 36 28 36L34 36Z" transform="translate(6 6)" id="Shape" fill="#CFD8DC" fill-rule="evenodd" stroke="none"></path></g></svg>`;
        this.reconnectionIcon = `<svg class="spinnerLoader"><circle class="pathLoader" cx="50" cy="50" r="30" fill="none" stroke-width="6" stroke-miterlimit="5" /></svg>`;
        this.reconnectionIconParticipant = `<svg class="spinnerParticipant"><circle class="pathParticipant" fill="none" stroke-width="4" stroke-miterlimit="5" /></svg>`;
        this.chatBubbleIconOnTiles = `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="45px" height="40px" viewBox="0 0 27 27" style="enable-background:new 0 0 30 25;" xml:space="preserve" fill="#fafafa"><g><g><path d="M24.624,12.837c-0.019-0.619-0.112-1.224-0.276-1.808c-1.201-4.274-6.133-7.476-12.034-7.476 C5.513,3.554,0,7.806,0,13.051c0,2.295,1.055,4.398,2.812,6.041l-0.906,4.572l4.483-2.287c1.758,0.746,3.777,1.172,5.925,1.172 c0.219,0,0.437-0.006,0.653-0.014c0.829-0.033,1.637-0.131,2.415-0.285c5.316-1.051,9.246-4.771,9.246-9.199 C24.627,12.98,24.626,12.909,24.624,12.837z M19.945,18.187c-1.867,1.438-4.33,2.28-6.993,2.396 c-0.211,0.011-0.424,0.016-0.639,0.016c-0.412,0-0.819-0.018-1.222-0.053c-2.438-0.204-4.679-1.023-6.408-2.357 c-1.837-1.417-2.849-3.241-2.849-5.136c0-1.895,1.012-3.719,2.849-5.136c2.015-1.554,4.725-2.41,7.63-2.41 c2.906,0,5.617,0.856,7.63,2.41c0.912,0.703,1.619,1.506,2.103,2.368c0.306,0.547,0.521,1.118,0.64,1.702 c0.071,0.351,0.107,0.707,0.107,1.065C22.793,14.946,21.782,16.77,19.945,18.187z"></path></g><g><circle cx="16.682" cy="13.08" r="1.347"></circle><circle cx="12.314" cy="13.08" r="1.347"></circle><circle cx="7.946" cy="13.08" r="1.348"></circle></g></g></svg>`;
        this.windowsLogo = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" fill="#E5E5E5"/><path d="M0 5.63727L16.2214 3.42809L16.2285 19.0749L0.0148182 19.1672L0 5.63727ZM16.2136 20.8777L16.2262 36.5382L0.0125909 34.309L0.0116818 20.7727L16.2136 20.8777ZM18.18 3.13909L39.6882 0V18.8759L18.18 19.0467V3.13909ZM39.6932 21.025L39.6882 39.8159L18.18 36.7803L18.1499 20.9898L39.6932 21.025Z" fill="#0078D6"/></svg>`;
        this.appleLogo = `<?xml version="1.0" encoding="UTF-8" standalone="no"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" width="40" viewBox="0 0 842.32007 1000.0001" version="1.1" height="40" id="svg2"><path d="m 824.66636,779.30363 c -15.12299,34.93724 -33.02368,67.09674 -53.7638,96.66374 -28.27076,40.3074 -51.4182,68.2078 -69.25717,83.7012 -27.65347,25.4313 -57.2822,38.4556 -89.00964,39.1963 -22.77708,0 -50.24539,-6.4813 -82.21973,-19.629 -32.07926,-13.0861 -61.55985,-19.5673 -88.51583,-19.5673 -28.27075,0 -58.59083,6.4812 -91.02193,19.5673 -32.48053,13.1477 -58.64639,19.9994 -78.65196,20.6784 -30.42501,1.29623 -60.75123,-12.0985 -91.02193,-40.2457 -19.32039,-16.8514 -43.48632,-45.7394 -72.43607,-86.6641 C 77.707522,829.30207 52.171259,778.62464 32.165691,720.84861 10.740416,658.44309 0,598.01283 0,539.50845 0,472.49197 14.481044,414.69125 43.486336,366.25444 66.28194,327.34823 96.60818,296.6578 134.5638,274.1276 c 37.95566,-22.53016 78.96676,-34.01129 123.1321,-34.74585 24.16591,0 55.85633,7.47508 95.23784,22.166 39.27042,14.74029 64.48571,22.21538 75.54091,22.21538 8.26518,0 36.27668,-8.7405 83.7629,-26.16587 44.90607,-16.16001 82.80614,-22.85118 113.85458,-20.21546 84.13326,6.78992 147.34122,39.95559 189.37699,99.70686 -75.24463,45.59122 -112.46573,109.4473 -111.72502,191.36456 0.67899,63.8067 23.82643,116.90384 69.31888,159.06309 20.61664,19.56727 43.64066,34.69027 69.2571,45.4307 -5.55531,16.11062 -11.41933,31.54225 -17.65372,46.35662 z M 631.70926,20.0057 c 0,50.01141 -18.27108,96.70693 -54.6897,139.92782 -43.94932,51.38118 -97.10817,81.07162 -154.75459,76.38659 -0.73454,-5.99983 -1.16045,-12.31444 -1.16045,-18.95003 0,-48.01091 20.9006,-99.39207 58.01678,-141.40314 C 497.65157,54.696 521.21876,37.0095 549.79815,22.90064 578.3158,9.00229 605.2903,1.31621 630.65988,0 c 0.74076,6.68575 1.04938,13.37191 1.04938,20.00505 z" id="path4" inkscape:connector-curvature="0" style="stroke-width:0.84231985;fill:#b3b3b3;fill-opacity:1" /></svg>`;
        this.pullFocusIcon = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px"><path fill="#e0e4e5" d="M12,2c-4.2,0-8,3.22-8,8.2c0,3.18,2.45,6.92,7.34,11.22c0.36,0.32,0.97,0.32,1.33,0C17.55,17.12,20,13.38,20,10.2 C20,5.22,16.2,2,12,2z M7.69,12.49C8.88,11.56,10.37,11,12,11s3.12,0.56,4.31,1.49C15.45,13.98,13.85,15,12,15 S8.55,13.98,7.69,12.49z M12,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C10,6.9,10.9,6,12,6z"/></svg>`;
        this.locateIcon = `<svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 21C3 30.9 11.1 39 21 39C30.9 39 39 30.9 39 21C39 11.1 30.9 3 21 3C11.1 3 3 11.1 3 21ZM7 21C7 13.3 13.3 7 21 7C28.7 7 35 13.3 35 21C35 28.7 28.7 35 21 35C13.3 35 7 28.7 7 21Z" fill="black"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19 0H23V10H19V0ZM0 19H10V23H0V19ZM42 19H32V23H42V19ZM23 32H19V42H23V32Z" fill="#78909C"/>
        <path d="M21 20.5C22.8937 20.5 24.4286 18.8213 24.4286 16.75C24.4286 14.6787 22.8937 13 21 13C19.1063 13 17.5714 14.6787 17.5714 16.75C17.5714 18.8213 19.1063 20.5 21 20.5ZM23.4 21.4375H22.9527C22.358 21.7363 21.6964 21.9062 21 21.9062C20.3036 21.9062 19.6446 21.7363 19.0473 21.4375H18.6C16.6125 21.4375 15 23.2012 15 25.375V26.5938C15 27.3701 15.5759 28 16.2857 28H25.7143C26.4241 28 27 27.3701 27 26.5938V25.375C27 23.2012 25.3875 21.4375 23.4 21.4375Z" fill="black"/>
        </svg>
        `;
        this.inviteIcon = `<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 0C6.01122 0 4.8 1.30112 4.8 2.90039C4.8 4.49966 6.01122 5.80078 7.5 5.80078C8.98878 5.80078 9.9704 4.49966 9.9704 2.90039C9.9704 1.30112 8.98878 0 7.5 0ZM10.8593 7.69559C10.1201 6.88932 9.14018 6.44532 8.1 6.44532H6.9C5.85983 6.44532 4.87988 6.88932 4.14068 7.69559C3.4051 8.49791 3 9.55697 3 10.6777C3 10.8557 3.13432 11 3.3 11H11.7C11.8657 11 12 10.8557 12 10.6777C12 9.55697 11.5949 8.49791 10.8593 7.69559Z" fill="#04171E"/>
        <path d="M3.13532 7.19884C4.30145 7.19884 5.37807 7.81908 5.89957 8.78548L6 9V8.67776C6 7.21726 4.7116 6.0235 3.13532 6.0235V5L1 6.61117L3.13532 8.22724V7.19884Z" fill="#04171E" stroke="#04171E" stroke-width="0.1" stroke-miterlimit="10"/>
        </svg>
        `
        this.inviteIconSecondOption = `<svg width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M256 0C181.561 0 121 60.561 121 135C121 209.439 181.561 270 256 270C330.439 270 391 209.439 391 135C391 60.561 330.439 0 256 0ZM423.966 358.195C387.006 320.667 338.009 300 286 300H226C173.992 300 124.994 320.667 88.034 358.195C51.255 395.539 31 444.833 31 497C31 505.284 37.716 512 46 512H466C474.284 512 481 505.284 481 497C481 444.833 460.745 395.539 423.966 358.195Z" fill="#032836"/>
        <path d="M363.09 211.556C363.09 213.618 362.359 215.638 360.981 217.378C359.603 219.119 357.636 220.508 355.31 221.384C352.985 222.262 350.397 222.59 347.848 222.33C345.299 222.07 342.896 221.232 340.919 219.916L266.936 170.713H227.533C225.756 170.714 223.996 170.433 222.354 169.888C220.712 169.342 219.22 168.543 217.963 167.534C216.706 166.526 215.709 165.328 215.029 164.011C214.349 162.693 214 161.281 214 159.854V116.582C214 113.701 215.426 110.938 217.963 108.901C220.501 106.864 223.943 105.719 227.533 105.718H266.939L340.922 56.5151C342.898 55.1974 345.303 54.3598 347.852 54.1007C350.401 53.8416 352.989 54.1717 355.313 55.0524C357.638 55.9286 359.605 57.3182 360.983 59.0585C362.361 60.7989 363.092 62.8182 363.093 64.8801L363.09 211.556ZM415.097 194.584C413.161 194.697 411.217 194.474 409.398 193.93C407.579 193.387 405.928 192.535 404.556 191.433L402.746 189.975C400.449 188.135 399.053 185.693 398.813 183.096C398.573 180.498 399.505 177.918 401.439 175.826C411.529 164.964 416.961 151.77 416.922 138.222C416.922 138.222 410.849 109.795 399.357 98.4328C397.245 96.3485 396.172 93.7097 396.344 91.0267C396.516 88.3438 397.922 85.8075 400.289 83.9084L402.096 82.4559C404.799 80.2863 408.422 79.1037 412.342 79.2914C414.231 79.3675 416.08 79.7602 417.768 80.4442C419.457 81.1283 420.948 82.0885 422.146 83.2631C438.088 98.9186 446.508 117.926 446.508 138.224C446.508 157.129 439.061 175.124 424.968 190.255C423.805 191.502 422.322 192.534 420.619 193.281C418.916 194.028 417.032 194.473 415.097 194.584ZM471.047 228.15C469.837 229.297 468.344 230.231 466.662 230.892C464.98 231.553 463.145 231.927 461.274 231.99C459.403 232.054 457.536 231.805 455.79 231.26C454.045 230.715 452.459 229.885 451.134 228.823L449.356 227.397C446.961 225.474 445.552 222.9 445.406 220.184C445.26 217.468 446.388 214.807 448.568 212.726C470.412 191.856 482.396 165.478 482.417 138.222C482.432 109.95 469.54 82.6542 446.178 61.4945C443.897 59.4256 442.683 56.7366 442.784 53.9748C442.885 51.2131 444.294 48.586 446.723 46.6282L448.497 45.2015C449.788 44.1367 451.343 43.302 453.062 42.7519C454.781 42.2018 456.626 41.9485 458.475 42.0087C460.319 42.0516 462.134 42.3969 463.806 43.0233C465.478 43.6498 466.973 44.5441 468.199 45.6513C496.436 71.1595 512.023 104.1 512 138.222C511.989 171.136 497.484 202.988 471.047 228.15Z" fill="#032836"/>
        </svg>
        `
        this.slideTopLeftVideoTimeout = 0;
        this.recordingListTimeout = 0;
        this.presenterStripVideos = $('#presenterStripVideos');
        this.efss=new Efss();
        this.announcement=new Announcement();
        this.speaker=new Speaker();
        this.presenter=new Presenter();
        this.stealFocus=new StealFocus();
        this.splitConversations=new SplitConversations();
        this.minimizedContent = new MinimizedContent();
        this.lockMasterVolume = new LockMasterVolume();
        this.isLobbyView=true;
        //lastParticipantVolume saves last volume value assigned to a participant except 0
        this.lastParticipantVolume={};
        //last master volume value changed except 0
        this.lastMasterVolume=1;
        this.stateChangedWhileMuted=false;
        this.isDisconnected=false;
        this.playUserLeftSoundTimeout=null;
        this.playUserLeftSound=true;
        this.isParticipantLocationActive = false;
    };
    addVideoHover(el) {
        var app = this;
        clearTimeout(app.slideTopLeftVideoTimeout);
        el.addClass('video-hover');
        // $('#localParticipant.left-top').addClass('move-right');
    };

    removeVideoHover(el) {
        var app = this;
        el.removeClass('video-hover');
        el.find('[data-toggle="tooltip"]').tooltip('hide');
        // app.slideTopLeftVideoTimeout = setTimeout(function () {
        //     $('#localParticipant.left-top').removeClass('move-right');
        // }, 2000);
    };

    videoHoverMouseNotMoving(el) {
        var app = this;

        clearTimeout(app.mouseNotMoving);
        clearTimeout(app.slideTopLeftVideoTimeout);
        app.mouseNotMoving = setTimeout(function () {
            app.removeVideoHover(el);
        }, 2500);
    };

    removeFrozen() {
        /* var app = this;
         if (room) {
           $.each(room.getParticipants(), function (i, participant) {
             if (participant.getConnectionStatus() == "inactive") {
               console.log(
                 participant.getDisplayName() + ' .'
               );
               app.removeVideo(participant.getId());
             }
           });
         }*/
    };

    addFullscreenBtn(){
        let app=this;
        const optionIcon=$("<div/>",{
            class:'option-icon',
            id:'windowFullScreenIcon',
            html:`<i class="icofont-expand"></i>`
        });
        const optionDesc=$("<div/>",{
            class:'option-description',
            html: `<div class="option-name" id="windowFullScreenDesc">
                     Full Screen
                </div>
                <div class="option-action"></div>`
        });
        this.windowFullScreenBtn=$("<div/>",{
            class:'option',
            id:'windowFullScreen',
            html:[optionIcon,optionDesc]
        }).on('click', function(){
            hideSideMenu();
            app.toggleFullScreen($(this));
        });
        $("#option-list").append(this.windowFullScreenBtn);
    }

    init() {
        var app = this;
        app.sounds.load();
        app.addLocalVideo();
        app.hideSideVideos();
        onStage.events();
        app.splitConversations.events();
        app.lockMasterVolume.events();
        if(HOST==1 || ROLE=="moderator"){
            CONV_STORAGE.addPinAccess();
            console.log("Add on stage video to local user",app.localVideo);
        }
        // app.toggleTileView.removeClass('active');
        app.enableLobbyView();
        app.enableToggle();
        // app.initMasterVolume();
        app.window.width = $(window).width();
        app.window.height = $(window).height();

        $(document).on(
            'mouseover',
            '.no-camer-layer-thumbnail, .videoWrapper, .video-toolbar, .video-top-toolbar, .toolbar-bottom',
            function () {
                app.addVideoHover($(this).parent('.videoViewContainer'));
            }
        );

        $(document).on(
            'mouseleave',
            '.no-camer-layer-thumbnail, .videoWrapper, .video-toolbar, .video-top-toolbar, .toolbar-bottom',
            function () {
                app.removeVideoHover($(this).parent('.videoViewContainer'));
            }
        );

        $(document).on(
            'mousemove',
            '.no-camer-layer-thumbnail, .videoWrapper, .video-toolbar, .video-top-toolbar, .toolbar-bottom',
            function () {
                // app.videoHoverMouseNotMoving($(this).parent('.videoViewContainer'));
            }
        );

        app.raiseHand.on('click', function () {
            let btn = $(this);
            if (btn.hasClass('active')) {
                return;
            } else {
                btn.addClass('active');
                socket.sendPublicRaiseHand();
                setTimeout(function () {
                    btn.removeClass('active');
                }, 5000);
            }
        });

        app.raiseHandFocused.on('click', function () {
            let btn = $(this);
            if (btn.hasClass('active')) {
                return;
            } else {
                $(this).addClass('active');
                let focused = Object.keys(app.focused);
                if (focused.length > 0) {
                    socket.sendPrivateRaiseHand(focused);
                } else if(CONV_STORAGE.myConversation){
                    socket.sendPrivateRaiseHand(kinoParticipants.inMySpace(false));
                    console.log('There are no focused participants to wave');
                }
                // disable for 5 sec
                setTimeout(function () {
                    btn.removeClass('active');
                }, 5000);
            }
        });

        socket.events.RaiseHand = function (request) {
            let message = '';
            let icon = `<img src="${isElectron ? '../..' : ''}/images/wave.png" width="30px" height="30px">`;
            if (request.data.private == 'yes') {
                message = `${request.data.displayName} is waving at you`;
            } else {
                message = `${request.data.displayName} is waving at everyone`;
            }
            app.sounds.play('wave2');
            app.showNotification(icon, message, 'wave', request.data.participantId);
        };

        socket.events.FocusConversation = function (request) {

        };

        socket.events.lowVolume = function (request) {
            let data = request.data;
            if (data.participant) {
                if (app.focused[data.participant] === undefined) {
                    app.onConversation[data.participant] = true;
                    let vol = 0.05;
                    if (isSafari) {
                        vol = 0;
                    } else {
                        if (app.masterMuted) {
                            vol = 0;
                        } else {
                            if (app.masterVolumeSlider.val() < 0.05) {
                                vol = app.masterVolumeSlider.val();
                            }
                        }
                    }
                    app.changeParticipantVolume(data.participant, vol);
                }
            }
        };


        socket.events.setVolume = function (request) {
            let data = request.data;
            if (data.participant) {

                if (data.toMasterVolume == true) {
                    delete app.onConversation[data.participant];
                    console.log("Removed from conversation user " + data.participant);
                } else {
                    console.log("Added on conversation user " + data.participant);
                    app.onConversation[data.participant] = (data.conversation) ? data.conversation : true;
                }
                console.log("On conversation participants");
                console.log(app.onConversation);
                if (app.focused[data.participant] === undefined) {
                    if (app.videos[data.participant]) {
                        let vol = data.volume;
                            if (volumeManager.masterMuted) {
                                if(!CONV_STORAGE.myConversation && CONV_STORAGE.masterVolumeOverwrite===0 && data.toMasterVolume){
                                    vol=1
                                }else{
                                    app.lastParticipantVolume[data.participant]=vol;
                                    vol = 0;
                                }

                            } else {
                                if (data.toMasterVolume == true) {
                                    console.log("Current masterVolume ",volumeManager.masterVolume);
                                    vol = volumeManager.masterVolume;

                                } else {
                                    if (volumeManager.masterVolume < data.volume) {
                                        vol = volumeManager.masterVolume;
                                    }else if(CONV_STORAGE.myConversation){
                                        vol = volumeManager.masterVolume;
                                    }
                                }

                            }
                        // app.changeParticipantVolume(data.participant, vol);
                        volumeManager.changeParticipantVolume(data.participant, vol)
                    }
                } else {
                    console.log("Skiping because user is focused");
                }
            }
        };

        // socket.events.UserJoin = function (request) {
        //     let data = request.data;
        //     if (data.role == "moderator") {
        //         if (!MODERATORS.includes(data.participant)) {
        //             MODERATORS.push(data.participant);
        //             if (app.videos[data.participant]) {
        //                 app.videos[data.participant].makeModerator.find(".make-moderator").addClass("enabled");
        //                 app.videos[data.participant].isModerator = true;
        //             }
        //         }
        //         if (app.videos[data.participant]) {
        //             console.log("User join request after object creation");
        //         }
        //     }
        // };


        socket.events.RoomLeft = function (request) {
            let data = request.data;
            app.disconnected(data.participant, 15000);
        };
        socket.events.PermanentDrop = function (request) {
            let data = request.data;
            if(app.videos[data.participant]){
                app.removeVideo(data.participant);
                try{
                    room.kickParticipant(data.participant);
                }catch(err){
                    // console.log("Can not kick participant");
                }
            }
        };
        socket.events.ReconnectUpdate = app.onReconnectUpdate.bind(app);
        socket.events.UserReconnect = function (request) {
            let data = request.data;
            app.reconnected(data.participant);
        };

        socket.events.connectedConfirmation=function(request){
            let data = request.data;
            if (data.connected==false) {
                app.removeVideo(data.participant);
                try{
                    room.kickParticipant(data.participant);
                }catch(err){
                    console.log("Can not kick participant");
                }
            }

        };
        //I lost connection
        socket.events.connectionError = function (message) {
            if(isJoined){
                app.connectionLost();
            }
        };
        socket.events.announcementStart=app.announcement.announcementStartEvent.bind(app.announcement);
        socket.events.announcementStop=app.announcement.announcementStopEvent.bind(app.announcement);
        /**
         * bamirs: local recording socket events
         * commented for production
         */
        // socket.events.startedRecording = app.startedRecording.bind(app);
        // socket.events.stoppedRecording = app.stoppedRecording.bind(app);
        socket.events.StreamDropError=function(request){
            app.errorMessage("Connection error","Failed to reconnect you to the kino",request.data.action);
        }
        socket.events.MakeModeratorEVT = function (request) {
            socket.moderatorRoom(room.myUserId(),'join');
            app.showNotification('', `${request.data.host} made you a moderator`, 'moderator');
            app.makeParticipantModerator(request.data.moderator);
        };
        socket.events.RemoveModeratorEVT = function (request) {
            app.showNotification('', `Moderator rights have been removed`, 'moderator');
            app.removeModeratorRights();
        };


        socket.events.maxVolume = function (request) {
            let data = request.data;
            if (data.participant) {
                delete app.onConversation[data.participant];
                if (app.focused[data.participant] === undefined) {
                    if (app.videos[data.participant]) {
                        delete app.onConversation[data.participant];
                        let vol = 1;

                        if (isSafari) {
                            vol = 1;
                        } else {
                            if (app.masterMuted) {
                                vol = 0;
                            } else {
                                vol = app.masterVolumeSlider.val();
                            }
                        }
                        app.changeParticipantVolume(data.participant, vol);
                    }

                }
            }
        };



        socket.events.lowVolumeInit = function (request) {
            let data = request.data;
            let vol = 0.05;

            if (volumeManager.masterMuted) {
                    vol = 0;
            } else {
                if (volumeManager.masterVolume < 1) {
                    vol = volumeManager.masterVolume;
                }
            }
            if (data.participants) {
                $.each(data.participants, function (i, val) {
                    if(CONV_STORAGE.spacesFinishedLoading && !CONV_STORAGE.isOnConversation(val)){
                        console.error("Low volume init, participant is not on a space",val);
                        return;
                    }
                    if (app.videos[val] !== undefined && app.videos[val].audioPlayer && app.videos[val].audios.slider) {
                        volumeManager.changeParticipantVolume(val, vol);//card 744
                    } else {
                        // console.error('Participant has not joined yet');
                        app.initialVolume[val] = vol;
                    }
                });
            }
        };
        document.addEventListener("keydown", function(e) {
            // console.log("Pressed Key",e.key)
            if (e.key === "F11") {
              app.toggleFullScreen(null);
              e.preventDefault()
            }
          }, false);

        window.addEventListener('fullscreenchange', function(){
            if (document.fullscreenElement) {
                console.log("Entered full screen")
                $('#windowFullScreenIcon').html('<i class="icofont-interface"></i>');
                $('#windowFullScreenDesc').html('Window Mode');
            }else{
                console.log("Exit full screen")
                hideSideMenu();
                $('#windowFullScreenIcon').html('<i class="icofont-expand"></i>');
                $('#windowFullScreenDesc').html('Full Screen');
            }
        });
        window.addEventListener('webkitfullscreenchange', function(){
            if (document.fullscreenElement) {
                console.log("Entered full screen")
                $('#windowFullScreenIcon').html('<i class="icofont-interface"></i>');
                $('#windowFullScreenDesc').html('Window Mode');
            }else{
                console.log("Exit full screen")
                $('#windowFullScreenIcon').html('<i class="icofont-expand"></i>');
                $('#windowFullScreenDesc').html('Full Screen');
                hideSideMenu();
            }
        });

        window.addEventListener('resize', function () {
            // console.log("Full screen element",document.fullscreenElement)
            app.window.width = $(window).width();
            app.window.height = $(window).height();
            app.resizeMainVideos();
            app.efss.inViewPortMainVideos.call(app.efss);
            app.efss.inViewPortSideVideos.call(app.efss);
            app.efss.inViewPortConversations.call(app.efss);
            spacesView.updateSpacesHeight();
            if(onStage.isActive()){
                onStage.myStage.resizeStageVideos();
            }
        });

        //$("#recorder-indicator").on('click', app.isRecordingList.bind(app));
        // app.windowFullScreenBtn.on('click', function () {
        //     hideSideMenu();
        //     app.toggleFullScreen($(this));
        // });

        $(document).on('mouseup', function (eup) {
            app.stopDragVideo(eup);
        });
        // call a function whenever the cursor moves:
        $(document).on('mousemove', function (em) {
            app.dragVideo(em);
        });
        app.nonDraggableVideo();
        //efss
        app.sideVideosContainer.scroll(app.efss.inViewPortSideVideos.bind(app.efss));
        app.remoteVideos.scroll(app.efss.inViewPortMainVideos.bind(app.efss));
        /***
            remove frozen videos on screen
            **/
        setInterval(function () {
            app.removeFrozen();
        }, 10000);

        /**
         * Tooltip fixes to not get stuck on the screen
         */
         $('body').tooltip({
            selector: '[data-toggle="tooltip"], [title]:not([data-toggle="popover"])',
            trigger: 'hover',
            container: 'body'
        }).on('click mouseup', '[data-toggle="tooltip"], [title]:not([data-toggle="popover"])', function () {
            $('[data-toggle="tooltip"], [title]:not([data-toggle="popover"])').tooltip('dispose')
        });
        //begin card 811
        // app.checkForGhosts();
        //end card 811
        app.searchParticipantInput.on('input', function(){
            let input = '';
            input = $(this).val().toLowerCase();
            app.searchParticipant(input)
        })
    };

    calculateMax() {
        var app = this;
        let containerWidth = app.remoteVideosContainer.innerWidth();
        let containerHeight = app.remoteVideosContainer.innerHeight();

        app.maxColumns = Math.floor(containerWidth / app.videoMinWidth);
        app.maxRows = Math.floor(containerHeight / app.videoMinHeight);
        app.containerMaxVideos = app.maxColumns * app.maxRows;
    };

    showInVideoNotification(
        participant,
        type = 'focusConversation',
        participants = [],
        conversation_id = 0
    ) {
        var app = this;
        let message = '';
        let action = '';
        let space = '&nbsp;';
        let dismiss = false;
        let icon = '';

        console.log(type);
        if (type == 'focusConversation') {
            message = `${app.videos[participant].displayName} is in a conversation`;
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            });
            action = $('<button/>', {
                class: 'btn btn-sm btn-outline-light btn-rounded mr-1',
                html: 'Focus Space',
            }).on('click', function () {
                //conversations
                if(typeof CONV_STORAGE !== 'undefined'){
                    CONV_STORAGE.join.call(CONV_STORAGE,conversation_id);
                }
                dismiss.click();
                app.videos[participant].notificationBar.html('');
            });

            icon = app.conversationIcon;
        } else if (type == 'focusBack') {
            message = `${app.videos[participant].displayName} is focused on you`;
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            });
            action = $('<button/>', {
                class: 'btn btn-sm btn-outline-light btn-rounded mr-1',
                html: 'Focus Back',
            }).on('click', function () {
                //check if on stage is active
                if(onStage.isActive()){
                    onStage.showLockOnStageActiveNotification();
                    return;
                }
                //lock focus
                if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                    lockFocus.showLockFocusNotification();
                    return;
                }
                app.videos[participant].focusButton.addClass('active');
                // app.videos[participant].focusButton.attr('title', 'Unfocus');
                // app.videos[participant].focusButton.attr(
                //     'data-original-title',
                //     'Unfocus'
                // );
                app.focusVideo(participant);
                dismiss.click();
            });

            icon = app.focusIcon;
        }

        let textdiv = $('<div/>', {
            class: 'text',
            html: [message, space, action, space, dismiss],
        });
        let icondiv = $('<div/>', {
            class: 'icon',
            html: icon,
        });

        let closediv = $('<div/>', {
            class: 'close',
            html: `<i class="icofont-close icofont-1x"></i>`,
        });

        let container = $('<div/>', {
            class: 'notificationContent',
            html: [icondiv, textdiv],
        });

        let timeout = setTimeout(function () {
            app.hideInVideoNotification(container);
        }, 30000);
        closediv.on('click', function () {
            clearTimeout(timeout);
            app.hideInVideoNotification(container);
        });
        if (dismiss) {
            dismiss.on('click', function () {
                clearTimeout(timeout);
                app.hideInVideoNotification(container);
            });
        }
        //console.log(container);

        //container.appendTo($());
        //$(document).find(`#${participant}`).append(container);
        app.videos[participant].notificationBar.html(container);
    };

    verifyInitialVolume(){
        try {
            let onSpaceIds=Object.keys(this.initialVolume);
            onSpaceIds.forEach(pid=>{
                let p=kinoParticipants.get(pid);
                if(p && !p.getSpaceId()){
                    console.error('Deleteing initial volume of participant ',pid);
                    delete this.initialVolume[pid];
                }
            });
        } catch (error) {

        }
    };
    conversationVolume(data){
        let app=this;

    };//conversation volume

    hideInVideoNotification(notification) {
        $(notification).remove();
    };

    moveNonFocusedSide () {
        var app = this;

        console.trace(`Moving non focused to side`);
        $.each(app.mainParticipants, function (i, val) {
            if(!app.videos[i] || app.focused[i]){return}
            if(kinoParticipants.isInMySpace(i)){return};
            delete app.mainParticipants[i];
            app.sideParticipants[i] = true;
            if (app.videos[i].focusOnMe) {
                    app.videos[i].viewContainer.prependTo(app.sideVideosContainer);
            } else {
                    app.videos[i].viewContainer.appendTo(app.sideVideosContainer);
            }
            try{
                setTimeout(() => {
                      app.efss.isInViewPort(app.videos[i].viewContainer,$('#sideVideosContainer'),i);
                }, 100);
                //console.warn("added viewport event on side");
            }catch(err){
                    console.error(err);
            }
        });
    };

    disableToggle() {
        var app = this;
        app.toggleDisabled = true;
        // app.toggleTileView.addClass('toggle-disabled');
    };
    enableToggle() {
        var app = this;
        app.toggleDisabled = false;
        // app.toggleTileView.removeClass('toggle-disabled');
    };
    moveAllToMain (skipConvo=false) {
        var app = this;
        let lastFocused =
            Object.keys(app.focused).length > 0 ?
            Object.keys(app.focused).pop() :
            false;

        $.each(app.sideParticipants, function (i, val) {
            if(skipConvo && app.isLobbyView && kinoParticipants.get(i).getSpaceId()){return};
            if (app.focused[i]) {
                app.videos[i].viewContainer.prependTo(app.remoteVideosContainer);
            } else if (app.videos[i].focusOnMe) {
                if (lastFocused && app.videos[lastFocused]) {
                    app.videos[lastFocused].viewContainer.after(
                        app.videos[i].viewContainer
                    );
                } else {
                    app.videos[i].viewContainer.prependTo(app.remoteVideosContainer);
                }
            } else {
                app.videos[i].viewContainer.appendTo(app.remoteVideosContainer);
            }

            delete app.sideParticipants[i];
            app.mainParticipants[i] = true;
            clearTimeout(conversationTooltipTimeout);
            //view port event on side
                try{
                    setTimeout(() => {
                        if(onStage.myStage.isStageView() && onStage.myStage.audienceScrollable){
                            app.efss.isInViewPort(app.videos[i].viewContainer,onStage.myStage.audienceScrollable,i);
                        }else{
                            app.efss.isInViewPort(app.videos[i].viewContainer,$('#remoteVideos'),i);
                        }
                    }, 100);
                }catch(err){
                    console.error(err);
                }
        });

        muteParticipants.renderMuteButtons();
    };

    moveVideoToSide(participant) {
        var app = this;
        if (app.focused[participant]) {
            if (app.videos[participant]) {
                app.videos[participant].viewContainer.prependTo(
                    app.sideVideosContainer
                );
                delete app.mainParticipants[participant];
                app.sideParticipants[participant] = true;
                app.isFocusedSafeView();
            }
        } else {
            if (app.videos[participant]) {
                if (app.videos[participant].focusOnMe) {
                    app.videos[participant].viewContainer.prependTo(
                        app.sideVideosContainer
                    );
                } else {
                    app.videos[participant].viewContainer.appendTo(
                        app.sideVideosContainer
                    );
                }
                delete app.mainParticipants[participant];
                app.sideParticipants[participant] = true;
                app.isFocusedSafeView();
            }
        }
        if (app.videos[participant]) {
          if(muteParticipants.canIMuteParticipant(participant)){
              app.videos[participant].showMuteButton();
          }else{
              app.videos[participant].hideMuteButton();
          }
        }
          if(Object.keys(app.sideParticipants).length > 0){
              app.showSideVideos();
          }
        //view port event on side
                try{
                    setTimeout(() => {
                        if(app.videos[participant] !== undefined) app.efss.isInViewPort(app.videos[participant].viewContainer,$('#sideVideosContainer'),participant);
                    }, 100);
                }catch(err){
                    // console.error(err);
                }
    };

    moveVideoToMain (participant) {
        var app = this;
        let lastFocused =
            Object.keys(app.focused).length > 0 ?
            Object.keys(app.focused).pop() :
            false;
            if(!app.videos[participant]){return}
            console.log(`moveVideoToMain main function ${participant}`);
        if(app.presenter.isPresenterView){
                app.videos[participant].viewContainer.prependTo(
                    app.presenterStripVideos
                   );
            }else{
                if (app.focused[participant]) {
                    app.videos[participant].viewContainer.prependTo(
                        app.remoteVideosContainer
                    );
                } else if (app.videos[participant] && app.videos[participant].focusOnMe) {
                    console.log(`Moving to remoteVideosContainer focused on me`,app.videos[participant].viewContainer)
                    if (lastFocused && app.videos[lastFocused]) {
                            app.videos[lastFocused].viewContainer.after(
                                app.videos[participant].viewContainer
                            );
                        } else {
                            console.log(`Moving to remoteVideosContainer`,app.videos[participant].viewContainer)
                            app.videos[participant].viewContainer.prependTo(
                                app.remoteVideosContainer
                            );
                        }
                } else {

                    if(app.videos[participant]!==undefined){
                       console.log(`Moving to remoteVideosContainer`,app.videos[participant].viewContainer)
                       app.videos[participant].viewContainer.appendTo(app.remoteVideosContainer);
                    }

                }
            }
        delete app.sideParticipants[participant];
        app.mainParticipants[participant] = true;
        if(Object.keys(app.sideParticipants).length > 0){
            app.showSideVideos();
        }else{
            app.hideSideVideos();
        }
        //view port event on main screen
        if(muteParticipants.canIMuteParticipant(participant)){
            app.videos[participant].showMuteButton();
        }else{
            app.videos[participant].hideMuteButton();
        }

         try{
             if(app.videos[participant] == undefined){return}
             setTimeout(() => {
                if(onStage.myStage.isStageView() && onStage.myStage.audienceScrollable){
                    app.efss.isInViewPort(app.videos[participant].viewContainer,onStage.myStage.audienceScrollable,participant);
                }else{
                    app.efss.isInViewPort(app.videos[participant].viewContainer,$('#remoteVideos'),participant);
                }
             }, 100);

        }catch(err){
            console.error(err);
        }
    };

    errorMessage (
        title,
        description = '',
        type = 'reconnect'
    ) {
        var app = this;
        let countDown;
        let initSeconds = 15;

        if($('.error-message-overlay')){
            $('.error-message-overlay').remove();
        }

        let errorIcon = $('<div/>', {
            class: 'message-error-icon mb-3',
            html: [`<i class="fa fa-exclamation-triangle f-s-5rem" aria-hidden="true"></i>`]
        });

        let messageTitle = $('<h3/>', {
            class: 'message-title',
            html: title,
        });

        let messageDesc = $('<div/>', {
            class: 'message-desc',
            html: description,
        });

        let messageContent = $('<div/>', {
            class: 'message-content-error',
            html: [errorIcon, messageTitle, messageDesc],
        });

        let messageRecommendations = $('<div/>',{
            class: 'message-recommendations',
            html: [`
                <div class="text-center mt-3">If you keep getting here, try these suggestions.</div>
                <ul>
                    <li class="mt-3"><u><b>Connection speed</b></u>, minimum of 10Mbps is recommended.</li>
                    <li class="mt-3"><u><b>Disconnect VPN</b></u>, VPN can disrupt your connection.</li>
                    <li class="mt-3"><u><b>Firewall or Proxy</b></u>, make sure your connection is not being blocked by a firewall or proxy.</li>
                </ul>
            `]
        });
        let pageWillReload='';
        if(type == 'reconnect'){
            let seconds = $("<span/>",{
                class: 'mx-1',
                html: [initSeconds]
            });
            countDown = setInterval(() => {
                initSeconds--;
                if(initSeconds < 10){
                    initSeconds = "0"+initSeconds;
                }
                seconds.html(initSeconds);
                if(initSeconds<=0){
                    clearInterval(countDown);
                    pageWillReload.remove();
                }
            }, 1000);

            pageWillReload = $('<div/>',{
                class: 'd-flex justify-content-center mt-3 font-weight-bold',
                html: ['This page will reload in ',seconds,' seconds.']
            });
        }


        let reloadAction = $('<button/>', {
            class: 'btn btn-rounded kino-btn-primary mt-2',
            html: 'Reload',
            style: 'min-width: 100px',
        }).on('click', function () {
            location.reload();
        });

        let actionContainer = $('<div/>', {
            class: 'message-actions text-center',
            html: [reloadAction, type == 'reconnect' ? pageWillReload : ''],
        });

        let downloadSectionTitle = $('<h3/>',{
            class: 'd-flex justify-center align-items-center',
            html: 'Download our desktop app'
        });

        let downloadSectionHeadline = $('<div/>',{
            class: 'd-flex mt-4 mb-3 text-bold justify-content-center',
            html: 'Still having an issue?'
        });


        let windowsImage = $('<div/>',{
            class: 'mb-2',
            alt: 'Windows image',
            html: app.windowsLogo
        })

        let macImage = $('<div/>',{
            class: 'mb-2',
            alt: 'Apple image',
            html: app.appleLogo
        })

        let downloadForWindows = $('<a/>',{
            class: 'd-flex flex-column align-items-center text-center',
            href: '/downloads/kino-setup.exe?referral=errorPage',
            'rel': 'noopener',
            style: 'color: #000; font-weight: 600',
            html: [windowsImage, 'Windows']
        });

        let downloadForMac = $('<a/>',{
            class: 'd-flex flex-column align-items-center text-center',
            href: '/downloads/kino-setup.dmg?referral=errorPage',
            'rel': 'noopener',
            style: 'color: #000; font-weight: 600',
            html: [macImage, 'Mac']
        });

        let downloadIcons = $('<div/>', {
            class: 'd-flex justify-content-center mt-2',
            style: 'gap: 5rem;',
            html: [downloadForWindows, downloadForMac]
        })

        let downloadContainerWeb = $('<div/>', {
            class: 'd-flex flex-column',
            html: [downloadSectionTitle, downloadIcons]
        });

        let kinoLink = $('<a/>',{
            class: 'd-flex',
            href: `https://kino.live/${room.getName()}`,
            html: 'Click here to open this Kino with your browser',
            style: 'color: #032836; font-weight: 500'
        });

        let downloadContainerDesktop = $('<div/>', {
            class: 'd-flex flex-column',
            html: [kinoLink]
        });

        let messageBox = $('<div/>', {
            class: 'message-box',
            html: [messageContent, actionContainer, messageRecommendations, downloadSectionHeadline, isElectron ? downloadContainerDesktop : downloadContainerWeb],
        });

        let errorOverlay = $('<div/>', {
            class: 'error-message-overlay',
            html: [messageBox],
        });

        if (type == 'reconnect') {
            clearTimeout(app.reconnectTimeout);

            app.reconnectTimeout = setTimeout(function () {
                location.reload();
            }, 15000);
        } else if (type == "leave") {
            unload('client_reconnect_error');
        }
        $('body').append(errorOverlay);
    };

    preventToolBoxHide() {
        var app = this;
        clearTimeout(app.toolBoxTimeout);
    };

    startToolBoxTimeout(timeout = 5000) {
        var app = this;
        /*if (!app.toolBoxShown) {
                   app.showToolBox();
               }*/
        app.preventToolBoxHide();
        app.toolBoxTimeout = setTimeout(function () {
            console.log('mouse not moving');
            $('#shareMenu').addClass('hidden').removeClass('shown');
            app.hideToolBox();
        }, timeout);
    };

    nonDraggableVideo() {
        var app = this;
        app.localVideo.wrapper.off('mousedown');
        app.restVideoPosition();
    };
    restVideoPosition() {
        var app = this;
        app.localVideo.viewContainer.removeClass('floating');
        app.localVideo.viewContainer.css({
            top: 'unset',
            left: 'unset',
        });
    };

    floatingVideo() {
        var app = this;
        if (!app.localVideo.viewContainer.hasClass('floating')) {
            let offset = app.localVideo.viewContainer.offset();
            app.localVideo.viewContainer.addClass('floating').css({
                top: offset.top + 'px',
                left: offset.left + 'px',
            });
        }
    };
    draggableVideo() {
        var app = this;
        app.localVideo.wrapper.on('mousedown', function (e) {
            app.startDragVideo(e);
        });
    };

    dragVideo(e) {
        var app = this;
        if (app.isDragging) {
            e = e || window.event;
            e.preventDefault();
            let offset = app.localVideo.viewContainer.offset();
            // console.log(offset);
            let mouseX = app.mousePosition.x - e.clientX;
            let mouseY = app.mousePosition.y - e.clientY;
            // calculate the new cursor position:

            app.mousePosition.x = e.clientX;
            app.mousePosition.y = e.clientY;

            let moveX = offset.left - mouseX;
            let moveY = offset.top - mouseY;

            // set the element's new position:
            app.localVideo.viewContainer.css({
                top: moveY + 'px',
            });
            app.localVideo.viewContainer.css({
                left: moveX + 'px',
            });
        }
    };

    startDragVideo(e) {
        var app = this;
        app.isDragging = true;
        app.mousePosition.x = e.clientX;
        app.mousePosition.y = e.clientY;
        app.floatingVideo();
        app.dragVideo(e);
    };

    stopDragVideo(e) {
        var app = this;

        if (app.isDragging) {
            let offset = app.localVideo.viewContainer.offset();
            let mouseX = app.mousePosition.x - e.clientX;
            let mouseY = app.mousePosition.y - e.clientY;
            // calculate the new cursor position:

            app.mousePosition.x = e.clientX;
            app.mousePosition.y = e.clientY;
            let moveX = offset.left - mouseX;
            let moveY = offset.top - mouseY;

            let horizontal = 'right';
            let vertical = 'bottom';

            if (moveX > app.window.width / 2) {
                horizontal = 'right';
            } else {
                horizontal = 'left';
            }

            if (moveY > app.window.height / 2) {
                vertical = 'bottom';
            } else {
                vertical = 'top';
            }

            let videoClass = horizontal + '-' + vertical;

            // set the element's new position:
            app.localVideo.viewContainer.attr('style', '');
            app.localVideoContainer.removeClass('right left').addClass(horizontal);
            app.localVideo.viewContainer
                .removeClass('floating right-top right-bottom left-top left-bottom')
                .addClass(videoClass);
            app.isDragging = false;
        }
    };

    toggleFullScreen(button) {
        // ## The below if statement seems to work better ## if ((document.fullScreenElement && document.fullScreenElement !== null) || (document.msfullscreenElement && document.msfullscreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        const elem=document.documentElement;
        if (
            (document.fullScreenElement !== undefined &&
                document.fullScreenElement === null) ||
            (document.msFullscreenElement !== undefined &&
                document.msFullscreenElement === null) ||
            (document.mozFullScreen !== undefined && !document.mozFullScreen) ||
            (document.webkitIsFullScreen !== undefined &&
                !document.webkitIsFullScreen)
        ) {
            if (elem.requestFullScreen) {
                elem.requestFullScreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullScreen) {
                elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            }
            $('#windowFullScreenIcon').html('<i class="icofont-interface"></i>');
            $('#windowFullScreenDesc').html('Window Mode');
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            $('#windowFullScreenIcon').html('<i class="icofont-expand"></i>');
            $('#windowFullScreenDesc').html('Full Screen');
        }
    };

    showNotification(
        icon,
        text = '',
        type = 'wave',
        participant = '',
        onSuccess = false,
        onDecline = false
    ) {
        var app = this;
        if(!isJoined){return}
        if($(`#${type}-${participant}`)){
          $(`#${type}-${participant}`).remove();
        }

        let icondiv = $('<div/>', {
          class: 'icon',
          html: icon,
        });
        let action = '';
        let action2 = '';
        let dismiss='';
        let space = '&nbsp;';
        let notificationTimeout = 15000;
        let countDown = null;
        let supNotification = '';
        let explainerSection = '';

        let closediv = $('<div/>', {
            class: 'close',
            html: `<i class="icofont-close icofont-1x"></i>`,
        });

        if (type == 'focusBack') {
            text = `${app.videos[participant].displayName} focused on you`;

            action = $('<button/>', {
                class: 'btn btn-sm btn-light btn-rounded mr-1',
                html: 'Focus Back',
            }).on('click', function () {
                let pRole = room.getParticipantById(participant).getProperty("role");
                let isMod = false;
                if(pRole == 'moderator' || pRole == 'host'){
                    isMod = true;
                }
                //check if on stage is active
                if(onStage.isActive()){
                    onStage.showLockOnStageActiveNotification();
                    return;
                }
                //lock focus
                if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                    lockFocus.showLockFocusNotification();
                    return;
                }
                app.videos[participant].focusButton.addClass('active');
                // app.videos[participant].focusButton.attr('title', 'Unfocus');
                // app.videos[participant].focusButton.attr(
                //     'data-original-title',
                //     'Unfocus'
                // );
                app.focusVideo(participant);
                closediv.click();
            });

            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click',()=>{
                closediv.click();
            });

            icon = app.focusIcon;
        } else if (type == 'wave') {
            if (app.videos[participant] !== undefined) {
                let showaction=true;
                if(typeof CONV_STORAGE !== 'undefined'){
                    let convid=CONV_STORAGE.isOnConversation(participant);
                    if((convid > 0) && (convid==CONV_STORAGE.myConversation)){
                        notificationTimeout = 5000;
                        showaction=false;
                    }
                }
                if(showaction){
                    action = $('<div/>', {
                        class: 'btn btn-sm btn-light btn-rounded mr-1',
                        html: `Go to ${app.videos[participant].displayName.slice(0, 8)}${app.videos[participant].displayName.length > 8 ? "..." : ""}`,
                    }).on('click', function () {
                        //check if on stage is active
                        if(onStage.isActive()){
                            onStage.showLockOnStageActiveNotification();
                            return;
                        }
                        //lock focus
                        if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                            lockFocus.showLockFocusNotification();
                            return;
                        }

                        const p = kinoParticipants.get(participant)

                        const space = CONV_STORAGE.getSpace(p.getSpaceId())


                        if(space){
                            space.onJoinSpace()
                        }else {
                            CONV_STORAGE.leaveSpace()
                            closediv.click();
                        }

                        // if (app.videos[participant]) {
                        //     app.videos[participant].focusButton.addClass('active');
                        //     // app.videos[participant].focusButton.attr('title', 'Unfocus');
                        //     // app.videos[participant].focusButton.attr(
                        //     //     'data-original-title',
                        //     //     'Unfocus'
                        //     // );
                        //     // app.videos[participant].focusButton.tooltip('hide');
                        //     app.focusVideo(participant);
                        //     closediv.click();
                        // }
                    });
                }

                dismiss = $('<button/>', {
                    class: 'btn btn-sm btn-outline-danger btn-rounded',
                    html: 'Dismiss',
                }).on('click',()=>{
                    closediv.click();
                });
            }
        } else if (type == 'moderator') {
            notificationTimeout = 5000;
        }  else if (type == "lockFocusNotification") {
            notificationTimeout = 5000;
            explainerSection = $('<span/>', {
                class: 'text-sup-container-explainer',
                html: `Moving between spaces is ${onSuccess ? 'unavailable' : 'available'}`
            })
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click', () => {
                closediv.click();
            });
        }  else if (type == "recording") {
            notificationTimeout = 5000;
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click', () => {
                closediv.click();
            });
        }else if (type == "recording-merge") {
            notificationTimeout = 10000;
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click', () => {
                closediv.click();
            });
        }else if (type == "stealFocusNotification") {
            notificationTimeout = 5000;
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click', () => {
                closediv.click();
            });
        }else if (type == 'timer'){
            let playSound = participant;
            notificationTimeout = 5000;

            supNotification = $('<span/>', {
                class: 'timer-notification-sup',
                html: 'This message is only visible to moderators',
            });

            if(playSound){
                try {app.sounds.play('wave2');}catch(e){}
            }
            text;
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click', () => {
                closediv.click();
            });
        }else if (type == 'timer_ending'){
            // console.error(text);
            let initSeconds = text ? text.showNotifAt : null;
            console.log('Init seconds: ',initSeconds)
            notificationTimeout = initSeconds ? initSeconds > 10 ? 10000 : initSeconds+'000' : null;

            if(text && text.playSound){
                try {app.sounds.play('wave2');}catch(e){}
            }
            if(!notificationTimeout){
                clearInterval(countDown);
                notificationTimeout = 100;
                return;
            }
            if(initSeconds < 10){
                initSeconds = "0"+initSeconds;
            }
            let secondOrMinute = $('<span/>',{
                html: initSeconds > 59 ? 'minutes' : 'seconds',
            });
            let seconds = $("<span/>",{
                html: [kinoTimer.secondsToTime(initSeconds).m +':'+ kinoTimer.secondsToTime(initSeconds).s]
            });
            countDown = setInterval(() => {
                initSeconds--;
                if(initSeconds < 10){
                    initSeconds = "0"+initSeconds;
                }
                if(initSeconds > 59){
                    secondOrMinute.html('minutes')
                }else{
                    secondOrMinute.html('seconds')
                }
                seconds.html(kinoTimer.secondsToTime(initSeconds).m +':'+ kinoTimer.secondsToTime(initSeconds).s);
                setTimeout(()=>{
                    clearInterval(countDown);
                },10000)
            }, 1000);

            text = $('<span/>', {
                html: [`Countdown is about to end in `,seconds,` `,secondOrMinute]
            });
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click', () => {
                closediv.click();
            });
        }else if(type=="unmute-request"){

            //mute unlock request
            action = $('<div/>', {
                class: 'btn btn-sm btn-light btn-rounded mr-1',
                html: `Allow`,
            }).on('click',()=>{
                if(onSuccess){
                    closediv.click();
                    onSuccess();
                }
            });



            notificationTimeout = 15000;
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click', () => {
                closediv.click();
            });
        }else if(type=="unmute-request-accepted"){

            //mute unlock request
            action = $('<div/>', {
                class: 'btn btn-sm btn-light btn-rounded mr-1',
                html: `Unmute`,
            }).on('click',()=>{
                if(onSuccess){
                    closediv.click();
                    onSuccess();
                }
            });



            notificationTimeout = 15000;
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click', () => {
                closediv.click();
            });
        }else if(type=="mute-lock"){

            notificationTimeout = 5000;
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click', () => {
                closediv.click();
            });
        }else{
            notificationTimeout = 5000;
            dismiss = $('<button/>', {
                class: 'btn btn-sm btn-outline-danger btn-rounded',
                html: 'Dismiss',
            }).on('click', () => {
                closediv.click();
            });
        }

        let textdiv = $('<div/>', {
            class: 'text',
            html: [text, space, space, action, space, action2 , action2 ? space : ''],
            html: [text, space, action, space],
        });
        let textSupDiv = $('<div/>', {
            class: 'text-sup-container',
            html: [supNotification, explainerSection, textdiv],
        });
        let container = $('<div/>', {
            class: `notificationContent ${type}-notification-${participant}`,
            id: `${type}-${participant}`,
            html: [icondiv, textSupDiv, dismiss, closediv],
        }).on('click', function(e){
            e.stopPropagation();
        });
        let timeout = setTimeout(function () {
            app.hideNotification(container);
        }, notificationTimeout);
        closediv.on('click', function (e) {
            e.stopPropagation();
            clearTimeout(timeout);
            app.hideNotification(container);
        });
        container.appendTo(app.notifications);
    };

    hideNotification(notification) {
        $(notification).remove();
    };
    flipLocalVideo() {
        var app = this;
        app.localVideo.wrapper.find("video").addClass("flipVideoX");
    };

    unFlipLocalVideo() {
        var app = this;
        app.localVideo.wrapper.find("video").removeClass("flipVideoX");
    };

    addLocalVideo() {
        var app = this;
        if (app.localVideo.viewContainer !== undefined) {
            return 0;
        }
        let video = {};
        video.wrapper = $('<div/>', {
            class: 'videoWrapper',
            html:[`<video autoplay class='${cameraOptionsPreferences.camera_flip ? 'flipVideoX' : ''}' id='localVideo1' playsinline />`]
        });
        video.audios = {
            slider: false,
            file: false,
        };
        video.audioWrapper = $('<div/>', {
            class: 'audioWrapper',
        });
        video.pipButton = $("<span/>", {
            class: "kinetx-icon",
            html: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"/></svg>               `,
            id: "togglePIP"
        }).on("click", function (e) {
            if (app.pipMode) {
                app.stopPiP();
            } else {
                var user = document.getElementById('localPresenterVideo');
                app.playPIP(user);
            }
        })
        video.presenterElements = $('<div/>', {
            class: 'presenterElements',
            style: 'display:none',
            html: [`<video id="localPresenterVideo" width="250" autoplay></video>`, video.pipButton]
        });
        video.minimize = $('<div/>', {
            class: 'toolbar-icon button-dark mr-1 svg-20 maximize-local',
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            title: 'Minimize',
            html: app.minimizeIcon,
        }).on('click', function () {
            if (app.isLocalMaximized) {
                $(this).attr('title', 'Maximize');
                $(this).attr('data-original-title', 'Maximize');
                // $(this).tooltip('hide');
                app.localVideoMinimize();
            } else {
                $(this).attr('title', 'Minimize');
                $(this).attr('data-original-title', 'Minimize');
                // $(this).tooltip('hide');
                app.localVideoMaximize();
            }
        });
        video.noLocalVideo = () =>{
            let isMuted = video.cameraMutedByMe;
            let p = kinoParticipants.me();
            if(isMuted && !app.isSharingScreen){
                video.userName.html(MY_NAME);
                video.noLocalCameraLayer.removeClass('d-none');

            if(p && p.noCameraLayerThumb){
                p.noCameraLayerThumb.removeClass('d-none');
            }
            if(p && p.menuNoCameraLayerThumb){
                p.menuNoCameraLayerThumb.removeClass('d-none');
            }
            }else{
                video.noLocalCameraLayer.addClass('d-none');
                if(p && p.noCameraLayerThumb){
                    p.noCameraLayerThumb.addClass('d-none');
                }
                if(p && p.menuNoCameraLayerThumb){
                    p.menuNoCameraLayerThumb.addClass('d-none');
                }
            }
        }
        video.noCameraImage=$('<div/>',{
            class: 'no-cam-layer-background mb-2',
            html: this.noCameraIcon
        });
        video.userName=$('<span/>',{
            class: 'no-cam-layer-name ellipsis',
            html: MY_NAME
        });
        video.noCameraMessage=$("<div/>",{
            class:'no-cam-message d-none',
            html:''
        });
        video.noCameraIconContainer=$("<div/>",{
            class:'no-cam-icon-container',
            html:[video.noCameraImage]
        });
        video.noLocalCameraLayer=$("<div/>",{
            class:"no-camer-layer-thumbnail d-none",
            html:[video.noCameraIconContainer, video.userName,video.noCameraMessage]
        });



        video.cameraMuted = $('<span/>',{
            class: "in-video-camera-muted cursor-pointer",
            title: "Unmute Camera",
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            html: app.cameraMutedIcon
        }).on('click', function(){
            unMuteCamera();
        });
        video.micMuted = $('<span/>', {
            class: 'in-video-mic-muted cursor-pointer',
            title: "Unmute Mic",
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            html: app.micMutedIcon
        }).on('click', function(){
            if(!muteAll.isUnmuteAllowed()){
                muteAll.showMuteLockedTooltip();
            }else{
                unMuteMic();
                muteAll.hideTooltip();
            }
        });
        video.emptyDiv = $('<div/>',{
            html: ''
        });
        video.bottomToolbar = $('<div/>', {
            class: 'toolbar-bottom',
            html: [video.emptyDiv]
        });
        video.nameContainer = $('<div/>', {
            class: 'display-name-container',
            html: `<span>${MY_NAME} (me)</span>`,
        });
        video.stats={
            quality:'excellent',
            video:{
                upload:0,
                download:0
            },
            audio:{
                upload:0,
                download:0
            },
            resolution:'N/A',
            region:'N/A',
            server_count:"N/A",
            framerate:"N/A"
        };

        tippy(video.nameContainer[0],{
            content:'',
            placement: 'bottom-start',
            allowHTML: true,
            theme:'light',
            arrow:false,
            zIndex: 9999
        });

        video.topToolBarLeft = $('<div/>',{
            class: 'video-top-toolbar-left',
            html: [video.nameContainer, video.micMuted, video.cameraMuted, ]
        })

        video.optionsMenuBtn=$('<div/>', {
            class: 'toolbar-icon button-dark svg-20',
            html: app.optionsIcon,
        });
        const menu=``;
        tippy(video.optionsMenuBtn[0],{
            content:menu,
            trigger: 'click',
            placement: 'bottom-end',
            allowHTML: true,
            theme:'light',
            arrow:false,
            zIndex: 900,
            interactive:true,
            appendTo: () => document.body,
            onShow(instance) {
                app.renderLocalParticipantMenu()
            }
        });
        // video.announceShortcut = $('<div/>', {});
        // video.hiddenLocalVideoIcons = $('<div/>',{
        //     class: 'video-top-toolbar-hidden-icons',
        //     html: [video.muteMyself, video.announceShortcut, video.pullFocusToUser]
        // })
        video.topToolBarRight = $('<div/>',{
            class: 'video-top-toolbar-right',
            html: [video.minimize,video.optionsMenuBtn]
        })
        video.topToolBar = $('<div/>', {
            class: 'video-top-toolbar',
            html: [video.topToolBarLeft, video.topToolBarRight],
        });
        video.background = $('<div/>', {
            class: 'videoContainerBackground',
        });
        video.overlay = $('<div/>', {
            class: 'video_overlay',
        });
        video.viewContainer = $('<div/>', {
            class: 'videoViewContainer',
            id: 'localParticipant',
            html: [
                video.background,
                video.wrapper,
                video.noLocalCameraLayer,
                video.audioWrapper,
                video.overlay,
                video.presenterElements,
                video.bottomToolbar,
                video.topToolBar,
            ],
        });

        //save object
        app.localVideo = video;
        app.renderLocalStats()
        app.appendVideo('local', true);
    };

    playPresenter(userTrack) {
        var app = this;
        app.presenterTrack = userTrack;
        console.log("play presenter mode");
        app.localVideo.presenterElements.css("display", "flex");
        var user = document.getElementById('localPresenterVideo');
        user.classList.add("presenterActive");
        userTrack.attach(user);
        user.play();

        user.addEventListener('loadedmetadata', function () {
            app.playPIP(user);
        });
        return user;

    };

    playPIP(video) {
        var app = this;
        try {


            if (!('pictureInPictureEnabled' in document)) {
                console.log('The Picture-in-Picture Web API is not available.');
            } else if (!document.pictureInPictureEnabled) {
                console.log('The Picture-in-Picture Web API is disabled.');
            }

            if (video !== document.pictureInPictureElement) {
                video.requestPictureInPicture();
                video.addEventListener('enterpictureinpicture', (event) => {
                    app.pipMode = true;
                    app.localVideo.presenterElements.css("display", "none");
                    console.log(event.pictureInPictureWindow);
                });
                video.addEventListener('leavepictureinpicture', (event) => {

                    if (app.isSharingScreen && !deviceManager.mutedWhileSharingScreen) {
                        app.localVideo.presenterElements.css("display", "flex");
                    }
                    app.pipMode = false;
                });

            } else {
                //disable pip
            }
        } catch (e) {
            console.log(e);
        } finally {
            app.pipMode = false;
        }

    };

    stopPiP() {
        var app = this;
        try {
            app.localVideo.presenterElements.css("display", "none");
            if (document.pictureInPictureElement) {
                //exit from picture in picture mode
                document.exitPictureInPicture();
                app.pipMode = false;
            }
        } catch (e) {
            app.pipMode = false;
        }
    };

    stopPresenter() {
        var app = this;
        app.stopPiP();
        if (app.presenterTrack) {
            app.presenterTrack.getTrack().stop();
        }

        app.localVideo.presenterElements.css("display", "none");
        var user = document.getElementById('localPresenterVideo');
        user.classList.remove("presenterActive");

        if (!user.srcObject) {
            return;
        }

        user.srcObject.getVideoTracks().forEach(track => {
            track.stop()
            user.srcObject.removeTrack(track);
        });
        user.srcObject=null;//card 556
        user.load();//card 556
    };

    changePresenterStream(newStream) {
        let app = this;
        app.presenterTrack = newStream;
        var user = document.getElementById('localPresenterVideo');
        if (!user.srcObject) {
            return;
        }

        user.srcObject.getVideoTracks().forEach(track => {
            track.stop()
            user.srcObject.removeTrack(track);
        });
        newStream.attach(user);
        user.play();

    };



    localVideoMaximize () {
        var app = this;
        console.trace("Maximize local video");
        $('#app').removeClass('local-minimized');
        app.localVideo.viewContainer.appendTo(app.remoteVideosContainer);
        app.localVideo.minimize.attr('title', 'Minimize');
        app.localVideo.minimize.attr('data-original-title', 'Minimize');
        // app.localVideo.minimize.tooltip('hide');
        app.localVideo.minimize.html(app.minimizeIcon);
        app.isLocalMaximized = true;
        app.nonDraggableVideo();
        app.isOnlyOne();
        app.resizeMainVideos();
    };

    localVideoMinimize () {
        var app = this;
        // console.error("Minimize local video",app.isLocalMaximized);
        app.localVideo.viewContainer.appendTo(app.localVideoContainer);
        app.localVideo.viewContainer.attr('style', '');
        app.localVideo.minimize.attr('title', 'Maximize');
        app.localVideo.minimize.attr('data-original-title', 'Maximize');
        // app.localVideo.minimize.tooltip('hide');
        //always show maximize icon when minimized
        app.localVideo.minimize.css("display","flex");
        app.localVideo.minimize.html(app.maximizeIcon);
        $('#app').addClass('local-minimized');
        app.isLocalMaximized = false;
        app.draggableVideo();
        app.isOnlyOne();
        app.resizeMainVideos();
    };


    getForwardedParticipants(){
        try {
            const forwardedSources=room.getForwardedSources();
            return forwardedSources.map(str => str.replace(/-v\d+$/, ''));
        } catch (error) {
            return []
        }
    }

    isForwarded(pid){
        return this.getForwardedParticipants().includes(pid);
    }

    addVideo(participant, displayName) {
        var app = this;
        kinoParticipants.addParticipant(new Participant(participant,displayName));
        console.log("All participants",kinoParticipants.getParticipants());
        if (app.videos[participant]) {
            return;
        }
        let video = {};
        //begin card 584
        let mediaElement=document.createElement('video');
        mediaElement.setAttribute("autoplay",1);
        mediaElement.id=`${participant}-media-player`;

        mediaElement.onplaying = (event) => {
            console.log(displayName+" started playing.");
            video.hideLoadingSpinner();
            if(video.waitingForScreen){
                removeScreenshareLayer();
            }
            if(video.viewContainer.hasClass("no-camera") && !video.isVideoMuted()){
                video.onVideoUnmuted();
            }
        };
        //begin card 808
        mediaElement.oncanplay=(event)=>{
            mediaElement.play();
            this.removeInformativeLayer(participant);
            animatedLayers.removeIsJoiningLayer(participant);
        };
        let audioPlayer=document.createElement('audio');
        audioPlayer.setAttribute("autoplay",1);
        audioPlayer.id=`${participant}-audio-player`;
        audioPlayer.oncanplay=(event)=>{
            // console.log('Audio player for '+participant+' is ready to play',event);
            audioPlayer.play();
            animatedLayers.removeIsJoiningLayer(participant);
        };


        video.skipEfss=false;
        video.isSharingScreen=false;
        video.player=mediaElement;
        video.audioPlayer=audioPlayer;
        video.onPrivateSpaceStarted=()=>{
            try {
                console.trace("On private space started",video);
                video.player.style.display="none";
                video.player.pause();
                video.onVideoUnmuted();
                video.audioPlayer.pause();
                app.splitConversations.videoPauseChange(participant,true)
            } catch (error) {}
        };

        video.onPrivateSpaceEnded=()=>{
            try {
                try {
                    video.player.style.display="block";
                    video.player.play();
                    if(video.isVideoMuted()){
                        video.onVideoMuted();
                    }
                    video.audioPlayer.play();
                    app.splitConversations.videoPauseChange(participant,false)
                } catch (error) {}
            } catch (error) {}
        };
        video.tracks=[];
        video.videoSuspendedTimeout=0;
        video.loadingSpinnerTimeout=0;
        video.videoWillMute=()=>{
            let showLayerDelay=video.isVideoMuted() ? 0 : 1500;
            if(app.videos[participant].disconnectTimer){
                showLayerDelay=6000;
            }
            clearTimeout(video.videoSuspendedTimeout);
            video.isVideoMuted() || video.showLoadingSpinner();
            video.videoSuspendedTimeout=setTimeout(video.onVideoMuted,showLayerDelay);
        };

        video.isInPrivateSpace=()=>{
            if(!CONV_STORAGE){return false}
            let cid=CONV_STORAGE.isOnConversation(participant);
            if(!cid || cid==CONV_STORAGE.myConversation){return false}
            if(CONV_STORAGE.conversations[cid] && CONV_STORAGE.conversations[cid].is_private){
                return true
            }
            return false;
        };
        video.isVideoMuted=()=>{
            try{
                let isMuted=video.cameraMutedByUser;
                if(isMuted){
                    return true;
                }else{
                    return false;
                }
            }catch(e){
                return true;
            }
        };
        video.isVideoMutedByError=()=>{
            const videoTrack=getRemoteParticipantMainVideoTrack(participant);
            const suspended = videoTrack && (videoTrack.status == STREAMING_STATUS.INTERRUPTED || videoTrack.status == STREAMING_STATUS.INACTIVE);
            return !video.isVideoMuted() && !video.isInPrivateSpace() && suspended && video.hasVideoTracks() && isEndpointVisible(participant);
        };
        video.hasVideoTracks=()=>{
            let tracks=room.getParticipantById(participant).getTracksByMediaType('video');
            if(tracks && tracks.length > 0){
                return true;
            }else{
                return false;
            }
        };
        video.waitingForScreenShareTimer=0;
        video.waitingForScreenVideoTimer=0;
        video.waitingForScreen=false;
        video.hasDesktopTrack=false;
        // video.blurEffect=null;
        video.sharingScreenEvent=(event)=>{
            console.log("screenshare event",event);
            onStage.onScreenShare(participant,event)
            if(event=="started"){
                video.isSharingScreen=true;
                if(video.isInPrivateSpace()){
                    return;
                }
                video.waitingForScreen=true;
                video.viewContainer.addClass("sharing-screen");
                // video.onVideoUnmuted();
                app.informativeOverlayParticipant(participant, 'Activating screen share')
                clearTimeout(video.waitingForScreenShareTimer);
                video.waitingForScreenShareTimer=setTimeout(() => {
                    video.waitingForScreen=false;
                    app.removeInformativeLayer(participant);
                    video.onVideoMuted();
                }, 15000);
            }else{
                video.isSharingScreen=false;
                if(video.isInPrivateSpace()){
                    return;
                }
                video.waitingForScreen=false;
                video.viewContainer.removeClass("sharing-screen");
                app.informativeOverlayParticipant(participant, 'Stoping screen share')
                clearTimeout(video.waitingForScreenShareTimer);
                video.waitingForScreenShareTimer=setTimeout(() => {
                    app.removeInformativeLayer(participant);
                }, 800);
            }
        }
        video.videoTypeChanged=(videotype)=>{
            console.log(video.displayName+" video type changed to "+videotype)
            video.hasDesktopTrack=videotype==MEDIA_TYPE.DESKTOP;
            clearTimeout(video.waitingForScreenShareTimer);
            clearTimeout(video.waitingForScreenVideoTimer);
            video.waitingForScreenVideoTimer=setTimeout(() => {
                video.waitingForScreen=false;
                app.removeInformativeLayer(participant);
            }, 5000);
            if(video.hasDesktopTrack){
                app.updateOverlayText(participant,`Getting ${video.displayName} screen`);
                if(!video.isVideoMutedByError()){
                    video.onVideoUnmuted();
                }
                 video.waitingForScreenShareTimer=setTimeout(() => {
                    if(video.isVideoMutedByError()){
                        video.onVideoMuted();
                    }
                 }, 2000);
            }
        };


        video.isVideoSuspendedBySender=()=>{
            try {
                const connectionStatus=room.getParticipantById(participant).getStatus();
                const stats = video.stats;
                const localStats= this.localVideo.stats;
                if(connectionStatus == "inactive"
                || (stats.quality=='low' || stats.video.upload == 0) && (localStats && localStats.connectionQuality > 20)){
                    return true;
                }
                return false
            } catch (error) {
                return false
            }
        };

        video.onVideoMuted=()=>{
            //add a no-video image
            if(!showCameraLayerWhenAppMinimized(participant) && !video.isVideoMuted()){
                return
            }
            if(video.isInPrivateSpace() || video.waitingForScreen || (!isEndpointVisible(participant) && !video.isVideoMuted())){
                video.onVideoUnmuted()
                return
            }
            console.trace("Video has been suspended")

            video.noCameraLayer.removeClass('d-none');
            video.viewContainer.addClass("no-camera");
            let p = kinoParticipants.get(participant);
            if(p && p.noCameraLayerThumb){
                p.noCameraLayerThumb.removeClass('d-none');
            }
            if(p && p.menuNoCameraLayerThumb){
                p.menuNoCameraLayerThumb.removeClass('d-none');
            }
            screenShare.popup.cameraMuteChanged(participant,true);

            spacesView.updateNoCameraLayerThumbnail(p,false)

            //uncomment this for new design from victor
            if(video.isVideoMutedByError()){
                video.noCameraLayer.addClass("error-message");
                const senderSuspended = video.isVideoSuspendedBySender() || this.isForwarded(participant);
                const message=senderSuspended ? `${video.displayName} connection is unstable, the video is paused.` : `This video has been suspended due to issues with your connection`
                video.noCameraMessage.html(message);
                video.noCameraMessage.removeClass('d-none');
            }else{
                video.noCameraLayer.removeClass("error-message");
                video.noCameraMessage.html("");
                video.noCameraMessage.addClass('d-none');

            }
        };
        video.onVideoUnmuted=()=>{
            //remove no-video image
            //stop all mute timeouts
            console.trace("Video has been resumed")
            clearTimeout(video.videoSuspendedTimeout);
            video.noCameraLayer.addClass('d-none');
            video.viewContainer.removeClass("no-camera");
            screenShare.popup.cameraMuteChanged(participant,false);
            clearTimeout(video.waitingForScreenShareTimer);
            let p = kinoParticipants.get(participant);
            if(p && p.noCameraLayerThumb){
                p.noCameraLayerThumb.addClass('d-none');
            }
            if(p && p.menuNoCameraLayerThumb){
                p.menuNoCameraLayerThumb.addClass('d-none');
            }
            video.hideLoadingSpinner();
            spacesView.updateNoCameraLayerThumbnail(p,true)
        };

        video.noCameraImage=$('<div/>',{
            class: 'no-cam-layer-background mb-2',
            html: this.noCameraIcon
        });
        video.userName=$('<span/>',{
            class: 'no-cam-layer-name ellipsis',
            html: displayName
        });
        video.noCameraMessage=$("<div/>",{
            class:'no-cam-message d-none',
            html:''
        })
        video.noCameraIconContainer=$("<div/>",{
            class:'no-cam-icon-container',
            html:[video.noCameraImage]
        });
        video.noCameraLayer=$("<div/>",{
            class:"no-camer-layer-thumbnail d-none",
            html:[video.noCameraIconContainer, video.userName,video.noCameraMessage]
        });
        //end card 584
        video.displayName = displayName;
        video.reconnectTimeout = 0;
        video.isRecording = false;
        video.focusButton = $('<div/>', {
            class: 'toolbar-icon button-dark mt-1',
            html: app.focusIcon,
        }).on('click', function () {
            //check if on stage is active
            if(onStage.isActive()){
                onStage.showLockOnStageActiveNotification();
                return;
            }
            //lock focus
            if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                lockFocus.showLockFocusNotification();
                return;
            }
            if (app.focused[participant] || kinoParticipants.isInMySpace(participant)) {
                // $(this).tooltip('hide');
                app.unFocusVideo(participant,true);
            } else {
                // $(this).tooltip('hide');
                app.focusVideo(participant);
                try {
                    $('#focusBack-' + participant).remove();
                } catch (e) {}
            }
        });
        tippy(video.focusButton[0],{
            content:"Focus",
            placement:'right',
            arrow:false,
            onShow:(i)=>{
                if(app.focused[participant] || kinoParticipants.isInMySpace(participant)){
                    i.setContent('Unfocus');
                }else{
                    i.setContent('Focus');
                }
            }
        });
        // video.kickUser = $("<span/>", {});
        video.notificationBar = $('<div/>', {
            class: 'notificationsBar',
        });
        // video.makeModerator = $("<span/>", {});
        console.log("Is moderator ? : " + MODERATORS.includes(participant))
        video.isModerator = MODERATORS.includes(participant);

        //mute participant
        video.muteUser = $("<span/>", {});
        video.showMuteButton=()=>{

        };
        video.hideMuteButton=()=>{

        };

        if(muteParticipants.canIMuteParticipant(participant)){
            video.showMuteButton();
        }

        //Pull focus on the tile
        // video.pullFocusToUser = $('<span/>',{});
        video.showPullFocusButton=()=>{

        }

        video.hidePullFocusButton=()=>{

        };

        // if is host
        let enabled = video.isModerator && !permissions.isWorkspace ? "enabled" : '';
        video.moderatorBadge=$('<span/>', {
            class: `icon-badge ${enabled ? '' : 'd-none'}`,
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            title: 'Moderator',
            'data-original-title': '',
            html: app.makeModeratorIcon,
        })

        video.recordingIndicator = $("<div/>", {
            class: "icon-badge rec-indicator is-host",
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            title: `${video.displayName} is recording this Kino`,
            html: app.recIcon
        });

        video.streamingIndicator = $("<div/>", {
            class: "icon-badge streaming-indicator",
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            title: `${video.displayName} is streaming this Kino`,
            html: app.recIcon
        });

        // video.recordingIndicator.tooltip();
        video.loadingVideo=$("<div/>",{
            class:'loading-video-spinner d-flex w-100 justify-content-center align-items-center',
            html:`<div class="spinner-border text-white mb-0" role="status">
            </div>`
        });

        video.hideLoadingSpinner=()=>{
            console.trace("Remove spining layer")
            clearTimeout(video.loadingSpinnerTimeout);
            video.loadingVideo.addClass('d-none').removeClass('d-flex');
        }
        video.showLoadingSpinner=()=>{
            video.loadingVideo.removeClass('d-none').addClass('d-flex');
            console.log("Show loading spinner",participant)
            video.loadingSpinnerTimeout=setTimeout(() => {
                const videoTrack = getRemoteParticipantMainVideoTrack(participant);
                console.log("Try to remove loading spinner, track status",videoTrack?.status);
                if(videoTrack && videoTrack.status !== STREAMING_STATUS.INTERRUPTED){
                    // console.log("Participant video track ",videoTrack.kinoTrack);
                    video.hideLoadingSpinner();
                }
            }, 5000);
        }

        video.wrapper = $('<div/>', {
            class: 'videoWrapper',
            html:[video.player,video.loadingVideo,video.noCameraLayer]//card 584
        }).dblclick(function () {
            //check if on stage is active
            if(onStage.isActive()){
                onStage.showLockOnStageActiveNotification();
                return;
            }
            //lock focus
            if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                lockFocus.showLockFocusNotification();
                return;
            }

            if(kinoParticipants.isInMySpace(participant)){
                CONV_STORAGE.showInviteOrLeave(participant);
                return
            }else if (app.focused[participant]) {
                video.focusButton.removeClass('active');
                app.unFocusVideo(participant,true);
            } else {
                video.focusButton.addClass('active');
                app.focusVideo(participant);
                try {
                    $('#focusBack-' + participant).remove();
                } catch (e) {}
            }
        });
        video.audios = {
            slider: false,
            file: false,
        };
        video.focusOnMe = false;
        video.isFocused = false;
        video.isMuted = false;
        video.volume = 1;
        video.audioWrapper = $('<div/>', {
            class: 'audioWrapper',
            html: video.audioPlayer
        });
        video.stats={
            quality:'excellent',
            video:{
                upload:0,
                download:0
            },
            audio:{
                upload:0,
                download:0
            },
            resolution:'N/A',
            region:'N/A',
            server_count:"N/A",
            framerate:"N/A"
        };

        video.nameContainer = $('<div/>', {
            class: 'display-name-container',
            html: `<span>${displayName}</span>`,
        });
        tippy(video.nameContainer[0],{
            content:'',
            placement: 'bottom-start',
            allowHTML: true,
            theme:'light',
            arrow:false,
            zIndex: 9999
        });

        video.presenterBtn = $('<div/>', {
            class: 'toolbar-icon button-dark presenter-btn  svg-20 mr-1',
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            title: 'Maximize',
            html: app.maximizeIcon,
        }).on('click', function () {
            app.presenter.hideTooltip();
            if (!app.presenter.isPresenter(participant)) {
                if(app.presenter.getPresenterId()!==null){
                    app.presenter.removePresenter();
                    app.presenter.makePresenter(participant);
                }else{
                    if(app.presenter.isPresenterAvailable()){
                        app.presenter.makePresenter(participant);
                    }else{
                        if(app.isLocalMaximized){
                            app.presenter.maximizeVideo(participant);
                        }else{
                            app.presenter.minimizeVideo(participant);
                        }
                    }
                }
            } else {
                app.presenter.removePresenter(true);
            }
        });
        video.optionsMenuBtn=$('<div/>', {
            class: 'toolbar-icon button-dark svg-20',
            html: app.optionsIcon,
        });
        const menu=`
            <div class="menu-item"><span class="menu-icon">${app.waveIcon}</span><span class="menu-text">Wave</span></div>
        `;
        tippy(video.optionsMenuBtn[0],{
            content:menu,
            trigger: 'click',
            placement: 'bottom-end',
            allowHTML: true,
            theme:'light',
            arrow:false,
            zIndex: 900,
            interactive:true,
            appendTo: () => document.body,
            onShow(instance) {
                app.renderParticipantMenu(participant)
            }
        });
        // app.renderParticipantMenu(participant);
        // raiseHandBtn.tooltip();
        // video.focusButton.tooltip();
        // video.presenterBtn.tooltip();
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });

        video.toolBarRight = $('<div/>', {
            class: 'toolbar-items-right',
            html: [video.focusButton],
        });
        video.toolBarLeft = $('<div/>', {
            class: 'toolbar-items-left',
        });

        video.toolBar = $('<div/>', {
            class: 'video-toolbar',
            html: [video.toolBarRight, video.toolBarLeft],
        });
        video.cameraMuted = $('<span/>',{
            class: 'in-video-camera-muted muted',
            title: 'Camera off',
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            html: app.cameraMutedIcon
        });
        video.micMuted = $('<span/>', {
            class: 'in-video-mic-muted muted',
            title: "Mic Off",
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            html: app.micMutedIcon
        });
        video.messageContainer = $('<div/>',{
            class: 'chatBubblesMessageContainer cursor-pointer',
            html: '',
        }).on('click', function(){
           video.messageIcon.trigger("click");
        });
        video.messageNotificationNumber = $('<div/>',{
            class: 'chatBubbleNotificationNumber',
            html: ''
        });
        video.messageIcon = $('<div/>',{
            class: 'chatBubbleMessageIcon toolbar-icon',
            'data-chat-id': null,
            'data-participant-id' : participant,
            html: [app.chatBubbleIconOnTiles, video.messageNotificationNumber]
        }).on('click', function(){
            $(`#${app.user_id} .chatBubblesMessageContainer`).removeClass('showChatMessageContainer');
            video.messageNotificationNumber.html('');
            chat.makeChatTabActive();
            if($(this).attr('data-chat-id').length) {
                console.log($(this).attr('data-chat-id'))
                chat.selectGroupChatById($(this).attr('data-chat-id'));
                CONV_STORAGE.openPanel();
            } else {
                chat.selectChatUsingParticipantId($(this).attr('data-participant-id'))
                CONV_STORAGE.openPanel();
            }
            app.hideMessageFromTile(participant)
        });
        video.chatBubbleContainer = $('<div/>',{
            class: 'chatBubbleContainer',
            html: [video.messageIcon, video.messageContainer]
        });
        video.bottomToolbar = $('<div/>', {
            class: 'toolbar-bottom',
            html: [video.chatBubbleContainer]
        });


        video.options = '';

        video.topToolBarLeft = $('<div/>', {
            class: 'video-top-toolbar-left',
            html: [ video.nameContainer, video.micMuted, video.cameraMuted ]
        });

        video.permanentIcons = $('<div/>',{
            class: 'video-top-toolbar-permanent-icons',
            html: [video.recordingIndicator, video.streamingIndicator ,video.moderatorBadge]
        });

        video.permanentPresenterBtn = $('<div/>',{
            class: 'video-top-toolbar-permanent-icons',
            html: [video.presenterBtn,video.optionsMenuBtn]
        })

        // video.hiddenIcons = $('<div/>',{
        //     class: 'video-top-toolbar-hidden-icons',
        //     html: [video.muteUser, video.pullFocusToUser, video.makeModerator, video.kickUser]
        // })

        video.topToolBarRight = $('<div/>', {
            class: `video-top-toolbar-right ${HOST == 1 ? 'has-host-privileges':''}`,    /* Card ID: 477*/
            html: [video.permanentIcons, video.permanentPresenterBtn]
        });

        video.topToolBar = $('<div/>', {
            class: 'video-top-toolbar',
            html: [
                video.topToolBarLeft,
                video.topToolBarRight
            ],
        });
        video.background = $('<div/>', {
            class: 'videoContainerBackground',
        });
        video.overlay = $('<div/>', {
            class: 'video_overlay',
        });
        video.viewContainer = $('<div/>', {
            class: `videoViewContainer ${app.isParticipantLocationActive ? 'transparent' : ''}`,
            id: participant,
            html: [
                video.background,
                video.wrapper,
                video.audioWrapper,
                video.overlay,
                video.toolBar,
                video.topToolBar,
                video.bottomToolbar,
                video.notificationBar,
            ],
        });

        //save object
        app.videos[participant] = video;
        app.appendVideo(participant);
        app.members.push(participant);
        app.splitConversations.onParticipantJoined(participant);
        kinoLimits.onUsersCountChanged();
        if(HOST == 1 || ROLE=="moderator"){
            app.videos[participant].showPullFocusButton();
        }
        app.renderParticipantToList(participant);
        if(isJoined){
            animatedLayers.isJoiningOverlayParticipant(participant, displayName);
        }
        app.renderParticipantMenu(participant);
        app.renderStats(participant);
        renderChatsList();

    };

renderParticipantMenu(id,instance=false, participant){
    console.log(`Rendering ${id} menu`);
    const app=this;
    const mod= HOST==1 || ROLE == "moderator";
    const menuItems=$('<div/>',{
        class:'menu-items'
    });

    //invite
    const invite=$('<div>',{
        class:`menu-item`,
        html:`<span class="menu-icon">${this.inviteIcon}</span><span class="menu-text">Invite Over</span>`
    }).on('click',(e)=>{
        e.stopPropagation()
        if(CONV_STORAGE.myConversation !== null){
        if (
            CONV_STORAGE.myConversation &&
            CONV_STORAGE.private &&
            CONV_STORAGE.private.id == CONV_STORAGE.myConversation
        ) {
            CONV_STORAGE.private.sendJoinConversationInvite(id);
        } else {
            socket.sendConversationJoinInvite(
                id,
                CONV_STORAGE.myConversation
            );
        }
        //end card 529
        CONV_STORAGE.showNotification(
                Video.conversationIcon,
                "INVITE_WAITING_RESPONSE",
                {
                    participant: id,
                    conversation_id: CONV_STORAGE.conversation_id,
                    displayName: participant.name,
                }
            );
        }else {
            socket.sendConversationJoinInvite(
                id,
                "new"
            );
            //end card 529
            CONV_STORAGE.showNotification(
                Video.conversationIcon,
                "INVITE_WAITING_RESPONSE",
                {
                    participant: id,
                    conversation_id: CONV_STORAGE.conversation_id,
                    displayName: participant.name,
                }
            );
        }

        if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
            spacesView.deactivateTheSearchViewExpanded()
            spacesView.closeAllDropDownMenu()
        }else {
            spacesView.deactivateTheSearchView()
            spacesView.closeLeftSpaceMenu()
        }
    });

    if(!kinoParticipants.isInMySpace(id)){
        menuItems.append(invite);
    }

    //wave

    const wave=$('<div>',{
        class:`menu-item ${!permissions.hasWave() ? 'disabled' : ''}`,
        html:`<span class="menu-icon">${this.waveIcon}</span><span class="menu-text">Wave</span>`
    }).on('click',function(e){
        e.stopPropagation()
        if(!permissions.hasWave()){return}
        e.preventDefault();
        console.log("Wave clicked")
        let btn = $(this);
        if (btn.hasClass('disable')) {
            return;
        } else {
            socket.sendPrivateRaiseHand(new Array(id));
            btn.addClass('disable');
            setTimeout(function () {
                btn.removeClass('disable');
            }, 5000);
        }
        app.closeParticipantMenu(id);
        if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
            spacesView.deactivateTheSearchViewExpanded()
            spacesView.closeAllDropDownMenu()
        }else {
            spacesView.deactivateTheSearchView()
            spacesView.closeLeftSpaceMenu()
        }
    });
    if(!permissions.hasWave()){
        wave.attr('data-toggle','tooltip')
        wave.attr('data-placement','top')
        wave.attr('data-original-title','This feature is disabled in this workspace.')
    }
    menuItems.append(wave);

    if(permissions.hasMuteAll() || permissions.isWorkspace){
        if(kinoParticipants.inSameSpaceWith(id) || onStage.isActive()){
            //mute participant
            const mute=$('<div>',{
                class:`menu-item ${!permissions.hasMuteAll() ? 'disabled' : ''}`,
                html:`<span class="menu-icon">${this.micMutedIcon}</span><span class="menu-text">Mute</span>`
            }).on('click',function(){
                if(!permissions.hasMuteAll()){return}
                muteParticipants.muteParticipant(id);
                app.closeParticipantMenu(id);
            });
            if(!permissions.hasMuteAll()){
                mute.attr('data-toggle','tooltip')
                mute.attr('data-placement','top')
                mute.attr('data-original-title','This feature is disabled in this workspace.')
            }
            menuItems.append(mute)
        }
    }

        //on stage
        if(permissions.hasStageView() || permissions.isWorkspace){

            const onStageItem=$('<div>',{
                class:`menu-item ${!permissions.hasStageView() ? 'disabled' : ''}`,
                html:`<span class="menu-icon">${this.pullFocusIcon}</span><span class="menu-text">Place on stage</span>`
            }).on('click',function(e){
                e.stopPropagation()
                if(!permissions.hasStageView()){return}
                let timeout
                    $(this).addClass('disable')
                    timeout = setTimeout(() => {
                        $(this).removeClass('disable')
                        clearTimeout(timeout)
                    }, 2000);
                    app.closeParticipantMenu(id);
                    onStage.openModalToPresetUser(id);
                    if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
                        spacesView.deactivateTheSearchViewExpanded()
                        spacesView.closeAllDropDownMenu()
                    }else {
                        spacesView.deactivateTheSearchView()
                        spacesView.closeLeftSpaceMenu()
                    }
            });
            if(!permissions.hasStageView()){
                onStageItem.attr('data-toggle','tooltip')
                onStageItem.attr('data-placement','top')
                onStageItem.attr('data-original-title','This feature is disabled in this workspace.')
            }
            menuItems.append(onStageItem)

        }

        //make moderator
        if(HOST == 1 && !permissions.isWorkspace){
            if(!this.videos[id].host){
                const isMod=this.videos[id].isModerator;
                const moderator=$('<div>',{
                    class:'menu-item',
                    html:`<span class="menu-icon">${this.makeModeratorIcon}</span><span class="menu-text">${isMod ? 'Remove moderator' : 'Make moderator'}</span>`
                }).on('click', function (e) {
                    e.stopPropagation()
                    $(this).addClass('disable')
                    let timeout = setTimeout(() => {
                        $(this).removeClass('disable')
                        clearTimeout(timeout)
                    }, 3000);
                    if (isMod) {
                        app.removeModeratorRole(id);
                        app.userRoleChanged(id,'none')
                    } else {
                        app.transferModeratorRole(id);
                        app.userRoleChanged(id,'moderator')
                    }
                    app.closeParticipantMenu(id);
                    if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
                        spacesView.deactivateTheSearchViewExpanded()
                        spacesView.closeAllDropDownMenu()
                    }else {
                        spacesView.deactivateTheSearchView()
                        spacesView.closeLeftSpaceMenu()
                    }
                });
                menuItems.append(moderator)
            }
        }

        if(permissions.hasShowtheDoor() || permissions.isWorkspace){
            const kick=$('<div>',{
                class:`menu-item ${!permissions.hasShowtheDoor() ? 'disabled' : ''}`,
                html:`<span class="menu-icon">${this.showTheDoorIcon}</span><span class="menu-text">Show the door</span>`
            }).on('click',function(e){
                e.stopPropagation()
                if(!permissions.hasShowtheDoor()){return}
                $(this).addClass('disable')
                let timeout = setTimeout(() => {
                    $(this).removeClass('disable')
                    clearTimeout(timeout)
                }, 1500);
                app.removeModeratorRole(id);
                room.kickParticipant(id);
                socket.sendOutOfKino(id);
                app.closeParticipantMenu(id);
                setTimeout(() => {
                    app.removeVideo(id);
                }, 1500);
                if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
                    spacesView.deactivateTheSearchViewExpanded()
                    spacesView.closeAllDropDownMenu()
                }else {
                    spacesView.deactivateTheSearchView()
                    spacesView.closeLeftSpaceMenu()
                }
            });
            if(!permissions.hasShowtheDoor()){
                kick.attr('data-toggle','tooltip')
                kick.attr('data-placement','top')
                kick.attr('data-original-title','This feature is disabled in this workspace.')
            }
            menuItems.append(kick)
        }


        if(instance){
            instance.html(menuItems[0])
        }else{
            this.videos[id].optionsMenuBtn[0]._tippy.setContent(menuItems[0]);
        }

}

renderLocalParticipantMenu(instance=false){
    console.log(`Rendering local participant menu`);
    const app=this;
    const mod=HOST==1 || ROLE == "moderator";
    const menuItems=$('<div/>',{
        class:'menu-items'
    });
    const iconMuted = this.muteUserIcon
    const iconNotMuted = this.micMutedIcon

    const mute=$('<div>',{
        class:'menu-item',
        html:`<span class="menu-icon">${isMicMuted() ? this.micMutedIcon : this.muteUserIcon}</span><span class="menu-text ellipsis">${ isMicMuted() ? 'Unmute microphone' : 'Mute microphone'}</span>`
    }).on('click',function(){
        // muteParticipants.muteParticipant(id);
        if(isMicMuted()){
            toggleMic();
            $(this).find('.menu-text').text('Mute microphone');
            $(this).find('.menu-icon').html(iconMuted);
        }else{
            muteMic();
            $(this).find('.menu-text').text('Unmute microphone');
            $(this).find('.menu-icon').html(iconNotMuted);
        }
        app.closeLocalParticipantMenu();
    });
    menuItems.append(mute)

    if(permissions.hasAnnouncer() || permissions.isWorkspace){
        const announce=$('<div>',{
            class:`menu-item ${!permissions.hasAnnouncer() ? 'disabled' : ''}`,
            html:`<span class="menu-icon">${app.announcement.announceIconFilled}</span><span class="menu-text">Announcer</span>`
        });
        if(permissions.hasAnnouncer()){
            announce.on('click', function(e){
                e.stopPropagation()
                app.announcement.showToolBoxComponents();
                if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
                    spacesView.deactivateTheSearchViewExpanded()
                    spacesView.closeAllDropDownMenu()
                    spacesView.toggleExpandView()
                }else {
                    spacesView.deactivateTheSearchView()
                    spacesView.closeLeftSpaceMenu()
                }
            }).on('mousedown', function(e){
                if(e.which == 1){
                    app.announcement.pressStart(app.announcement)
                    app.announcement.showToolBoxComponents();
                }
                app.announcement.pressHoldDuration = 40;
                app.announcement.pressReadyDuration = 70;
                app.announcement.quickAnnounce = true;
            })
            .on("mouseup", app.announcement.pressStop.bind(this,app.announcement))
            .on("touchstart", app.announcement.pressStart.bind(this,app.announcement))
            .on("touchend", app.announcement.pressStop.bind(this,app.announcement));
        }else{
            announce.attr('data-toggle','tooltip')
            announce.attr('data-placement','top')
            announce.attr('data-original-title','This feature is disabled in this workspace.')
        }

        menuItems.append(announce)
    }

    //invite
    const onStageItem=$('<div>',{
        class:`menu-item`,
        html:`<span class="menu-icon">${this.pullFocusIcon}</span><span class="menu-text">Place on stage</span>`
    })


    //on stage
    if(permissions.hasStageView() || permissions.isWorkspace){
        const onStageItem=$('<div>',{
            class:`menu-item ${!permissions.hasStageView() ? 'disabled' : ''}`,
            html:`<span class="menu-icon">${this.pullFocusIcon}</span><span class="menu-text">Place on stage</span>`
        })
        if(permissions.hasStageView()){
            onStageItem.on('click',function(e){
                e.stopPropagation()
                let timeout
                    $(this).addClass('disable')
                    timeout = setTimeout(() => {
                        $(this).removeClass('disable')
                        clearTimeout(timeout)
                    }, 2000);
                    app.closeLocalParticipantMenu();
                    if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
                        spacesView.deactivateTheSearchViewExpanded()
                        spacesView.closeAllDropDownMenu()
                    }else {
                        spacesView.deactivateTheSearchView()
                        spacesView.closeLeftSpaceMenu()
                    }
                    onStage.openModalToPresetUser(room.myUserId());
            });
        }else{
            onStageItem.attr('data-toggle','tooltip')
            onStageItem.attr('data-placement','top')
            onStageItem.attr('data-original-title','This feature is disabled in this workspace.')
        }
        menuItems.append(onStageItem)
    }

    if(instance){
        instance.html(menuItems[0])
    }else{
        this.localVideo.optionsMenuBtn[0]._tippy.setContent(menuItems[0]);
    }

}

closeLocalParticipantMenu(){
    try {
        this.localVideo.optionsMenuBtn[0]._tippy.hide();
    } catch (error) {

    }
}
    closeParticipantMenu(id){
        try {
            this.videos[id].optionsMenuBtn[0]._tippy.hide();
        } catch (error) {

        }
    }

   micMuted (participant, isMuted) {
       let app = this;
       screenShare.popup.micMuteChanged(participant,isMuted);
        if (app.videos[participant]) {
            if (isMuted) {
                app.videos[participant].micMuted.addClass('muted');
                $(`.mic-status-${participant}`).removeClass("d-none")
                app.videos[participant].hasMicMuted=true;
            } else {
                app.videos[participant].micMuted.removeClass('muted');
                $(`.mic-status-${participant}`).addClass("d-none")
                app.videos[participant].hasMicMuted=false;
            }
        }else if(participant == room.myUserId() || participant == "local"){
            if (isMuted) {
                app.localVideo.micMuted.addClass('muted');
                $(".mic-status-local").removeClass("d-none")
                app.localVideo.hasMicMuted=true;
                pictureInPicture.setMicrophoneActive(false);
            } else {
                app.localVideo.hasMicMuted=false;
                app.localVideo.micMuted.removeClass('muted');
                $(".mic-status-local").addClass("d-none")
                pictureInPicture.setMicrophoneActive(true);
            }
        }
    };

    cameraMuted (participant, isMuted) {
        let app = this;
        screenShare.popup.cameraMuteChanged(participant,isMuted,true);
        if (app.videos[participant]) {
            let p = kinoParticipants.get(participant);
            if (isMuted) {
                app.videos[participant].cameraMutedByUser=true;
                app.videos[participant].cameraMuted.addClass('muted');
                app.videos[participant].noCameraLayer.removeClass('d-none');
                app.videos[participant].viewContainer.addClass("no-camera");
                if(p && p.noCameraLayerThumb){
                    p.noCameraLayerThumb.removeClass('d-none');
                }
                if(p && p.menuNoCameraLayerThumb){
                    p.menuNoCameraLayerThumb.removeClass('d-none');
                }
                app.videos[participant].noCameraLayer.removeClass("error-message");
                app.videos[participant].noCameraMessage.html("");
                app.videos[participant].noCameraMessage.addClass('d-none');
                $(`.camera-status-${participant}`).removeClass("d-none")
                app.splitConversations.videoMuteChanged(participant,true)
                //app.videos[participant].onVideoMuted();
            } else {
                app.videos[participant].cameraMuted.removeClass('muted');
                $(`.camera-status-${participant}`).addClass("d-none")
                app.videos[participant].cameraMutedByUser=false;
                app.videos[participant].noCameraLayer.addClass('d-none');
                app.videos[participant].viewContainer.removeClass("no-camera");
                if(p && p.noCameraLayerThumb){
                    p.noCameraLayerThumb.addClass('d-none');
                }
                if(p && p.menuNoCameraLayerThumb){
                    p.menuNoCameraLayerThumb.addClass('d-none');
                }
                app.splitConversations.videoMuteChanged(participant,false)
            }

        }else if((room && participant == room.myUserId()) || participant=="local"){
            if (isMuted) {
                app.splitConversations.videoMuteChanged(room.myUserId(),true)
                app.localVideo.cameraMutedByMe = true;
                app.localVideo.noLocalVideo();
                app.localVideo.cameraMuted.addClass('muted');
                $(".camera-status-local").removeClass("d-none")
                app.disablePrivacyModeSwitch();
            } else {
                app.localVideo.cameraMuted.removeClass('muted');
                app.enablePrivacyModeSwitch();
                if(app.isSharingScreen){
                    disablePrivacyModeBtn();
                }
                app.localVideo.cameraMutedByMe = false;
                app.localVideo.noLocalVideo();
                $(".camera-status-local").addClass("d-none")
                app.splitConversations.videoMuteChanged(room.myUserId(),false)
            }
        }
    };

    attachLocalAudio(idx) {
        /*var app = this;
        stopMediaPlayers(app.localVideo.audioWrapper);//card 556
        app.localVideo.audioWrapper.html(
            `<audio autoplay='1' muted='true' id='localAudio${idx}' />`
        );*/
        //card 584
    };

    attachLocalVideo(idx) {
        var app = this;
        stopMediaPlayers(app.localVideo.wrapper);//card 556
        app.localVideo.wrapper.html(
            [`<video autoplay class='${cameraOptionsPreferences.camera_flip ? 'flipVideoX' : ''}' id='localVideo${idx}' playsinline />`]
        );
    };

    audioValue(volume) {
        volume = Math.round(parseFloat(volume) * 100).toString();
        document.getElementsByClassName('audioVal')[0].innerHTML = volume.concat(
            '%'
        );
    };
//begin card 584
    removeTrack(participant,track){
        try {
            if (track.getType() == "video") {
                if(this.videos[participant] && this.videos[participant].player){
                    this.videos[participant].player.srcObject.removeTrack(track.track);
                    this.videos[participant].tracks=this.videos[participant].tracks.filter(t=>t!=track.track.id);
                    console.log(`${participant} tracks after remove video`,this.videos[participant].player.srcObject.getTracks());
                }
            }else{
                if(this.videos[participant] && this.videos[participant].audioPlayer){
                    this.videos[participant].audioPlayer.srcObject.removeTrack(track.track);
                    this.videos[participant].tracks=this.videos[participant].tracks.filter(t=>t!=track.track.id);
                    console.log(`${participant} tracks after remove audio`,this.videos[participant].audioPlayer.srcObject.getTracks());
                }
            }
        } catch (error) {
            console.error('Remove track error',error);
        }

    }
    attachAudioToPlayer(participant,track){
        console.log("attaching audio to player")
        if(this.videos[participant] && this.videos[participant].audioPlayer){
            this.videos[participant].audioPlayer.srcObject=track.stream;
        }
        // if(this.videos[participant] && this.videos[participant].player){
        //     if(this.videos[participant].player.srcObject){
        //         //already initialized
        //         this.videos[participant].player.srcObject=this.joinMediaStreamsTracks(this.videos[participant].player.srcObject.getTracks(),track.stream.getTracks(),participant);
        //     }else{
        //         //audio is the first track attach to a audio element until a video stream is received
        //         if(this.videos[participant].audioPlayer){
        //             this.videos[participant].audioPlayer.srcObject=track.stream;
        //             console.log("Attaching to audio player")
        //         }else{
        //             this.videos[participant].player.srcObject=track.stream;
        //         }
        //     }
        // }
    };
    shouldAttachVideo(track){
        return new Promise((resolve,reject)=>{
            // console.error("promise entered track id",track.track.id);
            // console.log('should attach this track',track.getParticipantId());
            try {
                const hasVideo = getRemoteParticipantMainVideoTrack(track.getParticipantId());
               if(!hasVideo || hasVideo.muted ||  room.getParticipantById(track.getParticipantId()).getProperty("video_muted")){
                this.videos[track.getParticipantId()].noCameraLayer.removeClass('d-none');
                this.videos[track.getParticipantId()].viewContainer.addClass("no-camera");
                // console.error('Metadata loaded resolving because user has no tracks or user is muted',track.track.id);
                resolve(true);
                    return;
                }
            } catch (error) {

            }
           let rejectTimeout=0;
           let tempvideo = document.createElement('video');
            tempvideo.srcObject=track.stream;
            tempvideo.onloadedmetadata=(e)=>{
                clearTimeout(rejectTimeout);
                console.error('Metadata loaded resolving',track.track.id);
                tempvideo.pause();
                tempvideo.currentTime=0;
                tempvideo.srcObject=null;
                tempvideo.remove();
                tempvideo=undefined;
                resolve(true);
            };

            rejectTimeout=setTimeout(() => {
                console.error('Metadata did not load:  rejecting',track.track.id);
                tempvideo.pause();
                tempvideo.currentTime=0;
                tempvideo.srcObject=null;
                tempvideo.remove();
                tempvideo=undefined;
                console.log("Is rejeted track muted",track.track.muted);
                reject(false);
            }, 25000);


        });
    };
    attachVideoToPlayer(participant,track){
        // this.shouldAttachVideo(track).then((loaded)=>{
            if(this.videos[participant] && this.videos[participant].player){
                        console.log(`New video stream received for ${participant} `,track);
                        console.log(`Is new video muted `,track.isMuted());
                        if(track.isMuted()){
                            this.videos[participant].noCameraLayer.removeClass('d-none');
                            this.videos[participant].viewContainer.addClass("no-camera");
                        }
                        // this.videos[participant].tracks.push(track.track.id);
                        this.videos[participant].player.srcObject=track.stream;
                        setTimeout(() => {
                            this.videos[participant].player.play();
                        }, 3000);
                        //end card 808
                try { CONV_STORAGE.updateVideoStream(participant);} catch (e) {}
            }

        // }).catch(err=>{
        //     console.error('Promise',err);
        // })
    };
    joinMediaStreamsTracks(existingTracks,newTracks,pid){
        newTracks.forEach(track=>{
            if(track.kind=="video"){
                console.log("Adding mute event listeners for track",track);
                track.onmute = event => {
                    if(this.videos[pid]){
                        this.videos[pid].videoWillMute();
                    }
                    // console.log("Video track has been muted do something");
                };
                track.onunmute = event => {
                    console.log("Video track has been unmuted remove layer");
                    if(this.videos[pid]){
                        CONV_STORAGE.updateVideoStream(pid);
                        this.videos[pid].onVideoUnmuted();
                        animatedLayers.removeLocalConnectionLostLayer();
                    }
                };

            }
        })
      return new MediaStream(new Set([...existingTracks,...newTracks]));
    };

    attachAudio (participant, track) {
        var app = this;

       this.attachAudioToPlayer(participant,track);

        volumeManager.setVolumeOnJoin(participant);
        if(app.lockMasterVolume.isLocked()){
            if(!kinoParticipants.inSameSpaceWith(participant)){
                app.addDisabledVolumeControl(participant);
            }else{
                app.addEnabledVolumeControl(participant);
            }
        }else{
            app.addEnabledVolumeControl(participant);
        }
    };

    addEnabledVolumeControl(participant){
        let app = this;

        let sliderStep = 0.01;
        //trello web conversations #9 issue
        let audioVal = $('<div/>', {
            class: 'audioVal',
            html: app.videos[participant] ?
                Math.round(app.videos[participant].volume*100)+"%"
                : '', //kf
        });
        //app.videos[participant].filter=filter;
        //new
        let audioSlider = $('<input/>', {
            class: 'form-control-range stylish-range',
            type: 'range',
            max: 1,
            min: 0,
            step: sliderStep,
            value: app.videos[participant] ? app.videos[participant].volume : 1,
        }).on('input', function (e) {
            let volume = $(this).val();
            console.log('Volume change: ' + volume);
            volumeManager.changeParticipantVolume(participant, volume);
            // app.audioValue(volume); //kf
        }).on('change',function(){
            //trello web conversations #9 issue
            let vol=Math.round($(this).val() * 100);
            audioVal.html(vol+"%");
        });

        let volumePopupTimer = 0;
        let dropup = $('<div/>', {
            class: 'tippy-slider',
            html: [audioSlider, audioVal],
        }).on('wheel', (event)=>{
            event.preventDefault();
            if(event.originalEvent.deltaY !== 0){
                let currentVal=parseFloat(audioSlider.val());
              if(event.originalEvent.deltaY < 0){
                if(currentVal <= 0.95){
                    currentVal+=0.05;
                    audioSlider.val(currentVal);
                    audioSlider.trigger('input')
                }else if(currentVal > 0.95 && currentVal < 1){
                    audioSlider.val(1);
                    audioSlider.trigger('input')
                }
              }
              else {
                if(currentVal >= 0.05){
                    currentVal-=0.05;
                    audioSlider.val(currentVal);
                    audioSlider.trigger('input')
                }else if(currentVal > 0){
                    audioSlider.val(0);
                    audioSlider.trigger('input')
                }
              }
            }
          });

        app.videos[participant].muteIcon = $('<div/>', {
            class: 'volume-icon',
            html: app.volumeIcon,
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            id: 'volumeButtonTileVidIcon'
        }).off().on('click', function (e) {
            if (app.videos[participant].muteIcon.hasClass('muted')) {
                volumeManager.unMuteParticipant(participant);
            } else {
                volumeManager.lastParticipantVolume[participant]=audioSlider.val();
                volumeManager.changeParticipantVolume(participant, 0);
            }
        });

        if(app.videos[participant].muteIcon[0]._tippy){
            app.videos[participant].muteIcon[0]._tippy.destroy();
        }

        const sliderTippy=tippy(app.videos[participant].muteIcon[0],{
            arrow:false,
            placement:'right',
            interactive:true,
            allowHTML:true,
            content:dropup[0],
            // hideOnClick: 'toggle',
            inertia:true,
            sticky:true,
            onShow:(i)=>{
                if(!permissions.hasChangeVolume()){
                    sliderTippy.setContent(Math.round(app.videos[participant].volume*100)+"%")
                }else if(!kinoParticipants.inSameSpaceWith(participant) &&  app.lockMasterVolume.isLocked()){
                    sliderTippy.setContent(Math.round(app.videos[participant].volume*100)+"%")
                }else{

                    audioSlider.val(app.videos[participant].volume);
                    audioVal.html(Math.round(app.videos[participant].volume*100)+"%")
                    sliderTippy.setContent(dropup[0]);
                }
            }
            // trigger:'click'
        });

        let volumeButton = $('<div/>', {
            class: 'toolbar-icon button-dark mt-1',
            id: 'volumeButtonTileVid',
            html: [app.videos[participant].muteIcon],
        });

        app.videos[participant].toolBarLeft.find('#volumeButtonTileVid').remove();
        app.videos[participant].toolBarLeft.append([volumeButton]);

        app.videos[participant].audios.slider = audioSlider;

        volumeManager.updateParticipantTileVolume(app.videos[participant] ? app.videos[participant].volume : 1 ,participant)
    }

    addDisabledVolumeControl(participant){
        let app = this;
        try {
            if(app.videos[participant].muteIcon && app.videos[participant].muteIcon[0]._tippy){
                app.videos[participant].muteIcon[0]._tippy.destroy()
            }
        } catch (error) {

        }
        if(app.videos[participant].muteIcon){
            app.videos[participant].muteIcon.remove();
            app.videos[participant].muteIcon.off();
        }
        app.videos[participant].muteIcon = $('<div/>', {
            class: 'volume-icon',
            'data-toggle': 'tooltip',
            'data-placement': 'bottom',
            title: 'Background chatter is locked',
            html: app.volumeIconMuted
        });

        let volumeButton = $('<div/>', {
            class: 'toolbar-icon button-dark mt-1',
            id: 'volumeButtonTileVid',
            html: [app.videos[participant].muteIcon],
        });

        app.videos[participant].toolBarLeft.find('#volumeButtonTileVid').remove();
        app.videos[participant].toolBarLeft.append([volumeButton]);
        if(app.videos[participant].volume > 0){
            volumeManager.changeParticipantVolume(participant,0);
        }
    };

    removeVideo(participant, force = false) {
        // body...
        $('[data-toggle="tooltip"]').tooltip('hide');
        console.log("Remove video called for participant: " + participant);
        var app = this;
        if (participant === undefined) return;
        app.efss.viewPortLeave(participant);
        if(app.presenter.isPresenter(participant)){
            app.presenter.removePresenter(true);
        }
        if (app.videos[participant] !== undefined) {
            socket.sendParticipantLeft(participant);
            if(app.playUserLeftSound){
                app.playUserLeftSound = false;
                clearTimeout(app.playUserLeftSoundTimeout);
                app.sounds.play('leave',0.05);
                app.playUserLeftSoundTimeout = setTimeout(() => {
                    app.playUserLeftSound = true;
                }, 5000);
            }
            clearTimeout(app.videos[participant].reconnectTimeout);
            stopMediaPlayers(app.videos[participant].wrapper);//card 556
            stopMediaPlayers(app.videos[participant].audioWrapper);//card 556
            try {
                if(app.videos[participant].optionsMenuBtn[0]._tippy){
                    app.videos[participant].optionsMenuBtn[0]._tippy.destroy()
                }
                if(app.videos[participant].focusButton[0]._tippy){
                    app.videos[participant].focusButton[0]._tippy.destroy();
                }
                if(app.videos[participant].nameContainer[0]._tippy){
                    app.videos[participant].nameContainer[0]._tippy.destroy();
                }

            } catch (error) {}
            //fix remove tooltip for maximize video
            app.videos[participant].bottomToolbar.remove();
            app.videos[participant].viewContainer.remove();
            delete app.videos[participant];
            app.splitConversations.participantLeft(participant);
            lockFocus.participantLeft(participant);
            app.lockMasterVolume.participantLeft(participant);
            //pull focus
            /*if(app.stealFocus.participantFocused==participant){
                lockFocus.stopLockFocus();
            }*/
            kinoLimits.onUsersCountChanged();
            if(onStage.isActive() && onStage.isLastParticipant(participant)){
                if(onStage.isModerator()){
                    onStage.onStageEndEvent({participant:participant},true);
                }else{
                    onStage.onStageEndEvent({participant:participant},true);
                }
            }else if(app.focused[participant] && !onStage.isActive()){
                // console.error('MASTER MUTED', volumeManager.masterMuted)
                if(!volumeManager.masterMuted){
                    volumeManager.changeMasterVolume(0.05,0.05);
                }
            }
        }
        app.removeParticipantFromList(participant);
        kinoParticipants.delete(participant);
        //conversations
        if(typeof CONV_STORAGE !== 'undefined'){
            CONV_STORAGE.participantDisconnected(participant);
        }

        delete app.focused[participant];
        delete app.sideParticipants[participant];
        delete app.mainParticipants[participant];
        delete app.onConversation[participant];
        let pinnedConversation=false;
        if (Object.keys(app.focused).length == 0 && app.isFocused === true) {
            if(CONV_STORAGE.myConversation && CONV_STORAGE.conversations[CONV_STORAGE.myConversation] && CONV_STORAGE.conversations[CONV_STORAGE.myConversation].conv_type=='pinned'){
                pinnedConversation=true;
                if(!app.isLocalMaximized && kinoParticipants.inMySpace().length==0){
                    app.localVideoMaximize();
                }
            }else{
                if(app.isLobbyView){
                    app.enableLobbyView();
                }else if(app.isTileView){
                    app.enableTileView();
                }else{
                    app.enableLobbyView();
                }

            }

        }
        if(Object.keys(app.videos).length==0){
            app.localVideoMaximize();
            removeMutedLocalVideoTrack();
        }
        if (force) {
            console.log("Stream droped for participant :" + participant);
            //room.kickParticipant(participant);
            socket.sendStreamDrop(participant);
        }
        //lock focus
        // app.stealFocus.willReleaseLockFocus(participant);
        app.isOnlyOne();
        app.isFocusedSafeView();
        app.resizeMainVideos();
        delete localRecording.recordedBy[participant];
        if (Object.keys(localRecording.recordedBy).length == 0) {
            $("#recorder-indicator").removeClass("recordingOn");
            $("#whoRecordingList").removeClass('shown');
            $("#whoRecordingList").html('');
            $("#recorder-wraper").addClass("d-none")
        }
        renderChatsList();
    };



    transferModeratorRole(participant) {
        var app = this;
        app.addModerator(room.getName(), participant);
    };

    removeModeratorRole(participant) {
        var app = this;
        if(app.videos[participant].isModerator){
            app.removeModerator(room.getName(), participant, 0, '', true);
        }
    };



    makeParticipantModerator(participant) {
        var app = this;
        ROLE = "moderator";
        room.room.role = ROLE;
        permissions.setRole(ROLE);
        try {
            // CONV_STORAGE.addPinAccess();
            // spacesView.addModAccess();
            // muteParticipants.addOptionButton();
            kinoControls.onModeratorAccessAdded();
            kinoTimer.addOptionButton();
            lockFocus.addOptionButton();
            app.lockMasterVolume.addOptionButton();
            app.announcement.addOptionButton();
            // app.announcement.appendAnnouncerOnLocalTile();
            // app.stealFocus.addOptionButton();
            app.splitConversations.addOptionButton();

            renderKinoMenu();
            // kinoTimer.addModeratorRights();
            onStage.modAccessAdded();
            spacesView.addModAccess()
            if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                lockFocus.focusLockedEvent("",true);
            }
            app.lockMasterVolume.renderUnlockMasterVolumeToNewMod();
            if(CONV_STORAGE.private && CONV_STORAGE.private.id == CONV_STORAGE.myConversation){
                CONV_STORAGE.updateMakePrivateButton(true);
            }
            $("#recorder-wraper").addClass("moderator-recorder")
            $("#options-side-menu").removeClass("option-menu-non-moderator")
            $(".timer-timers-container").addClass("border-left")
            room.setLocalParticipantProperty('role',ROLE);
            hideAll({duration:0});
        } catch (error) {
            console.error("error happened adding options to menu",error);
        }

    };

   removeModeratorRights () {
        $('[data-toggle="tooltip"]').tooltip('hide');
        var app = this;
        if(HOST==1){
            return;
        }
        ROLE = "guest";
        room.room.role = ROLE;
        permissions.setRole(ROLE);
        socket.moderatorRoom(room.myUserId(),'leave');
        try {
            renderKinoMenu();
            localRecording.removeRecordingAccess();
            app.minimizedContent.removeModeratorAccess();
            kinoTimer.removeModeratorRights();
            app.lockMasterVolume.removeUnlockMasterVolume();
            onStage.modAccessRemoved();
            kinoControls.onModeratorAccessRemoved();
            if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                lockFocus.hideUnlockFocusButton();
                room.setLocalParticipantProperty('can_unlock_focus',null);
            }

            room.setLocalParticipantProperty('role',ROLE);
            hideAll({duration:0});
            $("#recorder-wraper").removeClass("moderator-recorder")
            $("#options-side-menu").addClass("option-menu-non-moderator")
            $(".timer-timers-container").removeClass("border-left")
        } catch (error) {
            console.error(error);
        }
        spacesView.removeModAccess();
    };

    moveVideosToSide() {
        var app = this;

        if (app.isLocalMaximized) {
            app.localVideoMinimize();
        }

        app.remoteVideosContainer
            .find('.videoViewContainer')
            .each(function (i, video) {
                $(video).appendTo(app.sideVideosContainer);
            });
    };

    moveVideosToMain() {
        var app = this;
        app.sideVideosContainer
            .find('.videoViewContainer')
            .each(function (i, video) {
                $(video).appendTo(app.remoteVideosContainer);
            });
    };

    getFeature(pid,feature_name){
        try {
            const features = Array.from(room.getParticipantById(pid)._features);
            console.log("[SPACES] remote participant features",features)
            const feature=features.find(f=>f.startsWith(feature_name));
            if(feature){
                return feature.split(":")[1];
            }
            return undefined
        } catch (error) {
            return undefined
        }
    }
    remoteParticipantHasAssignedSpace(pid){
        try {
            console.log("[SPACES] remote participant assigned space ",this.getFeature(pid,'assigned_space'))
            if(this.getFeature(pid,'assigned_space')){
                const space_id=parseInt(this.getFeature(pid,'assigned_space'));
                if(CONV_STORAGE.spacesFinishedLoading && CONV_STORAGE.spaceExists(space_id)){
                    return true
                }
            }
            console.log("[SPACES] spaces not ready")
            return false
        } catch (error) {
            console.log("[SPACES] has assigned space error",error)
            return false
        }
    }
    appendVideo (participant, isLocal = false) {
        var app = this;

        if (app.isFocused
            || (!isLocal && (CONV_STORAGE.isOnConversation(participant)
                || PARTICIPANTS_IN_CONVO.includes(participant)) || app.remoteParticipantHasAssignedSpace(participant))) {
            app.moveVideoToSide(participant);
            //app.videos[participant].viewContainer.appendTo(app.sideVideosContainer);
        } else {
            if (isLocal) {
                app.localVideo.viewContainer.appendTo(app.remoteVideosContainer);
            } else {
                if(onStage.isActive() && onStage.myStage.isPresenting){
                    app.moveVideoToSide(participant);
                }else{
                    app.moveVideoToMain(participant);
                }
                if(onStage.myStage.isStageView()){
                    let p=kinoParticipants.get(participant);
                    if(p){
                        p.setAsFocusedMe();
                    }
                }
                //app.videos[participant].viewContainer.appendTo(app.remoteVideosContainer);
            }
        }

        app.isOnlyOne();
        app.isFocusedSafeView();
        app.resizeMainVideos();
    };
    showToolBox() {
        var app = this;
        app.toolBox.addClass('tool-box-shown').removeClass('tool-box-hidden');
        /*app.toolBox.animate({
                bottom:"0px"
            },400);*/
        this.toolBoxShown = true;
    };
    hideToolBox() {
        var app = this;
        app.toolBox.removeClass('tool-box-shown').addClass('tool-box-hidden');
        /*app.toolBox.animate({
                bottom:"-200px"
            },700);*/
        this.toolBoxShown = false;
    };

    showSideVideos() {
        var app = this;
        this.sideVideosShown = true;
        app.videoSpace.addClass('strip');
        $('#app').addClass('strip');
        app.sideVideos
            .addClass('sideVideos-shown')
            .removeClass('sideVideos-hidden');
        app.isFocusedSafeView();
    };
    collapseScreen() {
        var app = this;
        app.remoteVideos.addClass('collapsed');
        $('#app').addClass('collapsed');
        // console.log('called collapseScreen');
    };

    expandScreen() {
        var app = this;
        app.remoteVideos.removeClass('collapsed');
        $('#app').removeClass('collapsed');
        // console.log('called expandScreen');
    };

    isFocusedSafeView() {
        var app = this;
         console.log('called isFocusedSafeView with with sideParticipants',Object.keys(app.sideParticipants).length);
        // if (
        //     (Object.keys(app.focused).length > 1 || (app.isLobbyView && !app.isFocused)) &&
        //     Object.keys(app.sideParticipants).length > 0
        // ) {
        if(Object.keys(app.sideParticipants).length > 0){
            app.collapseScreen();
        } else {
            app.expandScreen();
        }

        if (Object.keys(app.sideParticipants).length == 0) {
            app.sideVideos.addClass('empty');
            $('#app').addClass('no-strip');
            app.videoSpace.removeClass("strip");
            app.expandScreen();
        } else {
            app.sideVideos.removeClass('empty');
            $('#app').removeClass('no-strip');
            app.videoSpace.addClass("strip");


            if(Object.keys(app.mainParticipants).length==0){
                if(!app.isLocalMaximized){
                    app.localVideoMaximize();
                }
                app.collapseScreen();

            }else if(Object.keys(app.mainParticipants).length ==1){
                if(!app.isLocalMaximized){
                    app.expandScreen();
                }else{
                    app.collapseScreen();
                }
            }
        }
    };

    isOnlyOne () {
        var app = this;
        if (app.remoteVideosContainer.find('.videoViewContainer').length == 1 && !app.presenter.isPresenterView) {
            const pid = app.remoteVideosContainer.find('.videoViewContainer').attr('id');
            const participantVideo = document.getElementById(pid+'-media-player');
            let isLocalUser=pid=="localParticipant" ? true : false ;
            if(!isLocalUser && !onStage.myStage.isStageView()){
                let objectFit = "contain";
                if(participantVideo && participantVideo.videoWidth){
                    const ratio = participantVideo.videoWidth / participantVideo.videoHeight;
                    if(ratio > 1){
                        objectFit="cover";
                    }
                }
                app.remoteVideos.addClass('full-screen '+objectFit);
                $('#app').addClass('full-screen');
                app.remoteVideosContainer.addClass('full-screen');
                app.remoteVideosContainer.removeClass('lobby');
                app.expandScreen();
                //get main screen user
                try {
                    if(Object.keys(app.mainParticipants).length>0){
                        if(!app.videos[Object.keys(app.mainParticipants)[0]].viewContainer.hasClass('maximized')){
                            app.presenter.presenterButtonUI(Object.keys(app.mainParticipants)[0],'minimize');
                        }
                    }


                } catch (error) {

                }
            }else{
                app.remoteVideos.removeClass('full-screen');
                $('#app').removeClass('full-screen');
                app.remoteVideosContainer.removeClass('full-screen');
                app.remoteVideosContainer.addClass('lobby');
                if(Object.keys(app.sideParticipants).length > 0){
                    app.collapseScreen();
                }
            }
        } else {
            app.remoteVideosContainer.removeClass('lobby');
            app.remoteVideos.removeClass('full-screen');
            $('#app').removeClass('full-screen');
            app.remoteVideosContainer.removeClass('full-screen');
            if(Object.keys(app.sideParticipants).length > 0){
                app.collapseScreen();
            }
            Object.keys(app.mainParticipants).forEach(pid=>{
                if(app.videos[pid] && app.videos[pid].viewContainer.hasClass('maximized') && !app.presenter.isPresenter(pid)){
                    app.presenter.presenterButtonUI(pid,'maximize');
                }
            });

            console.log('Not Only one participant removing full screen');
        }
    };

    hideSideVideos() {
        var app = this;
        if(app.sideVideosContainer.find('.videoViewContainer').length > 0){return};
        this.sideVideosShown = false;
        console.log('Hidding side videos');
        app.videoSpace.removeClass('strip');
        $('#app').removeClass('strip');
        app.sideVideos
            .removeClass('sideVideos-shown')
            .addClass('sideVideos-hidden');
        app.expandScreen();
    };

    resizeMainVideos() {
        var app = this;
        app.presenter.canMakePresenterActive();
        let elements = app.remoteVideosContainer.find('.videoViewContainer').length;
        app.decideContainerDimensions(elements);
        let videoDimensions = app.videoDimension(elements);
        let tileSizeClass="tile-medium";
        if(videoDimensions.width > 800){
            tileSizeClass="tile-big";
        }else if(videoDimensions.width <= 800 && videoDimensions.width > 450){
            tileSizeClass="tile-medium";
        }else if(videoDimensions.width <= 450){
            tileSizeClass="tile-small";
        }
        if (elements == 1 && app.presenter.isPresenterView && Object.keys(app.mainParticipants).length > 1) {
            //is screensharing view
                    let height = app.remoteVideos.innerHeight();
                    height=height-120;
                    let width = parseInt(height * app.videoRatio);
                    console.log("height of video:" + height);

                    app.remoteVideosContainer
                    .find('.videoViewContainer').css({
                        width: width + "px",
                        height: height + "px"
                    }).removeClass('full-screen tile-small tile-medium tile-big').addClass(tileSizeClass);
        } else {
            if(Object.keys(app.mainParticipants).length==0 && app.isLocalMaximized){
                app.localVideo.minimize.css("display","none");
            }else{
                app.localVideo.minimize.css("display","flex");
            }
            app.remoteVideosContainer
                .find('.videoViewContainer')
                .removeClass('full-screen tile-small tile-medium tile-big')
                .css({
                    width: videoDimensions.width + 'px',
                    height: videoDimensions.height + 'px',
                }).addClass(tileSizeClass);

            if (videoDimensions.strech !== undefined) {
                console.log(videoDimensions.strech.index + ' streched');
                $('#remoteVideosContainer .videoViewContainer:nth-child(' + videoDimensions.strech.index + ')').css('width', '100%');
            }
        }
        if(onStage.myStage.isStageView() && onStage.myStage.audienceScrollable){
            app.efss.inViewPortAudienceVideos();
        }else{
            app.efss.inViewPortMainVideos();
        }
        // app.setQuality();
        updateVideoQuality();
        onResizeScreen();
    };

    decideContainerDimensions(elements) {
        var app = this;

        let parentWidth = app.remoteVideos.width();
        let parentHeight = app.remoteVideos.height();

        let containerHeight = parentHeight;
        let containerWidth = parentWidth;

        if (app.isTileView) {
            if (elements == 1) {
                containerWidth = parseInt(parentHeight * app.videoRatio);
            }
        }

        app.remoteVideosContainer.css({
            width: containerWidth + 'px',
        });
    };

    focusedView() {
        var app = this;
        app.isTileView = false;
        app.isLobbyView = false;
        app.isFocused = true;
        app.remoteVideos.addClass('focused');
        app.showSideVideos();
        // app.toggleTileView.removeClass('active');
        app.localVideo.viewContainer.removeClass('right-top right-bottom left-top left-bottom');
        // app.toggleTileView.attr('title' , 'Tile view');
        // app.toggleTileView.attr('data-original-title' , 'Tile view');
        // app.toggleTileView.html(this.tileViewIcon);
        if(app.presenter.isPresenterView){
            app.presenter.removePresenter(true);
        }
       // app.localVideo.viewContainer.appendTo(app.localVideoContainer);

       // app.isLocalMaximized = false;
        //$('#app').addClass('local-minimized');
        //app.draggableVideo();

        app.moveNonFocusedSide();
        //app.isOnlyOne();
        if (Object.keys(app.focused).length == 0 && kinoParticipants.inMySpace().length==0) {
            if(!app.isLocalMaximized){
                app.localVideo.minimize.attr('title', 'Minimize');
                app.localVideo.minimize.attr('data-original-title', 'Minimize');
                // app.localVideo.minimize.tooltip('hide');
                app.localVideoMaximize();
             }else{
                 app.resizeMainVideos();
             }
        }else if(CONV_STORAGE.joinSpaceSource!="split-spaces"){
            app.localVideoMinimize();
        }
        app.isOnlyOne();
        app.isFocusedSafeView();
    };

    enableTileView() {
        // var app = this;
        // app.isTileView = true;
        // app.isFocused = false;
        // app.toggleTileView.html(this.focusViewIcon);
        // if(app.presenter.isPresenterView){
        //     app.presenter.removePresenter(true);
        // }
        // //app.remoteVideosContainer.find(".videoViewContainer").removeClass("full-screen");
        // //app.localVideo.viewContainer.appendTo(app.remoteVideosContainer);
        // //app.isLocalMaximized = true;

        // //$('#app').removeClass('local-minimized');
        // //app.nonDraggableVideo();
        // app.moveAllToMain();
        // app.remoteVideos.addClass('tile-view').removeClass('full-view focused');
        // app.hideSideVideos();
        // app.isOnlyOne();
        // if(!app.isLocalMaximized){
        //     app.localVideo.minimize.attr('title', 'Minimize');
        //         app.localVideo.minimize.attr('data-original-title', 'Minimize');
        //         // app.localVideo.minimize.tooltip('hide');
        //         app.localVideoMaximize();
        // }else{
        //     app.resizeMainVideos();
        // }
    };

    videoDimension(videos){
        const isStage=onStage.myStage.isStageView();
        let availableWidth = videos > 1 ? this.remoteVideosContainer.innerWidth()-6 : this.remoteVideosContainer.innerWidth();
        let containerheight = isStage ? onStage.myStage.audienceScrollable.innerHeight() : this.remoteVideos.innerHeight();
        let availableHeight = videos > 1 ? containerheight-6 : containerheight;
        // console.log(`Available width ${availableWidth} height ${availableHeight} videos ${videos}`);
        let containerRatio=availableWidth/availableHeight;
        // const maxColums=isStage ? 6 : 5;
        const {maxColumns,col,row}=isStage ? this.getStageRowsAndColumns(videos,containerRatio) : this.getRowsAndColumns(videos,containerRatio);
        let videoWidth = availableWidth;
        let videoHeight = availableHeight;
        // console.warn(`Container ratio ${availableWidth/availableHeight} , video ratio ${this.videoRatio},columns ${col} x rows ${row}`)
        //only one video full screen
        if(videos==1){
            if(isStage){
                availableWidth = parseInt(Math.max(availableHeight,140) * this.videoRatio);
            }
            return {
                width: availableWidth,
                height: Math.max(availableHeight,140),
            };
        }

        videoWidth = availableWidth / col;
        videoHeight = parseInt(videoWidth / this.videoRatio);
        //if not enough height to fit rows
        if (videoHeight * row > availableHeight && (videos / row) <= maxColumns) {

            videoHeight = Math.max(parseInt(availableHeight / row),140);
            videoWidth = parseInt(videoHeight * this.videoRatio);

        }

        return {
            width: videoWidth,
            height: videoHeight,
        };

    };

    getRowsAndColumns(items,containerRatio){
        let col=1;
        let row=1;
        if(items==1){}
        else if(items==2){col=2;row=1}
        else if(items >=3 && items <= 4){
            if(containerRatio >= items){
                col=items;row=1
            }else{
                col=2;row=2
            }
        }
        else if(items >=5 && items <= 6){
            if(containerRatio >= items){
                col=items;row=1
            }else{
                col=3;row=2
            }
        }
        else if(items >=7 && items <= 8){
            if(containerRatio >= 6){
                col=items;row=1
            }else{
                col=4;row=2
            }
        }
        else if(items >=9 && items <= 12){col=4;row=3}
        else if(items >=13 && items <= 16){col=4;row=4}
        else{col=5;row=4}

        return  {
            col:col,
            row:row,
            maxColumns:5
        }
    }
    getStageRowsAndColumns(items,containerRatio){
        let col=1;
        let row=1;
        if(items==1){}
        else if(items==2){col=2;row=1}
        else if(items >=3 && items <= 4){
            if(containerRatio >= items){
                col=items;row=1
            }else{
                col=2;row=2
            }
        }
        else if(items >=5 && items <= 6){
            if(containerRatio >= items){
                col=items;row=1
            }else{
                col=3;row=2
            }
        }
        else if(items >=7 && items <= 8){
            if(containerRatio >= 6){
                col=items;row=1
            }else{
                col=4;row=2
            }
        }
        else if(items >=9 && items <= 12){col=4;row=3}
        else if(items >=13 && items <= 16){col=4;row=4}
        else{col=6;row=4}

        return  {
            col:col,
            row:row,
            maxColumns:6
        }
    }

    decideVideoDimensions(elements) {
        var app = this;
        let availableWidth = elements > 1 ? app.remoteVideosContainer.innerWidth()-6 :app.remoteVideosContainer.innerWidth();
        let containerheight = onStage.myStage.isStageView() ? onStage.myStage.audienceScrollable.innerHeight() : app.remoteVideos.innerHeight();
        let availableHeight = elements > 1 ? containerheight-6 : containerheight;

        let videoWidth = availableWidth;
        let videoHeight = availableHeight;

        if (elements == 1) {
            if (app.isTileView) {
                videoHeight = availableHeight;
                videoWidth = parseInt(videoHeight * app.videoRatio);
                if (videoWidth > availableWidth) {
                    videoWidth = availableWidth;
                    videoHeight = parseInt(videoWidth / app.videoRatio);
                }

                return {
                    width: videoWidth,
                    height: videoHeight,
                };
            } else {
                if(onStage.myStage.isStageView()){
                    availableWidth = parseInt(availableHeight * app.videoRatio);
                }
                return {
                    width: availableWidth,
                    height: availableHeight,
                };
            }
        } else if (elements == 2) {
            videoHeight = availableHeight <= 1080 ? availableHeight : 1080;
            videoWidth = parseInt(videoHeight * app.videoRatio);

            if (videoWidth * 2 > availableWidth) {
                videoWidth = parseInt(availableWidth / 2);
                videoHeight = parseInt(videoWidth / app.videoRatio);
            }

            return {
                width: videoWidth,
                height: videoHeight,
            };
        } else if (elements == 3 || elements == 4) {
            videoWidth = availableWidth / 2;
            videoHeight = parseInt(videoWidth / app.videoRatio);
            if (videoHeight * 2 > availableHeight) {
                videoHeight = parseInt(availableHeight / 2);
                videoWidth = parseInt(videoHeight * app.videoRatio);
            }

            return {
                width: videoWidth,
                height: videoHeight,
            };
        } else if (elements >= 5 && elements <= 6) {
            videoWidth = availableWidth / 3;
            videoHeight = parseInt(videoWidth / app.videoRatio);
            if (videoHeight * 2 > availableHeight) {
                videoHeight = parseInt(availableHeight / 2);
                videoWidth = parseInt(videoHeight * app.videoRatio);
            }

            return {
                width: videoWidth,
                height: videoHeight,
            };
        } else if (elements >= 7 && elements <= 8) {
            videoWidth = availableWidth / 4;
            videoHeight = parseInt(videoWidth / app.videoRatio);
            if (videoHeight * 2 > availableHeight) {
                videoHeight = parseInt(availableHeight / 2);
                videoWidth = parseInt(videoHeight * app.videoRatio);
            }

            return {
                width: videoWidth,
                height: videoHeight,
            };
        } else if (elements >= 9 && elements <= 12) {
            videoWidth = availableWidth / 4;
            videoHeight = parseInt(videoWidth / app.videoRatio);
            if (videoHeight * 3 > availableHeight) {
                videoHeight = parseInt(availableHeight / 3);
                videoWidth = parseInt(videoHeight * app.videoRatio);
            }

            return {
                width: videoWidth,
                height: videoHeight,
            };
        } else if (elements >= 13 && elements <= 16) {
            videoWidth = availableWidth / 4;
            videoHeight = parseInt(videoWidth / app.videoRatio);
            if (videoHeight * 4 > availableHeight) {
                videoHeight = parseInt(availableHeight / 4);
                videoWidth = parseInt(videoHeight * app.videoRatio);
            }

            return {
                width: videoWidth,
                height: videoHeight,
            };
        } else {
            videoWidth = availableWidth / 5;
            videoHeight = parseInt(videoWidth / app.videoRatio);
            if (videoHeight * 4 > availableHeight) {
                videoHeight = parseInt(availableHeight / 4);
                videoWidth = parseInt(videoHeight * app.videoRatio);
            }

            return {
                width: videoWidth,
                height: videoHeight,
            };
        }
    };

    focusVideo (participant, type = 'private', buttonPressed = true,silently=false) {//card 529
        var app = this;
        if(kinoParticipants.isInMySpace(participant)){
            return;
        }
        console.log(`Focus video participant=${participant},type=${type},buttonPress=${buttonPressed},silently=${silently}`);
        // if(buttonPressed){
        //     console.log("Can't focus, spaces still loading");
        //     return;
        // }
        let pRole = room.getParticipantById(participant).getProperty("role");
        let isMod = false;
        if(pRole == 'moderator' || pRole == 'host'){
            isMod = true;
        }
        console.log('pRole: ', pRole, ' isMod: ',!isMod)
        //lock focus
        if(lockFocus.isLocked() && buttonPressed && !permissions.hasSpacesLock()){
            lockFocus.showLockFocusNotification();
            if(app.videos[participant]){
                app.videos[participant].focusButton.removeClass('active');
                // app.videos[participant].focusButton.attr('title', 'Focus');
                // app.videos[participant].focusButton.attr('data-original-title', 'Focus');
            }
            return;
        }

        let DISPLAY_OPTION=false;
        let cid=false;
         /**Do conversation check */
        if(onStage.myStage.isStageView()){
            // app.stealFocus.sendReleaseFocusCommand();
            onStage.showLockOnStageActiveNotification();
            app.videos[participant].focusButton.removeClass('active');
            // app.videos[participant].focusButton.attr('title', 'Focus');
            // app.videos[participant].focusButton.attr('data-original-title', 'Focus');
            return;
        }else if(onStage.isActive()){
            onStage.showLockOnStageActiveNotification();
            app.videos[participant].focusButton.removeClass('active');
            // app.videos[participant].focusButton.attr('title', 'Focus');
            // app.videos[participant].focusButton.attr('data-original-title', 'Focus');
            return;
        }
        if(typeof CONV_STORAGE !== 'undefined' && type=='private'){
            cid=CONV_STORAGE.isOnConversation(participant);
            if(cid){
                if(CONV_STORAGE.myConversation > 0){
                    //both participants are on a conversation
                    if(cid != CONV_STORAGE.myConversation){
                        //participants are in different conversations
                        //option to leave conversation and focus on other conversation
                        DISPLAY_OPTION="JUMP_TO_OTHER_CONVO";
                    }else{
                        DISPLAY_OPTION="INVITE_OR_LEAVE";
                    }
                }else{
                    //I am not on a conversation
                    //show option to join this conversation
                    DISPLAY_OPTION="JOIN_CONVERSATION";
                }
            }else{
                //not in a conversation
                if(CONV_STORAGE.myConversation > 0){
                    //invite to join conversation or drop this conversation and focus on participant
                    DISPLAY_OPTION="JOIN_CONVERSATION";
                }else{
                    DISPLAY_OPTION="INVITE_TO_NEW_SPACE";
                }
            }
        }else if(type=="conversation"){
            cid=CONV_STORAGE.isOnConversation(participant);
            if(CONV_STORAGE.myConversation && cid && CONV_STORAGE.myConversation!=cid){
                console.error(`Focusing on a participant that is on a nother space from mine MINE:${CONV_STORAGE.myConversation} HIS: ${cid}`);
                if(app.videos[participant]){
                    app.videos[participant].focusButton.removeClass('active');
                    // app.videos[participant].focusButton.attr('title', 'Focus');
                    // app.videos[participant].focusButton.attr('data-original-title', 'Focus');
                }
                return;
            }
        }
        if(DISPLAY_OPTION){
            if(buttonPressed){
                if(app.videos[participant]){
                    app.videos[participant].focusButton.removeClass('active');
                    // app.videos[participant].focusButton.attr('title', 'Focus');
                    // app.videos[participant].focusButton.attr('data-original-title', 'Focus');
                }
            }
            //do stuf based on option
                CONV_STORAGE.showNotification(app.conversationIcon,DISPLAY_OPTION,{participant:participant,displayName:app.videos[participant].displayName,conversation_id:cid});
            //alert("Display this option to participant: "+DISPLAY_OPTION);
            return;
        }
        try {
            //fix clear invite unavailable to join when user focuses on me
            if(CONV_STORAGE.invitesTimeout[participant]!==undefined){
                clearTimeout(CONV_STORAGE.invitesTimeout[participant]);
              }
        } catch (error) {

        }
        /*
        * check if is a presenter view
         */
        if(app.presenter.isPresenterView && buttonPressed){
            app.presenter.removePresenter(true);
        }

        app.focused[participant] = true;
        $(`.${participant}-notification`).remove();
        $("#wave-"+participant).remove();
        if(!buttonPressed){
            if(app.videos[participant]){
                app.videos[participant].focusButton.addClass('active');
                // app.videos[participant].focusButton.attr('title', 'Unfocus');
                // app.videos[participant].focusButton.attr('data-original-title', 'Unfocus');
            }
        }

        if (Object.keys(app.focused).length == 1) {
            //card id 834 begin
            if(!app.isTileView){
                app.focusedView();
            }
            //card id 834 end
            app.enableToggle();
            //begin card 781
            let masterVolume=volumeManager.masterMuted ? 0 : volumeManager.muteVolumeOverwrite ? 0 : 0.05;
            volumeManager.lastMasterVolume=0.05;
            volumeManager.changeMasterVolume(masterVolume);
            volumeManager.stateChangedWhileMuted=true;//card 791
            //end card 781
        }
        app.moveVideoToMain(participant);
        app.isFocusedSafeView();
        app.isOnlyOne();
        app.resizeMainVideos();
        volumeManager.changeParticipantVolume(participant, 1);
        socket.sendFocusSignal(participant, type,silently);//card 529
         //release pull focus
        //  if(app.stealFocus.focusedOnMe){
        //     app.stealFocus.removeReleaseFocusButton();
        //     setTimeout(() => {
        //        app.stealFocus.setFocusedOnMe(false);
        //     }, 1000);
        // }
    };

    focusedMe(
        participant,
        autoFocus = false,
        silent = false,
        space_id= false
    ) {
        var app = this;
        app.sounds.play('focus3');
        $("#wave-"+participant).remove();
        try {
            //fix clear invite unavailable to join when user focuses on me
            if(CONV_STORAGE.invitesTimeout[participant]!==undefined){
                clearTimeout(CONV_STORAGE.invitesTimeout[participant]);
              }
        } catch (error) {

        }
        if (app.videos[participant] !== undefined) {
            app.videos[participant].focusOnMe = true;
            if (app.focused[participant] === undefined && app.isFocused) {
                app.videos[participant].viewContainer.prependTo(
                    app.sideVideosContainer
                );
            }

            app.videos[participant].focusButton.html(app.focusedIcon);

            app.videos[participant].viewContainer.addClass('focused-me');

            if (app.focused[participant] === undefined) {
                //show notification
                //app.showInVideoNotification(participant,"focusBack");
                if (autoFocus) {
                   //FIXED
                    let cid=false;
                    let myConversation=CONV_STORAGE.myConversation;

                    console.error(`Participant focused me : mySpace ${myConversation} , ${app.videos[participant].displayName} space ${cid} FROM space:${space_id}`);
                    if(myConversation){
                        CONV_STORAGE.leaveSpace().then(()=>{
                            $(`#focusBack-${participant}`).remove();
                            app.videos[participant].focusButton.addClass('active');
                            app.focusVideo(participant, 'autoFocusBack');
                        })
                    }else{
                        $(`#focusBack-${participant}`).remove();
                        app.videos[participant].focusButton.addClass('active');
                        app.focusVideo(participant, 'autoFocusBack');
                    }
                    // if((myConversation && cid && cid==myConversation) || (!myConversation && !cid) || (myConversation && !cid)){
                    //     $(`#focusBack-${participant}`).remove();
                    //     app.videos[participant].focusButton.addClass('active');
                    //     app.focusVideo(participant, 'autoFocusBack');

                    // }else{
                    //     app.videos[participant].focusButton.html(app.focusIcon);
                    //     app.videos[participant].viewContainer.removeClass('focused-me');
                    //     app.videos[participant].focusOnMe = false;
                    // }
                } else {
                    if (silent == false) {
                        app.showNotification(app.focusIcon, '', 'focusBack', participant);
                    }
                }
            }
        }
    };

    unFocusedMe(participant) {
        var app = this;
        if (app.videos[participant] !== undefined) {
            app.videos[participant].focusOnMe = false;
            app.videos[participant].viewContainer.removeClass('focused-me');
            app.videos[participant].focusButton.html(app.focusIcon);
            app.reArrangeSideVideos();
            let cid = CONV_STORAGE.isOnConversation(participant);
            // if(app.focused[participant] && CONV_STORAGE.myConversation != cid && app.stealFocus.participantFocused != participant){
            //     console.log("A participant froma diffrent space unfocused me");
            //     app.unFocusVideo(participant);
            // }
        }

        $("#wave-"+participant).remove();
        $("#focusBack-"+participant).remove();
    };

    unFocusVideo(participant,buttonPress=false,space_id='',silently=false) {
        var app = this;
        //lock focus
        if(lockFocus.isLocked() && buttonPress && !permissions.hasSpacesLock()){
            lockFocus.showLockFocusNotification();
            return;
        }
        if(onStage.isActive()){
            onStage.showLockOnStageActiveNotification();
            app.videos[participant].focusButton.addClass('active');
            return;
        }

        $("#focusBack-"+participant).remove();
        $(`.${participant}-notification`).remove();

        if(buttonPress && kinoParticipants.isInMySpace(participant)){
            // CONV_STORAGE.leaveSpace();
            CONV_STORAGE.showInviteOrLeave(participant);
            return
        }
        delete app.focused[participant];
        let pinnedConversation=false;
        if (Object.keys(app.focused).length == 0) {
            if(CONV_STORAGE.myConversation && CONV_STORAGE.conversations[CONV_STORAGE.myConversation]!==undefined && CONV_STORAGE.conversations[CONV_STORAGE.myConversation].conv_type=='pinned'){
                pinnedConversation=true;
                //card id 834 begin
                if(!app.isTileView){
                    app.moveVideoToSide(participant);
                }
                //card id 834 end
                if(!app.isLocalMaximized){
                    app.localVideoMaximize();
                }
            }else{
                app.enableLobbyView();
            }
        } else if (app.isFocused) {
            //app.videos[participant].viewContainer.prependTo(app.sideVideosContainer);
            //card id 834 begin
            if(!app.isTileView){
                app.moveVideoToSide(participant);
            }
            //card id 834 end
        }
        app.isFocusedSafeView();
        app.isOnlyOne();
        socket.sendUnFocusSignal(participant,buttonPress,space_id,silently);
        app.resizeMainVideos();
        //stop here if we are unfocusing a non existing participant
        if(!app.videos[participant]){
            return;
        }
        if(!buttonPress){//change focus button style
            app.videos[participant].focusButton.removeClass('active');
            // app.videos[participant].focusButton.attr('title', 'Focus');
            // app.videos[participant].focusButton.attr('data-original-title', 'Focus');
        }
        app.videos[participant].notificationBar.html('');

        volumeManager.onUnfocusVolume(participant);

    };

    reArrangeSideVideos() {
        var app = this;
        if (app.isFocused) {
            $.each(app.videos, function (i, video) {
                if (app.videos[i].focusOnMe == true && app.focused[i] === undefined && !kinoParticipants.isInMySpace(i)) {
                    app.videos[i].viewContainer.prependTo(app.sideVideosContainer);
                }
            });
        }
    };


    unFocusAll(exclude=[]){
        let app=this;
        $.each(app.focused, function (pid, focused) {
            if(!exclude.includes(pid)){
                app.videos[pid].focusButton.removeClass('active');
                // app.videos[pid].focusButton.attr('title', 'Focus');
                // app.videos[pid].focusButton.attr('data-original-title', 'Focus');
                app.unFocusVideo(pid);
            }
        });
    };


    connectionQuality(participant, stats) {

        var app = this;
        try {

        let quality = '';
        if (stats.connectionQuality <= 25) {
            quality = 'low';
        } else if (stats.connectionQuality > 25 && stats.connectionQuality <= 50) {
            quality = 'medium';
        } else if (stats.connectionQuality > 50 && stats.connectionQuality <= 75) {
            quality = 'high';
        } else if (stats.connectionQuality > 75) {
            quality = 'excellent';
        }


        if (participant == 'local') {
            // console.log("Local stats",stats)
            app.localVideo.nameContainer
                    .removeClass('low medium high excellent')
                    .addClass(quality);
                if(!app.localVideo.stats){
                    app.localVideo.stats={
                        quality:'excellent',
                        video:{
                            upload:0,
                            download:0
                        },
                        audio:{
                            upload:0,
                            download:0
                        },
                        resolution:'N/A',
                        region:'N/A',
                        server_count:"N/A",
                        framerate:"N/A"
                    }
                }

                app.localVideo.stats.quality=quality;
                app.localVideo.stats.video.upload=stats.bitrate.upload - stats.bitrate.audio.upload;
                app.localVideo.stats.video.download=stats.bitrate.video.download;
                app.localVideo.stats.audio.download=stats.bitrate.audio.download;
                app.localVideo.stats.audio.upload=stats.bitrate.audio.upload;
                app.localVideo.stats.region=stats.serverRegion;
                app.localVideo.stats.server_count=stats.bridgeCount;
                this.renderLocalStats();

            //update resolution and framerate
            try {
                const constraintStats=[];

                // console.log("Remote stats resolutions",stats.resolution)
                for (const pid in stats.resolution) {
                        const resolution = stats.resolution[pid];
                        constraintStats.push({
                            pid:pid,
                            resolutions:resolution,
                            framerate:null
                        })
                }

                for (const fpid in stats.framerate) {
                        const framerate = stats.framerate[fpid];
                        const exists=constraintStats.find(c=>c.pid===fpid);
                        if(exists){
                            exists.framerate=framerate;
                        }else{
                            constraintStats.push({
                                pid:fpid,
                                resolutions:null,
                                framerate:framerate
                            })
                        }
                }


                constraintStats.forEach(constraint => {
                    const isLocal = constraint.pid === room.myUserId();
                    const mainKinoTrack = isLocal ? getLocalMainKinoTrack() : getRemoteParticipantMainKinoTrack(constraint.pid);
                    const trackssrc= mainKinoTrack?.ssrc;

                    let render = false;
                    if(constraint.resolutions && trackssrc && constraint.resolutions[trackssrc]){
                        const res = constraint.resolutions[trackssrc];
                        if(isLocal){
                            app.localVideo.stats.resolution= res.width + "x" + res.height;
                            render = true
                        }else if(app.videos[constraint.pid]){
                            if(app.videos[constraint.pid].stats){
                                app.videos[constraint.pid].stats.resolution=res.width + "x" + res.height;
                                render = true
                            }
                        }
                    }
                    if(constraint.framerate && trackssrc && constraint.framerate[trackssrc]){
                        const frameR = constraint.framerate[trackssrc];
                        if(isLocal){
                            app.localVideo.stats.framerate=frameR;
                            render = true
                        }else if(app.videos[constraint.pid]){
                            if(app.videos[constraint.pid].stats){
                                app.videos[constraint.pid].stats.framerate=frameR;
                                render = true
                            }
                        }
                    }

                    if(render){
                        if(isLocal){
                            app.renderLocalStats();
                        }else if(app.videos[constraint.pid]){
                            app.renderStats(constraint.pid);
                        }
                    }

                });
            } catch (e) {
                console.error(e)
            }
        } else {

            if (app.videos[participant] !== undefined) {
                app.videos[participant].nameContainer
                    .removeClass('low medium high excellent')
                    .addClass(quality);
                if(!app.videos[participant].stats){
                    app.videos[participant].stats={
                        quality:'excellent',
                        video:{
                            upload:0,
                            download:0
                        },
                        audio:{
                            upload:0,
                            download:0
                        },
                        resolution:'N/A',
                        region:'N/A',
                        server_count:"N/A",
                        framerate:"N/A"
                    }
                }

                app.videos[participant].stats.quality=quality;
                app.videos[participant].stats.video.upload=stats.bitrate.upload - stats.bitrate.audio.upload;
                app.videos[participant].stats.video.download=stats.bitrate.video.download;
                app.videos[participant].stats.audio.download=stats.bitrate.audio.download;
                app.videos[participant].stats.audio.upload=stats.bitrate.audio.upload;
                app.videos[participant].stats.region=stats.serverRegion;
                this.renderStats(participant);
            }
        }
    } catch (error) {
           console.error(error)
    }
    };


    renderStats(id){
        try {
            // console.log("Render remote stats")
            const stats=this.videos[id].stats;
            let content=`
                    <div class="d-flex"><b>Connection: ${stats.quality}</b></div>
                    <div class="d-flex"><b>Video:</b> <i class="icofont-arrow-down icofont-1x"></i> ${stats.video.download} Kb/s <i class="icofont-arrow-up icofont-1x"></i> ${stats.video.upload} Kb/s</div>
                    <div class="d-flex"><b>Audio:</b> <i class="icofont-arrow-down icofont-1x"></i> ${stats.audio.download} Kb/s <i class="icofont-arrow-up icofont-1x"></i> ${stats.audio.upload} Kb/s</div>
                    <div class="d-flex"><b>Resolution:</b> ${stats.resolution}</div>
                    <div class="d-flex"><b>Frame Rate:</b> ${stats.framerate}</div>
                    <div class="d-flex"><b>Region:</b> ${stats.region}</div>
                    `;
            this.videos[id].nameContainer[0]._tippy.setContent(content);
        } catch (error) {
            console.error(error)
        }
    }
    renderLocalStats(){
        try {
            const stats=this.localVideo.stats;
            let content=`
                    <div class="d-flex"><b>Connection: ${stats.quality}</b></div>
                    <div class="d-flex"><b>Video:</b> <i class="icofont-arrow-down icofont-1x"></i> ${stats.video.download} Kb/s <i class="icofont-arrow-up icofont-1x"></i> ${stats.video.upload} Kb/s</div>
                    <div class="d-flex"><b>Audio:</b> <i class="icofont-arrow-down icofont-1x"></i> ${stats.audio.download} Kb/s <i class="icofont-arrow-up icofont-1x"></i> ${stats.audio.upload} Kb/s</div>
                    <div class="d-flex"><b>Resolution:</b> ${stats.resolution}</div>
                    <div class="d-flex"><b>Frame Rate:</b> ${stats.framerate}</div>
                    <div class="d-flex"><b>Server Count:</b> ${stats.server_count}</div>
                    <div class="d-flex"><b>Region:</b> ${stats.region}</div>
                    `;
            this.localVideo.nameContainer[0]._tippy.setContent(content);
        } catch (error) {
            console.error(error)
        }
    }
    /****
    Bandwidth Control
    *****/


    setQuality(maxReceiverHeight=720) {
        var app = this;

        if(!isJoined || !room.rtc._channel || !room.rtc._channel.isOpen()){
            return;
        }

        console.log("Called setQuality function *********************************************************");
        //return;
        let minHeight = 330;
        let selectLimit = 6;
        let resetSelected = true;
        let maxRes = maxReceiverHeight;
        let minRes = 360;
        let videosCount = Object.keys(app.videos).length;
        let focusedCount = CONV_STORAGE.myConversation ? kinoParticipants.inMySpace().length : Object.keys(app.focused).length;
        let focusedVideos= CONV_STORAGE.myConversation ? kinoParticipants.inMySpace() : Object.keys(app.focused);
        let participantsCount = Object.keys(app.mainParticipants).length;

        if(pictureInPicture.isPIP()){
            if(participantsCount >= 10){
                maxReceiverHeight=180;
                maxRes=180;
            }else{
                maxReceiverHeight=360;
                maxRes=360;
            }
        }
        if (participantsCount == 0) {
            try {
                app.setResolutionsConstraints([],[],minRes)
                room.setReceiverVideoConstraint('720');
            } catch (error) {
                console.error("Failed to set receiver video constraints",error);
            }

            return;
        }
        let videoHeight = app.remoteVideosContainer.find(".videoViewContainer:first").height();

        console.log("Participants: " + participantsCount + " videoHeight: " + videoHeight + ` TileView=${app.isTileView}, LobbyView=${app.isLobbyView}`);

        if (videoHeight > minHeight) {
            maxRes = maxReceiverHeight;
        } else if (videoHeight <= minHeight && videoHeight > 180) {
            maxRes = Math.min(360,maxReceiverHeight);
        } else if (maxRes <= 180) {
            maxRes = Math.min(360,maxReceiverHeight);;
        }
        if(room){
            try {
                room.setReceiverVideoConstraint(maxRes);
            } catch (error) {
                console.error("Failed to set receiver video constraints",error);
            }
        }


        try {

            if (participantsCount <= 2) {
                //room.selectParticipants(Object.keys(app.mainParticipants));
                app.setResolutionsConstraints(Object.keys(app.mainParticipants),[],maxRes)
                console.log("[setQuality] Selecting only 2 participants",Object.keys(app.mainParticipants));
                resetSelected = false;
                return;
            }

            if ((app.isTileView || app.isLobbyView) && focusedCount == 0) {
                //tile view
                if (participantsCount <= selectLimit && videoHeight >= minHeight) {
                    console.log("Tile view selecting " + participantsCount + " participants");
                    //room.selectParticipants(Object.keys(app.mainParticipants));
                    app.setResolutionsConstraints(Object.keys(app.mainParticipants),[],maxRes)
                    resetSelected = false;
                } else if (participantsCount > selectLimit && videoHeight >= minHeight) {
                    //check bandwidth of user
                    resetSelected = false;
                    app.setResolutionsConstraints([],[],maxRes,360);
                    console.log("Tile view res 360");
                } else if(videoHeight < minHeight && videoHeight > 180){
                    resetSelected = false;
                    app.setResolutionsConstraints([],[],maxRes,360);
                    console.log("Tile view res 360");
                } else {
                    resetSelected = false;
                    app.setResolutionsConstraints([],[],onStage.myStage.isStageView() ? 180 : maxRes,0);
                    console.log("Tile view res 180");
                }
            } else if ((app.isTileView || app.isLobbyView) && focusedCount > 0) {
                //tile view with focused
                if (participantsCount <= selectLimit && videoHeight >= minHeight) {
                    console.log("Tile view with focused participants selecting " + participantsCount + " focused participants");
                    //room.selectParticipants(Object.keys(app.mainParticipants));
                    app.setResolutionsConstraints(Object.keys(app.mainParticipants),[],maxRes)
                    resetSelected = false;
                } else if(videoHeight < minHeight && videoHeight > 180){
                    resetSelected = false;
                    app.setResolutionsConstraints([],[],maxRes,360);
                    console.log("Tile view with focused res 360");
                } else {
                    resetSelected = false;
                    app.setResolutionsConstraints([],[],onStage.myStage.isStageView() ? 180 : maxRes,0);
                    console.log("Tile view with focused res 180");
                }

            } else {
                //focused view
                if (focusedCount <= selectLimit && videoHeight >= minHeight) {
                    console.log("Focused view selecting " + focusedCount + " focused participants");
                    //room.selectParticipants(Object.keys(app.focused));
                    app.setResolutionsConstraints(focusedVideos,[],maxRes)
                    resetSelected = false;
                } else if (focusedCount > selectLimit && videoHeight >= minHeight) {
                    //check bandwidth of user
                    app.setResolutionsConstraints([],[],maxRes)
                    resetSelected = false;
                }
            }
            if (resetSelected) {
                // if (focusedCount > 0) {
                //     room.selectParticipant("");
                // } else {
                //     room.selectParticipant("");
                // }
                app.setResolutionsConstraints([],[],minRes)
            }
        } catch (e) {
            console.error("[setQuality] Error happend while setting quality:" + e.message);

        }

    };

    setResolutionsConstraints(selected=[],stage=[],maxRes=720,def=0){
        try {
            let minRes=Math.min(360,maxRes);
            let presenter=false;
            let participantsCount = Object.keys(this.mainParticipants).length;
            if((pictureInPicture.isPIP() && participantsCount >= 10 )
            || (onStage.isActive() && !onStage.myStage.isStageView())){
               minRes=180;
               def=180;
            }
            console.log(`Settign resolutions constraints minres=${minRes},default=${def}`);
            if(this.presenter.isPresenterView && this.presenter.getPresenterId()){
                presenter=this.presenter.getPresenterId();
                selected=[];
                stage=[presenter];
                console.log(`Presenter view is active setting only one participant on stage `,stage);
            }

            let constraints={
                      lastN: -1,
                      selectedSources: [],
                      onStageSources: stage,
                      defaultConstraints: { maxHeight: def },
                      constraints: {}
            };
            let inSpacesView=[];
            if(spacesView.isOpen()){
                inSpacesView=[...new Set([...this.efss.visibleOnConversation,...this.efss.visibleOnLobby])];
            }

            let inScreenSharePopup=[];
            if(screenShare.popup.isOpen()){
                inScreenSharePopup=screenShare.popup.visibleVideos;
            }
            let notSelected=Object.keys(this.videos).filter(id=>!selected.includes(id));
            notSelected.map(id=>{
                 constraints.constraints[id]=inSpacesView.includes(id) ||  inScreenSharePopup.includes(id) ? {maxHeight: 180}  : {maxHeight:def == 0 ? minRes : def};
            });
            selected.map(id=>{
                constraints.constraints[id]={maxHeight:maxRes};
            });
            stage.map(id=>{
                constraints.constraints[id]={maxHeight: id == presenter ? 720 :maxRes};
            });

            // console.error("setting_constrains",constraints);
            // if(this.isConstraintsChanged(constraints)){
            //     console.log("Constraints changed",true)
                //room.selectParticipants(selected);
                // room.setReceiverConstraints(constraints);
            // }
        } catch (error) {
            console.log(error);
        }
    };
    isConstraintsChanged(newConstraints){
        try {
            let oldConstraints=room.rtc._receiverVideoConstraints;
            if(oldConstraints.selectedEndpoints.toString() != newConstraints.selectedEndpoints.toString()){
                return true;
            }
            if(oldConstraints.onStageEndpoints.toString() != newConstraints.onStageEndpoints.toString()){
                return true;
            }
            if(!oldConstraints.defaultConstraints && newConstraints.defaultConstraints){
                return true;
            }
            if(oldConstraints.defaultConstraints && oldConstraints.defaultConstraints.maxHeight != newConstraints.defaultConstraints.maxHeight){
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }
    async addModerator(room_id, participant, user_id = 0, guest_id = '') {
        var app = this;
        try {
            axios.post(convertPath('/moderator/add'),{
                room_id: room_id,
                participant_id: participant,
                user_id: user_id,
                guest_id: guest_id,
                moderator_id: room.myUserId()
            }, await electronConfig()).then((response) => {
                // console.log(response.data);
                $.showNotification({
                    body: response.data.message,
                    type: "white",
                    duration: 3000
                });
            }, (error) => {
                console.error(error);
            });
        } catch (e) {
            console.log(e.message);
        }

    };

    async removeModerator(room_id, participant, user_id = 0, guest_id = '', silent = false) {
        var app = this;
        try {
            axios.post(convertPath('/moderator/delete'),{
                room_id: room_id,
                participant_id: participant,
                user_id: user_id,
                guest_id: guest_id
            }, await electronConfig()).then((response) => {
                if(silent){
                    return;
                }
                $.showNotification({
                    body: response.data.message,
                    type: "white",
                    duration: 3000
                });
            }, (error) => {
                console.error(error);
            });
        } catch (e) {
            console.log(e.message);
        }
    };

     disconnected(participant, delay = 10000) {
        let app = this;
        if (app.videos[participant]) {
            app.informativeOverlayParticipant(participant);
            console.log(`[${app.videos[participant]?.displayName}] ${participant} has been disconnected, video will be removed after ${delay} miliseconds`);
            app.videos[participant].disconnectTimer = setTimeout(function () {
                if(!app.videos[participant]){return}
                console.log(`[${app.videos[participant]?.displayName}] ${participant} remove video ${delay} miliseconds`);
                let roomParticipant=room.getParticipantById(participant);
                if(!roomParticipant){
                    app.removeVideo(participant);
                }else{
                    let tracks=roomParticipant.getTracks();
                    if(tracks.length==0){
                        app.removeVideo(participant);
                    }else{
                        socket.sendConfirmConnected(participant);
                        console.log(`[${app.videos[participant].displayName}] has ${tracks.length} streams,skiping tile remove`);
                    }
                }

            }, delay);
        }
    };

    reconnected(participant) {
        let app = this;
        // animatedLayers.removeLocalConnectionLostLayer();
        if (app.videos[participant]) {
            app.removeInformativeLayer(participant);
            console.log(`${participant} has been reconnected clearing timeout`);
            clearTimeout(app.videos[participant].disconnectTimer);
        }else if(participant != room.myUserId()){
            //user reconnected after video removed
            socket.sendYouAreGhost(participant);
        }
    };


    enableLobbyView(){
        var app=this;
        if((CONV_STORAGE !== undefined && CONV_STORAGE.myConversation) || Object.keys(app.focused).length > 0){return}
        app.isLobbyView=true;
        app.isFocused=false;
        app.isTileView=false;
        console.warn("Enabling lobby view");
        if(Object.keys(app.sideParticipants).length > 0){
            app.showSideVideos();
        }
        if(app.presenter.isPresenterView){
            app.presenter.removePresenter(true);
        }
        app.moveNonConversationsToMain();
        app.moveConversationsToSide();
        app.aloneInLobby(true);
        app.isOnlyOne();
        app.isFocusedSafeView();
        app.resizeMainVideos();
        // app.toggleTileView.attr('title' , 'Tile view');
        // app.toggleTileView.attr('data-original-title' , 'Tile view');
        // app.toggleTileView.html(this.tileViewIcon);
    };

    disableLobbyView(){
        var app=this;
        app.isLobbyView=false;
        if(CONV_STORAGE.myConversation){return}
        app.moveAllToMain();
        app.isOnlyOne();
        app.isFocusedSafeView();
        app.resizeMainVideos();
        // app.toggleTileView.attr('title' , 'Tile view');
        // app.toggleTileView.attr('data-original-title' , 'Tile view');
    };

moveConversationsToSide(){
    var app=this;
    if(CONV_STORAGE===undefined){return}
    for (const [cid, space] of Object.entries(CONV_STORAGE.conversations)) {
        if(CONV_STORAGE.myConversation==cid){return}
        space.participants.forEach(pid=>{
            if(pid !== room.myUserId()){
                app.moveVideoToSide(pid);
            }
        });
    }

};

    moveNonConversationsToMain(){
        var app=this;
        app.moveAllToMain(true);
    };

    removeParticipantFromLobby(participant){
        var app=this;
        if(!app.sideVideosShown){
            app.showSideVideos();
        }
        app.moveVideoToSide(participant);
        app.aloneInLobby();
        app.isOnlyOne();
        app.isFocusedSafeView();
        app.resizeMainVideos();
    };

    addParticipantToLobby(participant){
        var app=this;
        app.moveVideoToMain(participant);
        if(app.sideVideosContainer.find('.videoViewContainer').length == 0){
            app.hideSideVideos();
        }
        app.isOnlyOne();
        app.isFocusedSafeView();
        app.resizeMainVideos();
    };

    aloneInLobby(maximize=false){
        var app=this;
        if(Object.keys(app.mainParticipants).length==0 || maximize){
            if(!app.isLocalMaximized){
                app.localVideo.minimize.attr('title', 'Minimize');
                app.localVideo.minimize.attr('data-original-title', 'Minimize');
                // app.localVideo.minimize.tooltip('hide');
                app.localVideoMaximize();
            }
        }
    };
    moveSideVideoToTop (participant) {
        var app = this;
            if (app.videos[participant]) {
                app.videos[participant].viewContainer.prependTo(app.sideVideosContainer);
            }
            try{
                setTimeout(() => {
                    app.efss.isInViewPort(app.videos[participant].viewContainer,$('#sideVideosContainer'),participant);
                }, 50);
            }catch(err){
                console.error(err);
            }
    };

    removeFocusedMeBorder(){
        var app=this;
        $.each(app.videos,function(participant){
                app.videos[participant].focusOnMe = false;
                app.videos[participant].viewContainer.removeClass('focused-me');
                app.videos[participant].focusButton.html(app.focusIcon);
        });
    };
    connectionLost(){
        var app=this;
        app.isDisconnected=true;
        if(CONV_STORAGE.myConversation){
            CONV_STORAGE.storeLastSpaceId(CONV_STORAGE.myConversation,CONV_STORAGE.isPrivate(CONV_STORAGE.myConversation));
        }
        // if(CONV_STORAGE.myConversation){
        //     CONV_STORAGE.storeCurrentState();
        //     CONV_STORAGE.leave();
        // }
        // app.removeFocusedMeBorder();
        animatedLayers.reconnectingOverlay();
    };
    onReconnectUpdate(response){
        var app=this;
        if(response.data.participants.length){
            $.each(app.videos,function(participant){
                if(!response.data.participants.includes(participant)){
                    app.disconnected(participant,12000);
                }else if(response.data.participants.includes(participant)){
                    if(app.videos[participant].disconnectTimer){
                        app.reconnected(participant);
                    }
                }
            });
        }
    };
    /**
     * get participant right stream
     */
    //begin card 584
    getParticipantVideo(pid){
        return getRemoteParticipantMainKinoTrack(pid);
    };
    //end card 584
    /**
     * moderator function to update the user if moderator or not uppon refresh
     */
    userJoined(request) {
        var app = this;
        let data = request.data;
        if (data.role == "moderator") {
            // if (!MODERATORS.includes(data.participant)) {
            //     MODERATORS.push(data.participant);
            //     if (app.videos[data.participant]) {
            //         app.videos[data.participant].makeModerator.find(".make-moderator").addClass("enabled");
            //         app.videos[data.participant].isModerator = true;
            //     }
            // }
            if (app.videos[data.participant]) {
                console.log("User join request after object creation");
            } else {
                if (room.myUserId() != data.participant){
                    app.addVideo(data.participant, data.displayName);
                }
            }
        }
        onStage.renderOnstageButtons();
    }

    informativeOverlayParticipant(id, message='Connection lost, trying to reconnect...'){
        var app = this

        // console.trace('TRACING INFORMATIVE');
        app.removeInformativeLayer(id);

        let reconnectingAnimation = $('<div/>',{
            id: 'reconnectingAnimationParticipant',
            html: [app.reconnectionIconParticipant]
        });

        let reconnectionText = $('<div/>',{
            class:'text-center',
            id: 'reconnectionTextParticipant',
            html: message,
        });

        let reconnectionInnerCont = $('<div/>',{
            id: 'reconnectionInnerContParticipant',
            html: [reconnectingAnimation, reconnectionText],
        });

        app.videos[id].reconnectionOverlay = $('<div/>',{
            id: 'reconnectionOverlayParticipant',
            html: reconnectionInnerCont,
        });

        app.videos[id].viewContainer.append(app.videos[id].reconnectionOverlay);
    }

    updateOverlayText(pid,message){
        try {
            if(this.videos[pid] && this.videos[pid].reconnectionOverlay){
                this.videos[pid].reconnectionOverlay.find("#reconnectionTextParticipant").html(message);
            }
        } catch (error) {

        }
    }

    removeInformativeLayer(id){
        let app = this;
        // console.error("DEBUG: " , app.videos[id]);
        if(app.videos[id].reconnectionOverlay){
            app.videos[id].reconnectionOverlay.remove();
            app.videos[id].reconnectionOverlay=null;
        }
    };

    hideMessageFromTile(participantId) {
        clearTimeout(this.chatMessageReceivedTimeout[participantId])
        clearTimeout(this.chatMessageReceivedShowItemsTimeout[participantId])
        clearTimeout(this.chatMessageReceivedCloseItemsTimeout[participantId])
        $(`#${participantId}`).removeClass('message-req')
        $(`#${participantId} .chatBubblesMessageContainer`).removeClass('showChatMessageContainer');
        this.chatMessageReceivedCloseItemsTimeout[participantId] = setTimeout(() => {
            $(`#${participantId}`).removeClass('message-shown')
        }, 500);
    }

    chatBubblesAtTiles(group_name, id, msgText, images, msgNumber, chatId){
        let app = this;

        let closeChatMessageBtn = $('<span/>', {
            class: 'close-chat-btn',
            html: '<i class="fas fa-times"></i>'
        }).on('click', e => {
            e.stopPropagation();
            this.hideMessageFromTile(id)
        })

        let messageText = $('<div/>',{
            class: 'chatBubbleText',
            html: images.length ? 'Sent an Image' : msgText
        }).on('click',function(){
            console.log(click)
        });

        let sender = $('<div />', {
            class: 'sender',
            html: group_name
        })

        let messageContainer = $('<div />', {
            class: 'box-message-container',
            html: [messageText, closeChatMessageBtn]
        })

        if(msgNumber != 0 && app.videos[id].messageContainer){
            app.videos[id].messageContainer.html([sender, messageContainer]);
            app.videos[id].messageNotificationNumber.html(msgNumber);
            app.videos[id].messageIcon.attr('data-chat-id', chatId);
        }

        //card id 751
        //   console.log(app.sideVideosContainer.find('.videoViewContainer').length);
        if(app.sideParticipants[id] && !app.focused[id]){
            app.moveSideVideoToTop(id);
        }
        //card id 751 end

    };

    chatMessageReceived(message){
        console.error(message)
        let t = null ;
        let app = this;
        clearTimeout(t);
        app.chatBubblesAtTiles(message.group_name, message.participant_id, message.message, message.images, message.groupNotifications, message.group_id);

        if(message.groupNotifications != 0){
            $(`#${message.participant_id}`).addClass('message-shown')
            clearTimeout(this.chatMessageReceivedTimeout[message.participant_id])
            clearTimeout(this.chatMessageReceivedShowItemsTimeout[message.participant_id])
            clearTimeout(this.chatMessageReceivedCloseItemsTimeout[message.participant_id])
            this.chatMessageReceivedTimeout[message.participant_id] = setTimeout(()=>{
                $(`#${message.participant_id}`).addClass('message-req')
                // begin card 777
                console.log("Live streaming is",live_stream.streamingStatus);
                if(!localRecording.isRecording && live_stream.streamingStatus != "streaming") {
                    $(`#${message.participant_id} .chatBubblesMessageContainer`).addClass('showChatMessageContainer');
                }
                $(`#${message.participant_id} .chatBubbleContainer .chatBubbleMessageIcon`).addClass('forceChatBubble');
                // end card 777
                this.chatMessageReceivedShowItemsTimeout[message.participant_id] = setTimeout(()=>{
                    $(`#${message.participant_id}`).removeClass('message-req')
                    $(`#${message.participant_id} .chatBubblesMessageContainer`).removeClass('showChatMessageContainer');
                    $(`#${message.participant_id} .chatBubbleContainer .chatBubbleMessageIcon`).removeClass('forceChatBubble');

                },10000)
                this.chatMessageReceivedCloseItemsTimeout[message.participant_id] = setTimeout(() => {
                    $(`#${message.participant_id}`).removeClass('message-shown')
                }, 10200);
            }, 1000);
        }
    };

    disableModeratorIcon(button){
        button.addClass('button-disabled');
        setTimeout(() => {
            button.removeClass('button-disabled');
        }, 3100);
    };

    disablePrivacyModeSwitch(){
        $('#privacyModeBtn').attr({
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            'data-original-title': 'Turn on your camera to change this switch'
        });
        $('#privacyModeBtn').addClass('button-disabled');
        $('#privacy-mode-checkbox').prop("disabled", true);
    }

    enablePrivacyModeSwitch(){
        $('#privacyModeBtn').removeAttr('data-toggle data-placement data-original-title');
        $('#privacyModeBtn').removeClass('button-disabled');
        $('#privacy-mode-checkbox').prop("disabled", false);
    }

    checkForGhosts(){
        // let app=this;
        // try {
        //     //console.log("checking ghost");
        //     room.getParticipants().map(participant=>{
        //         if(!app.videos[participant.getId()] && participant._tracks.length>0){
        //             axios.post(convertPath('/kino/is-connected'),{
        //                 room_id:room.getName(),
        //                 participant:participant.getId()
        //             }).then(res=>{
        //                 if(res.data.connected){
        //                     socket.sendYouAreGhost(participant.getId());
        //                 }
        //                 //console.log("is connected response",res.data);
        //             }).catch(e=>{
        //                 //console.error("is connected check error",e);
        //             });
        //         }
        //     });
        // } catch (error) {
        //     //console.error("check ghost participants",error);
        // }
        // app.ghostCheckTimeout=setTimeout(() => {
        //     app.checkForGhosts();
        // }, 10000);
    };

    userRoleChanged(id,role){
        let app = this;
        // console.error('ID: ',id,', ROLE: ',role)
        try {
            const p = kinoParticipants.get(id);
            p.setRole(role);
            if(app.videos[id]){
                if((role=="host" || role=="moderator") && !permissions.isWorkspace){
                    app.videos[id].moderatorBadge.removeClass('d-none')
                    .attr({'data-original-title': `${role=="host" ? "Host" : "Moderator"}`});
                    app.videos[id].isModerator = true;
                }else{
                    app.videos[id].moderatorBadge.addClass("d-none").attr({'data-original-title': ''});
                    app.videos[id].isModerator = false;
                }
            }
            if(role == 'host'){
                app.videos[id].host=true;
            }
        } catch (error) {
            console.warn("Moderator icon not updated",error);
        }
    };

    userEmailChanged(id,email){
        let app = this;
        // console.error('ID: ',id,', ROLE: ',role)
        try {
            const p = kinoParticipants.get(id);
            p.setEmail(email);
        } catch (error) {
            console.warn("Moderator icon not updated",error);
        }
    };

    animateSliderForAll(show=false ){
        let app = this;
        if(show){
            Object.keys(app.videos).map(id => {
                if(!app.videos[id].viewContainer.hasClass('focused-me')){
                    // console.error(app.videos[id]);
                    app.videos[id].viewContainer.addClass('video-hover');
                    app.videos[id].viewContainer.find('.audioVal').addClass('animate-sliders-numbers');
                    if(app.videos[id].audios.slider){
                        app.videos[id].audios.slider.addClass('animate-sliders');
                    }
                }
            })
        }else{
            Object.keys(app.videos).map(id => {
                app.videos[id].viewContainer.find('.audioVal').removeClass('animate-sliders-numbers');
                app.videos[id].viewContainer.removeClass('video-hover');
                if(app.videos[id].audios.slider){
                    app.videos[id].audios.slider.removeClass('animate-sliders');
                }
            })
        }
    }

    clearDeadFocused(){
        //this function checks focused object for users that arleady left kino and removes them from focused
        let ids=[];
        Object.keys(this.focused).forEach(id=>{
            if(!this.videos[id]){
                ids.push(id);
            }
        });
        //ids to delete
        ids.forEach(id=>{
            delete this.focused[id];
        });
    };

    renderParticipantToList(id, skip=false){
        let app = this;

        if(!skip){
            app.participantCount++;
            $("#numberOfParticipants").html(kinoParticipants.count());
            if(kinoParticipants.count() == 1){
                $("#numberOfParticipantsText").html('Participant');
            } else {
                $("#numberOfParticipantsText").html('Participants');
            }
        }
        let p = kinoParticipants.get(id);
        let participantIcon = $('<span/>',{
            class: 'participants-icon',
            html: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 13C6 13 3 18 3 18C3 18 6 22 12 22C18 22 21 18 21 18C21 18 18 13 12 13Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 6.44444C16.5 8.9 14.4855 10.8889 12 10.8889C9.5145 10.8889 7.5 8.9 7.5 6.44444C7.5 3.98889 9.5145 2 12 2C14.4847 2 16.5 3.98963 16.5 6.44444Z" fill="white"></path></svg>`,
        });
        let participantName = $('<div/>',{
            class: 'participants-user',
            html: [participantIcon, p.local ? p.getName() + ' (me)': p.getName() ]
        }).on('click', function(){
            participantAction.trigger('click');
        });
        let participantAction = $('<div/>',{
            class: 'participants-action',
            html: app.locateIcon
        }).on('click', function(){
            hideSideMenu();
            app.scrollAndAnimateToSelectedUser(id);
        })//.tooltip();
        let participantActionContainer = $('<div/>',{
            class: 'participants-action-container',
            title:'Locate',
            'data-toggle':"tooltip",
            'data-placement':"bottom",
            html: participantAction
        });
        let participants = $('<div/>',{
            class: 'participants-container',
            id: `participant-list-${id}`,
            html: [participantName, participantActionContainer]
        });

        app.participantsListMenu.append(participants);
    }

    renderNoMatchesFound(){
        let app = this;

        let container = $('<div/>', {
            class: 'participants-no-matches-found',
            html: 'No matches found'
        })
        app.participantsListMenu.append(container);
    }

    removeParticipantFromList(id){
        let app = this;
        app.participantsListMenu.find(`#participant-list-${id}`).remove();
        app.participantCount--;
        $("#numberOfParticipants").html(kinoParticipants.count());
        if(kinoParticipants.count() == 1){
            $("#numberOfParticipantsText").html('Participant');
        } else {
            $("#numberOfParticipantsText").html('Participants');
        }
    }

    scrollAndAnimateToSelectedUser(id){
        let app = this;
        if(spacesView.isOpen()){
            spacesView.hideSpaceView();
        }
        if(app.videos[id] && app.videos[id].viewContainer){
            app.videos[id].viewContainer.addClass('locate').removeClass('transparent');
            $('#'+ id)[0].scrollIntoView({
                behavior: "smooth",
                block: 'nearest',
            });
        }else if(id == room.myUserId()){
            app.localVideo.viewContainer.addClass('locate').removeClass('transparent');
            $('#localParticipant')[0].scrollIntoView({
                behavior: "smooth",
                block: 'nearest',
            });
        }
        app.isParticipantLocationActive = true;
        clearTimeout(app.animationPerLocatedUser);
        Object.keys(app.videos).map(participant => {
            if(participant != id){
                if(app.videos[participant] && app.videos[participant].viewContainer){
                    app.videos[participant].viewContainer.addClass('transparent').removeClass('locate')
                }
            }
        })
        if(app.localVideo && app.localVideo.viewContainer && id!=room.myUserId()){
            app.localVideo.viewContainer.addClass('transparent')
        }

        app.animationPerLocatedUser = setTimeout(() => {
            if(app.videos[id] && app.videos[id].viewContainer){
                app.videos[id].viewContainer.removeClass('locate');
            }
            app.localVideo.viewContainer.removeClass('locate')
            Object.keys(app.videos).map(participant => {
                if(participant != id){
                    if(app.videos[participant] && app.videos[participant].viewContainer){
                        app.videos[participant].viewContainer.removeClass('transparent')
                    }
                }
            })
            if(app.localVideo && app.localVideo.viewContainer){
                app.localVideo.viewContainer.removeClass('transparent')
            }
            app.isParticipantLocationActive = false;
        }, 5000);
    }

    searchParticipant(input){
        let app = this;
        let userName = input.toLowerCase();
        app.participantsListMenu.html('');
        let participantLength = 0;
        let participants=kinoParticipants.getParticipants();
        participants.sort((a, b) => {
            let fa = a.getName().toLowerCase(),
                fb = b.getName().toLowerCase();

            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;
        });
        participants.forEach(participant =>{
            if(participant.getName().toLowerCase().indexOf(userName) > -1){
                participantLength ++;
                app.renderParticipantToList(participant.id, true);
            }else if(!userName || userName == ''){
                app.renderParticipantToList(participant.id, true);
            }
        })
        if(participantLength == 0){
            console.error("Kino participant not found");
            app.renderNoMatchesFound();
        }
    }
};
